(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/6/14
 * License: All rights reserved.
 * Copyright: 2014 Puritan Reformed Theological Seminary
 */

// Get metadata useful for content.

var /*data, status, headers, config*/_arguments = arguments;
var articlesOutline = require('./components/res/articles-outline');

// Module-level constants.
var sbRoot = '/rhkjvsb';

// 'Paths' to templates, so they do not have to be hard coded into the index.
// Note that these are actually paths to the templates loaded into the template
// cache via building each of them into `templates.build.js`. The templates are
// compiled via the `angular-cache` Gulp task. Partials, by contrast, are *not*
// compiled into the templates. They can be loaded dynamically, with
// server-side caching for load time issues.
var templates = {
  bible: 'main/bible.html',
  nav: 'navigation/navigation.html',
  settings: 'settings/settings.html',
  svg: 'res/svg-defs.svg',
  welcome: 'main/welcome.html'
};

// Define user roles
var ACCESS = {
  any: '*',
  user: 'user',
  kjvsb: 'kjvsb'
};

// Define the standard Bible URL.
var BIBLE_RE = /^\/[A-z0-9]{3}\.\d+\.\d+/;

function _sameBook(prev, curr) {
  return prev.split('.')[0] === curr.split('.')[0];
}

var justData = function justData(data /*, status, headers, config*/) {
  return data;
};
var allArgs = function allArgs() {
  return _arguments;
};

/**
  Define a resolve function to use in getting the book in a route.
  @param $http Angular HTTP request service.
  @param $q Angular promise service.
  @param $route Angular "current" route data.
  @param $routeParams Angular future route data.
  @returns {$q.promise} A promise which resolves as the content of the book
      requested or `null`.
 */
function passageResolver($http, $q, $route, $routeParams) {
  var url = $route.current.params.passage;
  var prev = $routeParams.passage !== void 0 ? $routeParams.passage : '';

  // Check whether to load a new book or simply let the view navigate within
  // the book.
  return _sameBook(prev, url) ? $q.resolve(null) : $http.get('b/' + url);
}

function makeQueryParams(keyName) {
  return function queryParams($location) {
    return $location.search()[keyName];
  };
}

/**
  Define a resolve function to use in getting the notes associated with a book.
  @param $http Angular HTTP request service.
  @param $q Angular promise service.
  @param $route Angular "current" route data.
  @param $routeParams Angular future route data.
  @returns {$q.promise} A promise which resolves as the book's associated notes
      or `null` if the book has not changed.
 */
function notesResolver($http, $q, $route, $routeParams) {
  var url = $route.current.params.passage;
  var prev = angular.isDefined($routeParams.passage) ? $routeParams.passage : '';

  var resUrl = '/res' + sbRoot;
  var book = url.split('.')[0];
  var bookNotes = resUrl + '/' + book + '.json';

  if (_sameBook(prev, url)) {
    return $q.defer().resolve(null).promise;
  } else {
    return $http.get(bookNotes).then(justData).catch(allArgs);
  }
}

/**
  Construct a function to resolve the data access list.
  @param accessList
  @returns {Function}
 */
function requiredAccess(accessList) {
  if (!angular.isArray(accessList)) {
    accessList = [accessList];
  }
  return function () {
    return accessList;
  };
}

/**
  A not-very-good (but good enough for our purposes) title-caser.
  @param {string} text The text to title-case.
  @return {string} The title-cased text.
 */
function titleCase(text) {
  text = text.replace(/(\w)-(\w)/g, '$1 $2');
  text = text.replace(/\w+/, function (subtext) {
    return subtext.charAt(0).toUpperCase() + subtext.substr(1);
  });

  return text;
}

function pageTitle($route, locationMeta, titleOverride) {
  var title = 'HolyBible.com';

  if (titleOverride) {
    title = titleOverride;
  } else if (!!$route && !!$route.current.params.page) {
    title = $route.current.params.page;
    title = titleCase(title);
  }

  if (title) {
    locationMeta.setPage({ title: title });
  }
  return title;
}

function studyBibleTitle($route, locationMeta) {
  var articles = articlesOutline.byUrl;

  var params = $route.current.params ? $route.current.params : null;
  var section = !!params && !!params.section ? params.section : null;
  var article = !!params && params.article ? params.article : null;

  var path = void 0;
  if (article) {
    path = sbRoot + '/' + article;
  } else if (section) {
    path = sbRoot + '/' + section;
  }

  // Set the content title from the outline if it is available; otherwise,
  // provide a reasonable fallback.
  var contentTitle = articles[path].title ? articles[path].title : 'RHKJVSB';
  return pageTitle($route, locationMeta, contentTitle + ' \u2013 HolyBible.com');
}

/**
  Return a function that calls pageTitle with a titleOverride value.
  @param  {string} override The override title to use with pageTitle.
  @return {function} A function taking `$route` and `hbLocationMetadata` types
                     as arguments.
 */
function overrideTitleFactory(override) {
  return function ($route, locationMeta) {
    return pageTitle($route, locationMeta, override);
  };
}

// Routing configurator to use with the `angular.module.config()` method.
function configure($locationProvider, $routeProvider, ACCESS) {
  // Set up route bindings. Start with the `/pages` routes.
  $routeProvider.when('/pages/rhkjvsb-info', {
    reloadOnSearch: false,
    resolve: {
      metaTitle: ['$route', 'hbLocationMetadata', overrideTitleFactory('Reformation Heritage KJV Study Bible Info')],
      requiredAccess: requiredAccess([ACCESS.user])
    },
    templateUrl: function templateUrl() /*params*/{
      return '/partials/pages/rhkjvsb-info';
    }
  }).when('/pages/:page', {
    controller: 'PageController',
    reloadOnSearch: false,
    resolve: {
      metaTitle: ['$route', 'hbLocationMetadata', pageTitle],
      requiredAccess: requiredAccess([ACCESS.any])
    },
    templateUrl: function templateUrl(params) {
      return '/partials/pages/' + params.page;
    }
  })

  // Handling for `/user` routes that do *not* need to be logged in. All user
  // routes use the `UsersController` by default; the templates may further
  // specify a controller.
  .when('/user/password-reset', {
    controller: 'UsersController',
    reloadOnSearch: false,
    resolve: {
      metaTitle: ['$route', 'hbLocationMetadata', overrideTitleFactory('Password Reset')],
      requiredAccess: requiredAccess([ACCESS.any])
    },
    templateUrl: '/partials/user/password-reset'
  }).when('/user/sign-in', {
    controller: 'UsersController',
    reloadOnSearch: false,
    resolve: {
      metaTitle: ['$route', 'hbLocationMetadata', overrideTitleFactory('Sign In')],
      requiredAccess: requiredAccess([ACCESS.any])
    },
    templateUrl: '/partials/user/sign-in'
  }).when('/user/confirm-username', {
    controller: 'ConfirmationController',
    reloadOnSearch: false,
    resolve: {
      metaTitle: ['$route', 'hbLocationMetadata', pageTitle],
      username: ['$location', makeQueryParams('username')],
      token: ['$location', makeQueryParams('token')],
      requiredAccess: requiredAccess([ACCESS.any])
    },
    templateUrl: '/partials/user/confirm-username'
  })

  // Handling for other `/user` routes, which *do* require authentication. The
  // controller must be specified by the partial.
  .when('/user/:page', {
    reloadOnSearch: false,
    resolve: {
      metaTitle: ['$route', 'hbLocationMetadata', pageTitle],
      requiredAccess: requiredAccess([ACCESS.user])
    },
    templateUrl: function templateUrl(params) {
      return '/partials/user/' + params.page;
    }
  })

  // Study Bible articles
  .when(sbRoot, {
    controller: 'StudyBibleController',
    reloadOnSearch: false,
    resolve: {
      metaTitle: ['$route', 'hbLocationMetadata', overrideTitleFactory('Reformation Heritage KJV Study Bible')],
      requiredAccess: requiredAccess([ACCESS.any])
    },
    templateUrl: '/partials' + sbRoot
  }).when(sbRoot + '/:section*', {
    controller: 'StudyBibleController',
    reloadOnSearch: false,
    resolve: {
      metaTitle: ['$route', 'hbLocationMetadata', studyBibleTitle],
      requiredAccess: requiredAccess([ACCESS.user, ACCESS.kjvsb])
    },
    templateUrl: function templateUrl(params) {
      var root = '/partials' + sbRoot;
      var path = root + '/' + params.section;
      return path;
    }
  })

  // Default handling at the root is for the Bible.
  .when('/:passage', {
    controller: 'BibleController',
    reloadOnSearch: false,
    resolve: {
      book: [
      // Inject dependencies. AngularJS:
      '$http', '$q', '$route', '$routeParams',
      // Supply the function.
      passageResolver],
      notes: [
      // Inject dependencies. AngularJS:
      '$http', '$q', '$route', '$routeParams',
      // Supply the function.
      notesResolver],
      requiredAccess: requiredAccess([ACCESS.any])
    },
    templateUrl: templates.bible
  })

  // In the general case, just redirect to Genesis 1:1
  .otherwise({
    redirectTo: 'gen.1.1',
    reloadOnSearch: false,
    resolve: {
      requiredAccess: requiredAccess([ACCESS.any])
    }
  });

  // Configure HTML5 linking.
  $locationProvider.html5Mode({ enabled: true, requireBase: false });
}

module.exports = { BIBLE_RE: BIBLE_RE, ACCESS: ACCESS, configure: configure, templates: templates };

},{"./components/res/articles-outline":15}],2:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/6/14
 * License: All rights reserved.
 * Copyright: 2014 Puritan Reformed Theological Seminary
 */

// Get dependencies for setting up the top-level Angular module.

var config = require('./app-config');

function runApp($http, $location, $rootScope, auth, messages, session) {
  // On startup, check whether the user is authorized on the back end. We
  // fully expect that the result may be negative.
  var ignoreErr = function ignoreErr() {};

  $http.get('/u/logged-in').then(function (data) {
    if (data.user) {
      var sessionData = {
        user: {
          name: data.user.username,
          confirmed: data.user.confirmed
        },
        access: ['user']
      };

      if (data.user.sb && data.user.sb.hasAccess) {
        sessionData.access.push('kjvsb');
      }

      session.set(sessionData);
    }
  }).catch(ignoreErr);

  function routeChangeHandler(event, next /*, current*/) {
    if (angular.isDefined(next.$$route) && !auth.isAuthorized(next.$$route.resolve.requiredAccess())) {

      // Never go to the relevant page if not authorized.
      event.preventDefault();

      // If the issue is one of authentication, redirect to the login page.
      if (!session.isAuthenticated()) {
        $location.path('/user/sign-in');
      } else {
        messages.unauthorized = 'Sorry, you are not authorized to view that content.';
      }
    }
  }

  var routeChangeWatch = $rootScope.$on('$routeChangeStart', routeChangeHandler);
  $rootScope.$on('$destroy', routeChangeWatch);
}

// Define the top-level module's dependencies and configure it.
angular.module('app', [
// Inject module dependencies. AngularJS:
'ngCookies', 'ngResource', 'ngRoute', 'ngOrderObjectBy',
// Third-party:
'cgBusy', 'duScroll',
// Project:
'hbBible', 'hbServices', 'hbUsers']).constant('ACCESS', config.ACCESS).config([
// Inject provider dependencies for the configuration function. AngularJS:
'$locationProvider', '$routeProvider',
// First-party
'ACCESS',
// Configure the module.
config.configure]).value('cgBusyDefaults', {
  message: 'Loading...',
  // backdrop: false,
  // templateUrl: 'my_custom_template.html',
  delay: 250,
  minDuration: 1500,
  wrapperClass: 'loading-template'
}).run([
// Inject dependencies. AngularJS:
'$http', '$location', '$rootScope',
// First-party
'hbAuth', 'hbMessages', 'hbSession',
// How to run the application.
runApp]);

/* Assemble the rest of the application. */
// Common helper functionality.
require('./directives');
require('./filters');
require('./services');
// Views
require('./components/templates.build');
// Controllers
require('./components/app-controller');
require('./components/main');
require('./components/users');
require('./components/navigation');
require('./components/settings');

},{"./app-config":1,"./components/app-controller":3,"./components/main":5,"./components/navigation":13,"./components/settings":18,"./components/templates.build":20,"./components/users":22,"./directives":28,"./filters":31,"./services":34}],3:[function(require,module,exports){
'use strict';

/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/6/14
 * License: All rights reserved.
 * Copyright: 2014 Puritan Reformed Theological Seminary
 */

var config = require('../app-config'),
    outline = require('./res/outline'),
    readingSettings = require('./res/reading-settings');

require('./users');

var _angular = angular,
    isUndefined = _angular.isUndefined;

// Define an Angular controller.
// TODO: Use dependency injection with services for some of these pieces.

function AppController($scope, $location, $log, $route, $window, auth, ACCESS) {
  $scope.$log = $log;

  // Base view data
  $scope.metaTitle = 'HolyBible.com';

  // Bind authorization control.
  $scope.isAuthorized = auth.isAuthorized;
  $scope.userAccess = ACCESS;

  // Set root classes for mobile web app support on iOS devices.
  $scope.mobileWebApp = $window.navigator.standalone !== void 0 && $window.navigator.standalone;
  $scope.mobileWebAppOffset = $scope.mobileWebApp ? 16 : 0;
  $scope.iOS = /i(Pod|Phone|Pad)/g.test($window.navigator.userAgent);

  $scope.templates = config.templates;

  // Outline of the Bible.
  $scope.outline = outline;

  // The current passage. This must be accessible from inheriting scopes
  // since both the navigation template and controller and the main view
  // depend on it.
  // TODO: use local storage and/or cookies to autoload previous passage.
  $scope.passage = {
    book: null,
    setBook: function setBook(newBook) {
      this.book = newBook;
    },


    /**
      Parse a string using normal Bible separation patterns.
       @param {string} passageString A string to parse as a passage.
      @returns {ParsedLocation}
     */
    parse: function parse(passageString) {
      var splitters = '[:\\s\\.\\+]'; // Space or punctuation
      var bookNumber = '(?:[1-3]\\s*)'; // Book numbers, like 1th or 1 Thess...
      var bookName = '[A-z]+(?:\\s+[A-z]+)*'; // Book names are one or more words.
      var chapterNumbers = '\\d{1,3}'; // Chapter and verse numbers <= 999.
      var verseNumbers = chapterNumbers;

      // Build a regex by joining the string components with no separator.
      var passageRe = new RegExp(['(', bookNumber, '?', bookName, ')', // Capture the book (including optional number).
      splitters, '?', // `jn 1` or `jn1` accepted; do not capture the splitters.
      '(?:', '(', chapterNumbers, ')', // Capture chapter number
      '(?:', splitters, '(', verseNumbers, ')', ')?', // capture verse number but not splitters
      ')?'].join(''));

      var components = passageString.match(passageRe);
      if (isUndefined(components[0]) || isUndefined(components[1])) {
        return null;
      }

      /**
        @typedef {object} ParsedLocation
        @property {string} book
        @property {string} chapter
        @property {string} verse
       */
      return {
        book: components[1],
        chapter: components[2] || '1',
        verse: components[3] || '1'
      };
    }
  };

  // Define the main view so it can be used for the Bible or standalone
  // articles.
  $scope.mainView = {
    // The view type is 'bible' by default; it may also be 'page'.
    type: 'bible',

    // The content defaults to the current passage. It may also be an article.
    content: null,

    /**
     * Set the content, either to the current passage book, or to the value
     * supplied.
     * @param {string} value Either `'bible'` or the desired content. If
     *     `'bible'`, the content will be set to `$scope.passage.book`.
     *     Otherwise, it will be set to the value supplied (presumably, HTML).
     */
    setContent: function setContent(value) {
      if (value === 'bible') {
        this.content = $scope.passage.book.content;
        this.type = value;
      } else {
        this.content = value;
        this.type = 'page';
      }
    }
  };

  // Define the reading settings. These must be accessible at lower scopes
  // (e.g for the main template and the settings template and controller).
  $scope.readingSettings = readingSettings;

  // Not all settings are popups; create a sub-list of those that are.
  $scope.readingPopupSettings = {};
  for (var key in $scope.readingSettings) {
    if ($scope.readingSettings[key].popup) {
      $scope.readingPopupSettings[key] = $scope.readingSettings[key];
    }
  }

  // Only track analytics on the main website, *not* on test sites.
  function trackPageViews() {
    if ($location.host().match(/holybible\.com/)) {
      $window.ga('send', 'pageview', { page: $location.url() });
    }
  }

  // Bind behavior to events.
  $scope.$on('$viewContentLoaded', trackPageViews);
  $scope.$on('$locationChangeSuccess', trackPageViews);

  $scope.$on('hbLocationMetadataUpdate', function (event, data) {
    $scope.metaTitle = data.meta.title;
  });
}

// Construct a controller for the application.
angular.module('app').controller('AppController', [
// Inject dependencies. Angular:
'$scope', '$location', '$log', '$route', '$window',
// First-party:
'hbAuth', 'ACCESS', //'hbRouteLogging',  // For debug only.
// Supply the controller.
AppController]);

},{"../app-config":1,"./res/outline":16,"./res/reading-settings":17,"./users":22}],4:[function(require,module,exports){
'use strict';

/**
  Author: Chris Krycho
  Contact: chris@krycho.com
  Date: 12/8/14
  License: All rights reserved.
  Copyright: 2014 Puritan Reformed Theological Seminary
 */

// Define requirements for Browserify.
require('../app-controller.js');
var articlesOutline = require('../res/articles-outline');

var SHOW_WELCOME = {
  key: 'SHOW_WELCOME',
  show: 'show',
  hide: 'hide'
};

// MUTATING $cookies -> 'show' | 'hide'
var setShowWelcome = function setShowWelcome($cookies, value) {
  if (![SHOW_WELCOME.show, SHOW_WELCOME.hide].includes(value)) {
    throw new Error('Wrong value supplied for setting showWelcome');
  }

  $cookies.put(SHOW_WELCOME.key, value);
};

// $cookies -> boolean
var showWelcome = function showWelcome($cookies) {
  switch ($cookies.get(SHOW_WELCOME.key)) {
    case SHOW_WELCOME.hide:
      return false;
    case SHOW_WELCOME.show:
      return true;
    default:
      return true;
  }
};

// MUTATING $cookies
var setupCookies = function setupCookies($cookies) {
  if (angular.isUndefined($cookies.get(SHOW_WELCOME.key))) {
    $cookies.put(SHOW_WELCOME.key, SHOW_WELCOME.show);
  }
};

// A controller for the Bible itself.
function BibleController($cookies, $scope, _ref, _ref2, auth, locationMeta) {
  var book = _ref.data;
  var notes = _ref2.data;

  // Make the related articles outline available.
  $scope.articlesOutline = articlesOutline.byLocation;
  $scope.passageInfo = locationMeta.get().passage.current;
  $scope.sbAccess = auth.isAuthorized('kjvsb') ? 'sb-access' : '';

  setupCookies($cookies);

  $scope.showWelcome = showWelcome($cookies);

  $scope.hideWelcome = function () {
    $scope.showWelcome = false;
    setShowWelcome($cookies, SHOW_WELCOME.hide);
  };

  // If the book is *not* null, the data is available and can be assigned to the
  // passage object. If it is null, no change is needed; new content was not
  // loaded.
  if (book !== null) {
    $scope.passage.setBook(book.content);
    $scope.prev = book.prev;
    $scope.next = book.next;

    // Set a visibility flag on each note item.
    $scope.textNotes = notes.map(function (n) {
      return angular.merge({}, n, { visible: false });
    });
  }
}

function BookContentController($document, $location, $scope, $timeout) {

  /**
    Maintain the basic scroll position even as the relative position of the
    element on the pages shifts due to changes in reading settings.
   */
  function keepScrollPosition() {
    // Wait for the digest cycle to finish and the browser to have fully
    // rendered the page.
    $timeout(function () {
      var offset = $scope.navOffset + $scope.mobileWebAppOffset;
      var delay = 0;
      var passage = $location.path().replace(/\./g, '-').replace(/^\//, '');
      var dEl = document.getElementById(passage);
      var ngEl = angular.element(dEl);

      $document.scrollToElement(ngEl, offset, delay);
    });
  }

  // Scroll to the chapter specified in the URL when toggling reading settings.
  $scope.$on('hbReadingSettingsChanged', keepScrollPosition);
}

// Construct a controller for cross-book behaviors.


// A controller for the internal content of Bible books.
angular.module('hbBible').controller('BibleController', [
// Inject dependencies. AngularJS:
'$cookies', '$scope',
// First-party:
'book', 'notes', 'hbAuth', 'hbLocationMetadata',
// Supply the controller function.
BibleController]).controller('BookContentController', [
// Inject dependencies. AngularJS:
'$document', '$location', '$scope', '$timeout',
// Supply the controller function.
BookContentController]);

},{"../app-controller.js":3,"../res/articles-outline":15}],5:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/16/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

// Define an Angular module for all the Bible components.

angular.module('hbBible', ['cgBusy', 'duScroll']);

// The Browserify package includes all JS modules that comprise the AngularJS
// `hbBible` module.
require('./bible-controller');
require('./page-controller');
require('./rss-controller');
require('./study-bible-controller');
require('./related-articles-directive');
require('./text-notes-directive');
require('./popover-directive');

},{"./bible-controller":4,"./page-controller":6,"./popover-directive":7,"./related-articles-directive":8,"./rss-controller":9,"./study-bible-controller":10,"./text-notes-directive":11}],6:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/8/14
 * License: All rights reserved.
 * Copyright: 2014 Puritan Reformed Theological Seminary
 */

// Define requirements for Browserify.

require('../app-controller');

// Module constants.
var API_ROOT = '/p';

// A note to whoever maintains this: I apologize. I did not yet have a good
// handle on the way to handle routing and views in Angular when I wrote it and
// do not have the budget allocated to be able to refactor all the relevant
// pieces at present.
function PageCtrl($http, $scope, $route, $routeParams) {
  $scope.content = '';

  // Load the requested data from the back end.
  var url = API_ROOT + '/' + $routeParams.page;
  $http.get(url).then(function (data) {
    $scope.content = data.content;
  }).catch(function (data, status, headers /*, config*/) {
    // On initial page load, the route must be reloaded to trigger API access.
    if (status === void 0) {
      $route.reload();
    }

    $scope.$log.error('An error occurred after requesting ' + url + '. Status: ' + status + ' | Headers: ' + headers);
  });
}

// Define a controller for page views.
angular.module('app').controller('PageController', ['$http', '$scope', '$route', '$routeParams', PageCtrl]);

},{"../app-controller":3}],7:[function(require,module,exports){
'use strict';
/**
  Author: Chris Krycho
  Contact: chris@krycho.com
  Date: 5/22/15
  License: All rights reserved.
  Copyright: 2015 Puritan Reformed Theological Seminary
 */

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function HbNotePopover($compile, $document, $window, auth) {
  function controller($scope) {

    /**
      Get the constraining viewport details.
      @returns {{width: Number, height: Number, scrollX: Number, scrollY: Number}}
       The algorithm draws *heavily* on the Bigfoot.js positioning algorithm.
      See [`viewportDetails`](https://github.com/lemonmade/bigfoot/blob/master/src/coffee/bigfoot.coffee#L1119).
      However, it has been adapted to function with the Zepto.js components, so
      that jQuery is not a dependency.
     */
    function viewportDetails($window) {
      var width = $window.innerWidth,
          height = $window.innerHeight,
          scrollX = $window.scrollX,
          scrollY = $window.scrollY;


      return { width: width, height: height, scrollX: scrollX, scrollY: scrollY };
    }

    var getNavHeight = function getNavHeight() {
      return $document[0].querySelector('#mainnav').clientHeight + 2;
    };

    var getSettingsHeight = function getSettingsHeight() {
      var item = $document[0].querySelector('#settings');

      var _$window$getComputedS = $window.getComputedStyle(item),
          bottom = _$window$getComputedS.bottom;

      var bottomAsNum = bottom.replace(/(\d+).*/, '$1');
      var bottomIsSetToNum = !isNaN(parseInt(bottomAsNum));
      return bottomIsSetToNum ? item.clientHeight : 0;
    };

    var getStripeHeight = function getStripeHeight() {
      return $document[0].querySelector('.branding-stripe').clientHeight;
    };

    var getUnavailableBottomSpace = function getUnavailableBottomSpace() {
      return getSettingsHeight() + getStripeHeight();
    };

    /**
      Determine how much room is present in each direction around the element.
     */
    var calcRoom = function calcRoom(el) {
      var v = viewportDetails($window);
      var rect = el.getBoundingClientRect();
      var docEl = el.ownerDocument.documentElement;
      var elOffset = {
        top: rect.top + $window.pageYOffset - docEl.clientTop,
        left: rect.left + $window.pageXOffset - docEl.clientLeft
      };
      var elTopInView = elOffset.top - v.scrollY;
      var elLeftInView = elOffset.left - v.scrollX;

      var navBarHeight = docEl.querySelector('#mainnav').clientHeight;
      var topRoom = elTopInView + el.clientHeight / 2 - navBarHeight;

      var bottomRoom = v.height - topRoom - getUnavailableBottomSpace();

      return {
        top: topRoom,
        bottom: bottomRoom,
        leftRelative: elLeftInView / v.width
      };
    };

    /**
      Determine where to place the popover, and apply CSS accordingly.
     */
    var positionPopover = function positionPopover(el) {
      var $el = angular.element(el);
      var $link = $el.parent()[0].querySelector('[data-hb-note-link]');
      var content = el.querySelector('.note-content');
      var linkLeft = $link.getBoundingClientRect().left;
      var room = calcRoom($link);
      var spacing = 16;

      // Use el.height() * 1.5 so that it does not end up compressed out of
      // visibility on the bottom of the screen.
      var requiredBottomSpace = el.clientHeight * 1.5;
      var positionAbove = room.bottom < requiredBottomSpace && room.top > room.bottom;

      var offset = '1.5em';

      var _ref = positionAbove ? [room.top - spacing - getNavHeight() + 'px', { bottom: offset }] : [room.bottom - spacing - getUnavailableBottomSpace() + 'px', { top: offset }],
          _ref2 = _slicedToArray(_ref, 2),
          maxHeight = _ref2[0],
          position = _ref2[1];

      var articleWidth = document.querySelector('article.book').clientWidth;
      var totalAvailableWidth = Math.max(articleWidth, document.querySelector('body').clientWidth);

      var left = el.clientWidth + linkLeft > totalAvailableWidth ? spacing - room.leftRelative * articleWidth + 'px' : undefined;

      $el.css(angular.merge({}, { 'max-height': maxHeight }, position, { left: left }));
      angular.element(content).css({ 'max-height': 'calc(' + maxHeight + ' - 1.2rem)' });
    };

    /**
      Show or hide a note popup.
     */
    $scope.toggleNote = function () {
      var closeButton = '\n        <div class=\'close button\' data-ng-click=\'toggleNote()\' data-dismiss=\'modal\'>\n          <label class=\'icon-label\'>Close</label>\n          <div class=\'icon-wrap\'>\n            <svg class=\'svg icon\'><use xlink:href=\'#close-icon\'/></svg>\n            <div class=\'svg-fallback icon\' data-src=\'#close-icon\'></div>\n          </div>\n        </div>\n      ';

      // Toggle the visibility.
      $scope.note.visible = !$scope.note.visible;

      // If the popover exists, remove it. Otherwise, create it.
      if (!$scope.popover) {
        var popover = $document[0].createElement('div');
        popover.setAttribute('class', 'note-popover modal');

        // Build the popover: get its content, then bind it to the Angular scope
        // and insert it into the DOM.
        var sourceHTML = $scope.popoverSource.innerHTML;
        popover.innerHTML = '\n          ' + closeButton + '\n          <div class=\'note-content\' data-hb-note-content>\n            ' + sourceHTML + '\n          </div>\n        ';

        $compile(popover)($scope);
        $scope.iEl[0].appendChild(popover);

        // Bind the new element to the scope so it can be retrieved later.
        $scope.popover = popover;

        // Set the correct position of the popover.
        positionPopover(popover);
      } else {
        $scope.popover.parentElement.removeChild($scope.popover);
        delete $scope.popover;
      }
    };
  }

  function link(scope, iEl, iAttrs) {
    // Don't do anything at all if the user isn't authorized for the KJVSB.
    if (!auth.isAuthorized('kjvsb')) {
      return;
    }

    // Don't do anything if there aren't any notes.
    if (angular.isUndefined(scope.textNotes)) {
      return;
    }

    // Bind the element reference for ease of use with position calculations.
    scope.iEl = iEl;

    // Bind a reference to the element target for styling.
    scope.popoverSource = $document[0].getElementById(iAttrs.noteHref);

    // Initialize scope settings for each instance.
    scope.note = scope.textNotes[iAttrs.noteReference];
  }

  return {
    controller: controller,
    link: link,
    restrict: 'A',
    scope: true
  };
}

angular.module('hbBible').directive('hbNotePopover', [
// Inject dependencies. AngularJS:
'$compile', '$document', '$window',
// First-party (hb):
'hbAuth',
// Supply the constructor
HbNotePopover]);

},{}],8:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 2/13/15
 * License:
 * Copyright: 2015
 */
/* globals document */

/**
 * Constructor for the `related-articles` directive.
 *
 * @constructor
 */

function HbRelatedArticles($timeout, auth) {
  function link(scope, el, attrs) {
    // Don't do anything at all if the user isn't authorized for the KJVSB.
    if (!auth.isAuthorized('kjvsb')) {
      return;
    }

    var book = attrs.hbRelatedArticles;

    $timeout(function () {
      if (!!scope.articlesOutline && !!scope.articlesOutline[book]) {

        var articles = scope.articlesOutline[book];

        var id = void 0;
        for (var article = 0; article < articles.length; article++) {
          var insertBeforeEl = void 0;
          var wrapperEl = null;
          // Get the correct insertion location, depending on whether the note
          // is tied to a given chapter or to the book as a whole.
          if (articles[article].chapter) {
            // If to the chapter, insert inline before the first verse.
            id = book + '-' + articles[article].chapter;
            insertBeforeEl = document.getElementById(id);
          } else {
            // If to the book, insert before the first paragraph, with a div
            // wrapper for the element.
            id = book;
            insertBeforeEl = document.getElementById(id).firstChild.nextSibling;
            var wrapperId = book + '-book-notes';
            wrapperEl = document.getElementById(wrapperId);
            if (!wrapperEl) {
              wrapperEl = document.createElement('div');
              wrapperEl.setAttribute('id', wrapperId);
              wrapperEl.setAttribute('class', 'book-notes');
            }
          }

          // Define the element to insert:
          //     <a href="{url}" class="related-article">{source}: {title}</a>
          var contentEl = document.createElement('a');
          contentEl.setAttribute('href', articles[article].url);
          contentEl.setAttribute('class', 'related-article');
          var text = articles[article].source + ':' + articles[article].title;
          var content = document.createTextNode(text);
          contentEl.appendChild(content);
          if (wrapperEl) {
            wrapperEl.appendChild(contentEl);
            insertBeforeEl.parentNode.insertBefore(wrapperEl, insertBeforeEl);
          } else {
            insertBeforeEl.parentNode.insertBefore(contentEl, insertBeforeEl);
          }
        }
      }
    }, 0);
  }

  return { link: link, restrict: 'A' };
}

// Construct the directive and bind it to the `hbBible` module.
angular.module('hbBible').directive('hbRelatedArticles', [
// Inject dependencies. AngularJS:
'$timeout',
// First-party (hb):
'hbAuth',
// Supply the directive.
HbRelatedArticles]);

},{}],9:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 2015/10/23
 * License:
 * Copyright: 2015
 */

function RSSController($resource, $scope) {
  $scope.feeds = null;

  function bindFeeds(feeds) {
    $scope.feeds = feeds;
  }

  var Feed = $resource('/f/all');
  Feed.get(bindFeeds);
}

angular.module('app').controller('RSSController', [
// Inject dependencies.
'$resource', '$scope',
// Bind the controller
RSSController]);

},{}],10:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 2/6/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

function StudyBibleController() {}

angular.module('hbBible').controller('StudyBibleController', [
// Inject dependencies
// Supply the controller.
StudyBibleController]);

},{}],11:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 4/17/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

/**
 * Constructor for the `text-notes` directive.
 *
 * @constructor
 */

function HbTextNotes($compile, $timeout, auth) {

  function link(scope /*, el, attrs*/) {
    // Don't do anything at all if the user isn't authorized for the KJVSB.
    if (!auth.isAuthorized('kjvsb')) {
      return;
    }

    // Don't do anything if there aren't any notes.
    if (angular.isUndefined(scope.textNotes)) {
      return;
    }

    // Define the note-rendering behavior.
    function renderNotes() {
      scope.textNotes.forEach(function (note, n) {
        // Create a container (which will handle scoping).
        var div = document.createElement('div');
        div.setAttribute('class', 'text-note');
        div.setAttribute('data-hb-note-popover', '');
        div.setAttribute('data-note-reference', n);
        div.setAttribute('data-note-href', note.id);

        // Create a link to the note.
        var a = document.createElement('a');
        a.setAttribute('href', ''); // Makes the <a> click-able w/o CSS
        a.setAttribute('data-ng-click', 'toggleNote()');
        a.setAttribute('data-hb-note-link', '');

        var text = void 0;
        switch (note.type) {
          case 'inline':
            text = '†';
            a.setAttribute('class', 'note-link');
            break;
          case 'thought':
            text = 'Thoughts for Personal/Family Worship';
            a.setAttribute('class', 'note-link long-note-link');
            break;
          case 'head':
            text = 'Introduction to ' + note.title;
            a.setAttribute('class', 'note-link long-note-link');
            break;
          default:
            text = '';
            break;
        }

        a.appendChild(document.createTextNode(text));
        div.appendChild(a);

        // Set up the Angular bindings.
        $compile(div)(scope);

        // Insert the link element after the verse number.
        var insertAtID = note.ref;
        var targetEl = document.getElementById(insertAtID);
        var insertBefore = void 0;
        if (angular.element(targetEl).hasClass('chnum')) {
          insertBefore = targetEl.nextSibling.firstChild.nextSibling;
          targetEl = targetEl.nextSibling;
        } else {
          insertBefore = targetEl.firstChild.nextSibling;
        }

        targetEl.insertBefore(div, insertBefore);
      });
    }

    // We use `$timeout` to ensure that the digest cycle has finished and thus
    // that the page is laid out before updating it.
    $timeout(renderNotes);
  }

  return { link: link, restrict: 'A' };
}

// Construct the directive and bind it to the `hbBible` module.
angular.module('hbBible').directive('hbTextNotes', [
// Inject dependencies. AngularJS:
'$compile', '$timeout',
// First-party (hb):
'hbAuth',
// Supply the constructor
HbTextNotes]);

},{}],12:[function(require,module,exports){
'use strict';
/**
  Author: Chris Krycho
  Contact: chris@krycho.com
  Date: 12/6/14
  License: All rights reserved.
  Copyright: 2014 Puritan Reformed Theological Seminary

  Define a controller for the Bible navigation field and popups.
 */

// Define requirements for Browserify.

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

require('../app-controller');
var config = require('../../app-config');

function BibleNavController($scope, $timeout, $rootElement, $location, locationMeta) {
  /* Controller setup: define data and functions */
  // Data structures with controller state.
  var touch = $rootElement.hasClass('touch');
  $scope.menu = {
    outline: $scope.outline,
    current: { book: '', numChapters: '' },
    sections: ['Old Testament', 'New Testament'],
    active: false,
    textEditable: !touch
  };

  $scope.searchField = {
    focused: false,
    text: '',
    clear: function clear() {
      this.text = '';
    }
  };

  // TODO: move this. It does *not* belong here. (Part of splitting up
  // navigation controls!)
  $scope.sitenav = {
    active: false,
    toggleActive: function toggleActive(active) {
      if (angular.isDefined(active)) {
        this.active = active;
      } else {
        this.active = !this.active;
      }
    }
  };

  // Build a request like `<book ID>.<chapter>.verse`, e.g. `isa.61.1`
  $scope.request = {
    book: '', chapter: '', verse: '',
    valid: function valid() {
      var validBook = $scope.menu.outline.hasOwnProperty(this.book);
      var numChapters = $scope.menu.outline[this.book].numChapters;
      var validChapter = this.chapter > 0 && this.chapter <= numChapters;
      return validBook && validChapter;
    }
  };

  // Functions for modifying state.
  /**
   * Add a function to biblenav to update all relevant state when
   * toggling the menu visibility.
   *
   * @param {bool} [active] Optionally specify the state to which to set
   *     the toggle.
   *
   * @TODO: We use `$timeout` here for what is essentially a visual fix,
   *     because I haven't yet implemented this as a directive. See issue
   *     [#25][25] for further details.
   *
   * [25]: https://github.com/chriskrycho/holybible.com/issues/25
   */
  function toggleActive(active) {
    var previouslyActive = $scope.menu.active;
    if (angular.isDefined(active)) {
      $scope.menu.active = active;
    } else {
      $scope.menu.active = !$scope.menu.active;
    }

    if (previouslyActive) {
      $timeout(function () {
        $scope.cancelBookRequest();
      }, 500);
    }
  }

  /**
   * Request a book.
   *
   * If the book is a valid book, this has three results:
   *
   *  1. It sets the biblenav current state to 'chapters', so that the nav
   *     may display a list of chapters instead of books.
   *  2. It sets the biblenav object's `chapters` property to the number
   *     of chapters in the requested book.
   *  3. It sets the `book` property of the `request` object to the book.
   *
   * @param bookId
   */
  function requestBook(bookId) {
    if (bookId in $scope.menu.outline) {
      $scope.menu.current.book = bookId;
      $scope.menu.current.numChapters = $scope.menu.outline[bookId].numChapters;
      $scope.request.book = bookId;
    }
  }

  /**
   * Request a specific chapter from the currently selected book.
   * @param {int} chapter
   */
  function requestChapter(chapter) {
    var currentBook = $scope.menu.current.book;
    if (currentBook !== null) {
      var maxChapters = $scope.menu.current.numChapters;

      if (chapter > 0 && parseInt(chapter) <= maxChapters) {
        $scope.request.chapter = chapter.toString();
        $scope.request.verse = '1';
      }
    }

    if ($scope.request.valid()) {
      var url = buildUrlFromComponents($scope.request);
      $location.path(url);
    }
  }

  /**
   * Cancel a request: reset the `biblenav.current` and `request` objects.
   */
  function cancelBookRequest() {
    $scope.menu.current.book = '';
    $scope.menu.current.numChapters = '';
    $scope.request.book = '';
  }

  // Whenever the path is updated, if the path is a Bible URL, update the
  // menu and search bar.
  // TODO: replace with $scope.$on($locationChangeSuccess).
  $scope.$watch(
  // Get the watched value: the URL.
  function () {
    return $location.path();
  },
  // When the value changes, update local data if is a Bible URL.
  function (value) {
    if (config.BIBLE_RE.test(value)) {
      $scope.requestLocation(value);
    }
  });

  /**
   * Update the current location via the hbLocationMetadata service..
   *
   * @param {string} [url] A string specifying the URL.
   */
  $scope.requestLocation = function (url) {
    // Get the request string.
    if (angular.isUndefined(url)) {
      throw 'UndefinedUrlError';
    }

    var normalized = normalizeUrl(url);
    var components = urlComponents(normalized);
    var id = components[1];

    // Do not continue if the URL is empty.
    if (id === '') {
      return;
    }

    var title = $scope.menu.outline[id].title;
    var chapter = components[2];
    var verse = components[3];

    // Close the navigation popup. Do not reset its location, since the
    // user is likely to want to navigate within the same book.
    $scope.menu.active = false;

    // Then update the app scope's passage.current values to match the
    // requested passage.
    updatePassage({ id: id, title: title, chapter: chapter, verse: verse });
  };

  /**
   * Query for a given passage using text input.
   * @param {string} text The user-supplied search string.
   */
  $scope.searchPassage = function (text) {
    var passage = $scope.passage.parse(text);
    if (!passage) {
      // TODO: message?
      return;
    }

    $scope.request.book = bookStringToUrl(passage.book);
    $scope.request.chapter = passage.chapter;
    $scope.request.verse = passage.verse;

    var url = buildUrlFromComponents($scope.request);
    $location.path(url);
  };

  /**
   * Take a book string (`Genesis`, `gen`, etc.) and attempt to match it to
   * a book in the outline. If it matches, return the book ID.
   *
   * @param {string} bookString
   * @returns {string}
   * @throws {string} When a request produces an unparseable book.
   */
  function bookStringToUrl(bookString) {
    var bookStringLower = bookString.toLowerCase();

    var bookId = void 0;
    for (var b in $scope.outline) {
      var title = $scope.outline[b].title;
      var id = $scope.outline[b].id;

      // For a title or ID to match, the request must be a substring of the
      // title or ID, and they must start with the same character. Thus, Ez
      // will work for Ezekiel, but even though 'John' is a substring of
      // all the epistles as well, it will not match because it does not
      // start with a number. Match against lowercase variants of the strings to
      // handle however it has been typed.
      var titleLower = title.toLowerCase(),
          idLower = id.toLowerCase();

      var titleMatch = titleLower.indexOf(bookStringLower) !== -1 && titleLower[0] === bookStringLower[0];

      var idMatch = idLower.indexOf(bookStringLower) !== -1 && idLower[0] === bookStringLower[0];

      if (titleMatch || idMatch) {
        return id;
      }
    }

    if (angular.isUndefined(bookId)) {
      throw {
        name: 'UnparseableBook',
        message: 'Book ID was undefined: ' + bookString
      };
    }
  }

  /**
   * Build a request string like `gen.1.1` from book/chapter/verse pieces.
   * @param request A request object with `book` and `chapter` properties
   *     defined, and optionally also a `verse` property defined.
   * @returns {string}
   */
  function buildUrlFromComponents(request) {
    var verse = request.verse ? request.verse : 1;
    var url = request.book + '.' + request.chapter + '.' + verse;
    return url;
  }

  /** Update the location.
     @param {object} passage              Specify the passage.
    @property {string} passage.id        The book ID (e.g. 'gen').
    @property {string} [passage.chapter] The chapter in the book.
    @property {string} [passage.verse]   The verse in the book.
     @note If `chapter` or `verse` are unset, default values (of 1) are used.
   */
  function updatePassage(passage) {
    // Throw exceptions for unset passage IDs or titles.
    if (!passage.id) {
      throw { passage: passage, name: 'PassageError', message: 'Passage ID not set.' };
    }

    var id = passage.id;

    // Supply default values for unset chapter and verse.
    var chapter = angular.isDefined(passage.chapter) ? passage.chapter : '1';
    var verse = angular.isDefined(passage.verse) ? passage.verse : '1';

    locationMeta.setPassage({ id: id, chapter: chapter, verse: verse });
  }

  /** Update the search field text to match the current passage.
   */
  function updateSearchField(event, data) {
    var title = data.passage.title,
        chapter = data.passage.chapter,
        verse = data.passage.verse;

    if (!(title && chapter && verse)) {
      $scope.searchField.clear();
    } else {
      $scope.searchField.text = title + ' ' + chapter + ':' + verse;
    }
  }

  /** Get the components of a Bible URL request.
     @param {string} url
    @returns {Array} URL components: leading slash, book, chapter, and verse.
   */
  function urlComponents(url) {
    return url.split(/[\.\/]/);
  }

  /** Normalize a user input request string to match the standard URL scheme.
     @param {string} input An input string to normalize.
    @returns {*}
   */
  function normalizeUrl(input) {
    return input.replace(/^([^\/])/, '/$1');
  }

  // Bind public functions to the $scope.
  $scope.cancelBookRequest = cancelBookRequest;
  $scope.requestBook = requestBook;
  $scope.requestChapter = requestChapter;
  $scope.menu.toggleActive = toggleActive; // TODO: see above at definition.

  // Bind local behavior to events.
  $scope.$on(locationMeta.eventName, updateSearchField);
}

/** Allow the template to filter books by section (i.e. get only New Testament).

  @param {Array} books
  @param {string} section
  @return {Array}
 */
function filterBySection() {
  return function (books, section) {
    var filtered = [];
    for (var b in books) {
      if (books[b].section === section) {
        filtered.push(books[b]);
      }
    }
    return filtered;
  };
}

/** Define a standard range function as a filter.

  @param {Array} range Standard input to a filter; must be an empty array.
  @param {int} max The ending point of the range. Not inclusive by default (see
      inclusive below).
  @param {int} [min] The starting point of the range; defaults to 0.
  @param {bool} [inclusive] Whether to include `max`. Defaults to false.
  @param {int} [step] Step size to use in range.
  @return {Array} An array from min to max by step, including max if
      `inclusive` was set to true.

  @note The first argument is *max*, not *min*. This is so that the function
      can be called as `range(<max>)` rather than having to call
      `range(0, <max>)`.

  @note The types given above are idealized. This is a filter, so all but the
      Array will actually be parsed from a string.
 */
function range() {
  return function (range, max, min, inclusive, step) {
    /* eslint-disable angular/definedundefined */
    min = typeof min !== 'undefined' ? parseInt(min) : 0;
    inclusive = typeof inclusive !== 'undefined' || inclusive === 'true';
    step = typeof step !== 'undefined' ? step : 1;
    /* eslint-enable angular/definedundefined */

    max = parseInt(max);
    if (inclusive) {
      max += 1;
    }

    var finalRange = [].concat(_toConsumableArray(range));
    for (var i = min; i < max; i += step) {
      finalRange.push(i);
    }
    return finalRange;
  };
}

angular.module('app').controller('BibleNavController', [
// Inject dependencies. AngularJS:
'$scope', '$timeout', '$rootElement', '$location',
// First-party:
'hbLocationMetadata',
// Supply the constructor:
BibleNavController]).filter('filterBySection', filterBySection).filter('range', range);

},{"../../app-config":1,"../app-controller":3}],13:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/16/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

// The Browserify package includes all modules here.

require('./biblenav-controller');
require('./sitenav-controller');

},{"./biblenav-controller":12,"./sitenav-controller":14}],14:[function(require,module,exports){
'use strict';

// Define requirements for Browserify.

require('../app-controller');

// siteOutline -> boolean -> isProfile -> siteOutline
var setProfileViews = function setProfileViews(original, isAuthenticated, isProfile) {
  return angular.merge({}, original, {
    pages: {
      profile: {
        show: isAuthenticated && !isProfile
      },
      signIn: {
        show: !isAuthenticated
      },
      signOut: {
        show: isAuthenticated && isProfile
      }
    }
  });
};

function SiteNavController($location, $scope, $window, locationMeta, session, user) {
  var defaultClick = function defaultClick() {
    return $scope.sitenav.toggleActive(false);
  };

  var updateOutline = function updateOutline() /*event, eventData*/{
    var isAuthenticated = session.isAuthenticated();
    var isProfile = /^Profile/.test(locationMeta.get().meta.title);
    $scope.siteOutline = setProfileViews(siteOutline, isAuthenticated, isProfile);
  };

  var siteOutline = {
    pages: {
      read: {
        title: 'Read',
        click: defaultClick,
        standalone: false,
        url: '/gen.1.1',
        order: 0,
        menu: true,
        show: true,
        id: 'read'
      },
      about: {
        title: 'About',
        click: defaultClick,
        standalone: true,
        url: 'about',
        order: 1,
        menu: true,
        show: true,
        id: 'about'
      },
      studyBible: {
        title: 'Study Bible',
        click: defaultClick,
        standalone: false,
        order: 2,
        menu: true,
        url: '/rhkjvsb',
        show: true,
        id: 'study-bible'
      },
      resource: {
        title: 'Resources',
        click: defaultClick,
        standalone: true,
        url: 'resources',
        order: 2,
        menu: true,
        show: true,
        id: 'resources'
      },
      profile: {
        title: 'Account',
        click: defaultClick,
        standalone: false,
        url: '/user/profile',
        order: 3,
        menu: true,
        show: false,
        id: 'profile'
      },
      signIn: {
        title: 'Sign In',
        click: defaultClick,
        standalone: false,
        url: '/user/sign-in',
        order: 4,
        menu: true,
        show: true,
        id: 'sign-in'
      },
      signOut: {
        title: 'Sign Out',
        click: function click() {
          defaultClick();
          user.logout();
        },
        standalone: false,
        url: '/',
        order: 5,
        menu: true,
        show: false,
        id: 'sign-out'
      }
    },

    getId: function getId(page) {
      return 'sitenav-' + page.id;
    },
    getUrl: function getUrl(page) {
      if (page.standalone) {
        return '/pages/' + page.url;
      } else {
        return page.url;
      }
    },
    runClick: function runClick(page) {
      page.click();
    }
  };

  updateOutline();

  // This is a *horrible* hack. But it gets the job done.
  $scope.clickLogo = function () {
    var showMenu = $window.innerWidth <= 1340;
    if (showMenu) {
      $scope.sitenav.toggleActive();
    } else {
      $location.path($scope.siteOutline.pages.read.url);
    }
  };

  /**
    Update the read link as appropriate, so that it always takes the user back
    to the previous Bible page they were reading.
     @param event
    @param eventData
   */
  var updateReadLink = function updateReadLink(event, eventData) {
    var urlFromPassage = function urlFromPassage(passage) {
      return '/' + [passage.id, passage.chapter, passage.verse].join('.');
    };

    var passage = eventData.passage;

    var updatedUrl = $scope.siteOutline.pages.read.url;
    if (passage && !angular.equals(passage, {})) {
      updatedUrl = urlFromPassage(passage);
    } else {
      var previousPassage = locationMeta.get().passage.previous;
      if (angular.isDefined(previousPassage.id)) {
        updatedUrl = urlFromPassage(previousPassage);
      }
    }

    $scope.siteOutline.pages.read.url = updatedUrl;
  };

  var onChangeLocation = function onChangeLocation(event, eventData) {
    updateOutline();
    updateReadLink(event, eventData);
  };

  $scope.$on(locationMeta.eventName, onChangeLocation);
  $scope.$on(session.EVENT, updateOutline);
}

// Define a controller for site navigation
angular.module('app').controller('SiteNavController', [
// Inject dependencies. AngularJS:
'$location', '$scope', '$window',
// First-party
'hbLocationMetadata', 'hbSession', 'hbUser',
// Supply the constructor
SiteNavController]);

},{"../app-controller":3}],15:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 2/13/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

var articlesRoot = '/rhkjvsb';

var byLocation = {
  gen: [
  // 1
  {
    title: 'Introduction to the Pentateuch',
    url: articlesRoot + '/introduction-to-the-pentateuch',
    source: 'KJVSB'
  }, {
    title: 'Introduction to the Book of Genesis',
    url: articlesRoot + '/introduction-to-the-book-of-genesis',
    source: 'KJVSB'
  }, {
    title: 'Creation and God’s Glory',
    url: articlesRoot + '/creation-gods-glory',
    source: 'KJVSB',
    chapter: 1
  }, {
    title: 'The Fall of Man',
    url: articlesRoot + '/fall-of-man',
    source: 'KJVSB',
    chapter: 3
  }, {
    title: 'Faith in God',
    url: articlesRoot + '/faith-in-god',
    source: 'KJVSB',
    chapter: 15
  }, {
    title: 'God’s Covenants',
    url: articlesRoot + '/gods-covenants',
    source: 'KJVSB',
    chapter: 50
  }],
  exo: [
  // 2
  {
    title: 'Introduction to the Book of Exodus',
    url: articlesRoot + '/introduction-to-the-book-of-exodus',
    source: 'KJVSB'
  }, {
    title: 'God’s Names',
    url: articlesRoot + '/gods-names',
    source: 'KJVSB',
    chapter: 3
  }, {
    title: 'God’s Love and Justice',
    url: articlesRoot + '/gods-love-justice',
    source: 'KJVSB',
    chapter: 34
  }, {
    title: 'God’s Dwelling with Man',
    url: articlesRoot + '/gods-dwelling-with-man',
    source: 'KJVSB',
    chapter: 40
  }],
  lev: [
  // 3
  {
    title: 'Introduction to the Book of Leviticus',
    url: articlesRoot + '/introduction-to-the-book-of-leviticus',
    source: 'KJVSB'
  }, {
    title: 'God’s Holiness and Ours',
    url: articlesRoot + '/gods-holiness-ours',
    source: 'KJVSB',
    chapter: 11
  }],
  num: [
  // 4
  {
    title: 'Introduction to the Book of Numbers',
    url: articlesRoot + '/introduction-to-the-book-of-numbers',
    source: 'KJVSB'
  }, {
    title: 'God’s Immutability',
    url: articlesRoot + '/gods-immutability',
    source: 'KJVSB',
    chapter: 23
  }],
  deu: [
  // 5
  {
    title: 'Introduction to the Book of Deuteronomy',
    url: articlesRoot + '/introduction-to-the-book-of-deuteronomy',
    source: 'KJVSB'
  }, {
    title: 'The Uses of the Moral Law',
    url: articlesRoot + '/uses-of-the-moral-law',
    source: 'KJVSB',
    chapter: 5
  }],
  jos: [
  // 6
  {
    title: 'Introduction to the Historical Books',
    url: articlesRoot + '/introduction-to-the-historical-books',
    source: 'KJVSB'
  }, {
    title: 'Introduction to the Book of Joshua',
    url: articlesRoot + '/introduction-to-the-book-of-joshua',
    source: 'KJVSB'
  }, {
    title: 'Canaan and the Inheritance',
    url: articlesRoot + '/canaan-inheritance',
    source: 'KJVSB',
    chapter: 11
  }],
  jdg: [
  // 7
  {
    title: 'Introduction to the Book of Judges',
    url: articlesRoot + '/introduction-to-the-book-of-judges',
    source: 'KJVSB'
  }, {
    title: 'The Angel of the Lord',
    url: articlesRoot + '/angel-lord',
    source: 'KJVSB',
    chapter: 7
  }],
  rth: [
  // 8
  {
    title: 'Introduction to the Book of Ruth',
    url: articlesRoot + '/introduction-to-the-book-of-ruth',
    source: 'KJVSB'
  }],
  '1sa': [
  // 9
  {
    title: 'Introduction to the Books of 1 and 2 Samuel',
    url: articlesRoot + '/introduction-to-the-books-of-1-and-2-samuel',
    source: 'KJVSB'
  }, {
    title: 'Obedience to God’s Will',
    url: articlesRoot + '/obedience-to-gods-will',
    source: 'KJVSB',
    chapter: 15
  }],
  '2sa': [
  // 10
  {
    title: 'Introduction to the Book of 2 Samuel',
    url: articlesRoot + '/introduction-to-the-book-of-2-samuel',
    source: 'KJVSB'
  }, {
    title: 'The Son of David',
    url: articlesRoot + '/son-of-david',
    source: 'KJVSB',
    chapter: 7
  }],
  '1ki': [
  // 11
  {
    title: 'Introduction to the Books of 1 and 2 Kings',
    url: articlesRoot + '/introduction-to-the-books-of-1-and-2-kings',
    source: 'KJVSB'
  }, {
    title: 'God’s Foreknowledge',
    url: articlesRoot + '/gods-foreknowledge',
    source: 'KJVSB',
    chapter: 13
  }],
  '2ki': [
  // 12
  {
    title: 'Introduction to the Book of 2 Kings',
    url: articlesRoot + '/introduction-to-the-book-of-2-kings',
    source: 'KJVSB'
  }, {
    title: 'The Only True God',
    url: articlesRoot + '/only-true-god',
    source: 'KJVSB',
    chapter: 19
  }],
  '1ch': [
  // 13
  {
    title: 'Introduction to the Books of 1 and 2 Chronicles',
    url: articlesRoot + '/introduction-to-the-books-of-1-and-2-chronicles',
    source: 'KJVSB'
  }, {
    title: 'Worship by the Word',
    url: articlesRoot + '/worship-by-the-word',
    source: 'KJVSB',
    chapter: 15
  }],
  '2ch': [
  // 14
  {
    title: 'Introduction to the Book of 2 Chronicles',
    url: articlesRoot + '/introduction-to-the-book-of-2-chronicles',
    source: 'KJVSB'
  }, {
    title: 'Repentance',
    url: articlesRoot + '/repentance',
    source: 'KJVSB',
    chapter: 3
  }],
  ezr: [
  // 15
  {
    title: 'Introduction to the Book of Ezra',
    url: articlesRoot + '/introduction-to-the-book-of-ezra',
    source: 'KJVSB'
  }],
  neh: [
  // 16
  {
    title: 'Introduction to the Book of Nehemiah',
    url: articlesRoot + '/introduction-to-the-book-of-nehemiah',
    source: 'KJVSB'
  }, {
    title: 'This Evil World',
    url: articlesRoot + '/this-evil-world',
    source: 'KJVSB',
    chapter: 4
  }],
  est: [
  // 17
  {
    title: 'Introduction to the Book of Esther',
    url: articlesRoot + '/introduction-to-the-book-of-esther',
    source: 'KJVSB'
  }],
  job: [
  // 18
  {
    title: 'Introduction to the Poetic and Wisdom Books',
    url: articlesRoot + '/introduction-to-the-poetic-and-wisdom-books',
    source: 'KJVSB'
  }, {
    title: 'Introduction to the Book of Job',
    url: articlesRoot + '/introduction-to-the-book-of-job',
    source: 'KJVSB'
  }, {
    title: 'Satan',
    url: articlesRoot + '/satan',
    source: 'KJVSB',
    chapter: 2
  }, {
    title: 'God’s Wisdom',
    url: articlesRoot + '/gods-wisdom',
    source: 'KJVSB',
    chapter: 12
  }],
  psa: [
  // 19
  {
    title: 'Introduction to the Book of Psalms',
    url: articlesRoot + '/introduction-to-the-book-of-the-psalms',
    source: 'KJVSB'
  }, {
    title: 'The Means of Grace',
    url: articlesRoot + '/means-of-grace',
    source: 'KJVSB',
    chapter: 19
  }, {
    title: 'The Soul',
    url: articlesRoot + '/soul',
    source: 'KJVSB',
    chapter: 63
  }, {
    title: 'God’s Eternity',
    url: articlesRoot + '/gods-eternity',
    source: 'KJVSB',
    chapter: 90
  }],
  pro: [
  // 20
  {
    title: 'Introduction to the Book of Proverbs',
    url: articlesRoot + '/introduction-to-the-book-of-proverbs',
    source: 'KJVSB'
  }, {
    title: 'The Authority and Inerrancy of Scripture',
    url: articlesRoot + '/authority-inerrancy-scripture',
    source: 'KJVSB',
    chapter: 30
  }],
  ecc: [
  // 21
  {
    title: 'Introduction to the Book of Ecclesiastes',
    url: articlesRoot + '/introduction-to-the-book-of-ecclesiastes',
    source: 'KJVSB'
  }],
  sng: [
  // 22
  {
    title: 'Introduction to the Book of Song of Solomon',
    url: articlesRoot + '/introduction-to-the-book-of-song-of-solomon',
    source: 'KJVSB'
  }],
  isa: [
  // 23
  {
    title: 'Introduction to the Prophets',
    url: articlesRoot + '/introduction-to-the-prophets',
    source: 'KJVSB'
  }, {
    title: 'Introduction to the Book of Isaiah',
    url: articlesRoot + '/introduction-to-the-book-of-isaiah',
    source: 'KJVSB'
  }, {
    title: 'Christ’s Kingdom',
    url: articlesRoot + '/christs-kingdom',
    source: 'KJVSB',
    chapter: 9
  }],
  jer: [
  // 24
  {
    title: 'Introduction to the Book of jeremiah',
    url: articlesRoot + '/introduction-to-the-book-of-jeremiah',
    source: 'KJVSB'
  }, {
    title: 'Total Depravity',
    url: articlesRoot + '/total-depravity',
    source: 'KJVSB',
    chapter: 17
  }, {
    title: 'The Perseverance of the Saints',
    url: articlesRoot + '/perseverance-of-the-saints',
    source: 'KJVSB',
    chapter: 32
  }],
  lam: [
  // 25
  {
    title: 'Introduction to the Book of Lamentations',
    url: articlesRoot + '/introduction-to-the-book-of-lamentations',
    source: 'KJVSB'
  }, {
    title: 'God’s Faithfulness',
    url: articlesRoot + '/gods-faithfulness',
    source: 'KJVSB',
    chapter: 3
  }],
  ezk: [
  // 26
  {
    title: 'Introduction to the Book of Ezekiel',
    url: articlesRoot + '/introduction-to-the-book-of-ezekiel',
    source: 'KJVSB'
  }, {
    title: 'Human Responsibility',
    url: articlesRoot + '/human-responsibility',
    source: 'KJVSB',
    chapter: 18
  }],
  dan: [
  // 27
  {
    title: 'Introduction to the Book of Daniel',
    url: articlesRoot + '/introduction-to-the-book-of-daniel',
    source: 'KJVSB'
  }],
  hos: [
  // 28
  {
    title: 'Introduction to the Book of Hosea',
    url: articlesRoot + '/introduction-to-the-book-of-hosea',
    source: 'KJVSB'
  }],
  jol: [
  // 29
  {
    title: 'Introduction to the Book of Joel',
    url: articlesRoot + '/introduction-to-the-book-of-joel',
    source: 'KJVSB'
  }],
  amo: [
  // 30
  {
    title: 'Introduction to the Book of Amos',
    url: articlesRoot + '/introduction-to-the-book-of-amos',
    source: 'KJVSB'
  }],
  oba: [
  // 31
  {
    title: 'Introduction to the Book of Obadiah',
    url: articlesRoot + '/introduction-to-the-book-of-obadiah',
    source: 'KJVSB'
  }],
  jon: [
  // 32
  {
    title: 'Introduction to the Book of jonah',
    url: articlesRoot + '/introduction-to-the-book-of-jonah',
    source: 'KJVSB'
  }, {
    title: 'God’s Mercy',
    url: articlesRoot + '/gods-mercy',
    source: 'KJVSB',
    chapter: 4
  }],
  mic: [
  // 33
  {
    title: 'Introduction to the Book of Micah',
    url: articlesRoot + '/introduction-to-the-book-of-micah',
    source: 'KJVSB'
  }],
  nam: [
  // 34
  {
    title: 'Introduction to the Book of Nahum',
    url: articlesRoot + '/introduction-to-the-book-of-nahum',
    source: 'KJVSB'
  }],
  hab: [
  // 35
  {
    title: 'Introduction to the Book of Habakkuk',
    url: articlesRoot + '/introduction-to-the-book-of-habakkuk',
    source: 'KJVSB'
  }],
  zep: [
  // 36
  {
    title: 'Introduction to the Book of Zephaniah',
    url: articlesRoot + '/introduction-to-the-book-of-zephaniah',
    source: 'KJVSB'
  }, {
    title: 'The Day of the Lord',
    url: articlesRoot + '/day-lord',
    source: 'KJVSB',
    chapter: 3
  }],
  hag: [
  // 37
  {
    title: 'Introduction to the Book of Haggai',
    url: articlesRoot + '/introduction-to-the-book-of-haggai',
    source: 'KJVSB'
  }],
  zec: [
  // 38
  {
    title: 'Introduction to the Book of Zechariah',
    url: articlesRoot + '/introduction-to-the-book-of-zechariah',
    source: 'KJVSB'
  }],
  mal: [
  // 39
  {
    title: 'What Happened Between the Testaments?',
    url: articlesRoot + '/what-happened-between-the-testaments',
    source: 'KJVSB'
  }, {
    title: 'Introduction to the Book of Malachi',
    url: articlesRoot + '/introduction-to-the-book-of-malachi',
    source: 'KJVSB'
  }],
  mat: [
  // 40
  {
    title: 'What Happened Between the Testaments?',
    url: articlesRoot + '/what-happened-between-the-testaments',
    source: 'KJVSB'
  }, {
    title: 'Introduction to the Gospels and Acts',
    url: articlesRoot + '/introduction-to-the-gospels-and-acts',
    source: 'KJVSB'
  }, {
    title: 'Introduction to the Book of Matthew',
    url: articlesRoot + '/introduction-to-the-book-of-matthew',
    source: 'KJVSB'
  }, {
    title: 'The Trinity',
    url: articlesRoot + '/trinity',
    source: 'KJVSB',
    chapter: 3
  }],
  mrk: [
  // 41
  {
    title: 'Introduction to the Book of Mark',
    url: articlesRoot + '/introduction-to-the-book-of-mark',
    source: 'KJVSB'
  }, {
    title: 'Christian Discipleship',
    url: articlesRoot + '/christian-discipleship',
    source: 'KJVSB',
    chapter: 8
  }],
  luk: [
  // 42
  {
    title: 'Introduction to the Book of Luke',
    url: articlesRoot + '/introduction-to-the-book-of-luke',
    source: 'KJVSB'
  }, {
    title: 'Angels',
    url: articlesRoot + '/angels',
    source: 'KJVSB',
    chapter: 9
  }, {
    title: 'The Lord’s Supper',
    url: articlesRoot + '/lords-supper',
    source: 'KJVSB',
    chapter: 22
  }],
  jhn: [
  // 43
  {
    title: 'Introduction to the Book of John',
    url: articlesRoot + '/introduction-to-the-book-of-john',
    source: 'KJVSB'
  }, {
    title: 'Christ’s Incarnation',
    url: articlesRoot + '/christs-incarnation',
    source: 'KJVSB',
    chapter: 1
  }, {
    title: 'Experiential Knowledge',
    url: articlesRoot + '/experiential-knowledge',
    source: 'KJVSB',
    chapter: 17
  }],
  act: [
  // 44
  {
    title: 'Introduction to the Book of Acts',
    url: articlesRoot + '/introduction-to-the-book-of-acts',
    source: 'KJVSB'
  }, {
    title: 'The Holy Spirit',
    url: articlesRoot + '/holy-spirit',
    source: 'KJVSB',
    chapter: 13
  }],
  rom: [
  // 45
  {
    title: 'Introduction to the Epistles',
    url: articlesRoot + '/introduction-to-the-epistles',
    source: 'KJVSB'
  }, {
    title: 'Introduction to the Book of Romans',
    url: articlesRoot + '/introduction-to-the-book-of-romans',
    source: 'KJVSB'
  }, {
    title: 'Adoption',
    url: articlesRoot + '/adoption',
    source: 'KJVSB',
    chapter: 8
  }, {
    title: 'Christ’s Satisfaction of God’s Justice',
    url: articlesRoot + '/christs-satisfaction-gods-justice',
    source: 'KJVSB',
    chapter: 3
  }],
  '1co': [
  // 46
  {
    title: 'Introduction to the Book of 1 Corinthians',
    url: articlesRoot + '/introduction-to-the-book-of-1-corinthians',
    source: 'KJVSB'
  }, {
    title: 'The Calling of God',
    url: articlesRoot + '/calling-god',
    source: 'KJVSB',
    chapter: 1
  }, {
    title: 'Christ’s Resurrection and Ours',
    url: articlesRoot + '/christs-resurrection-ours',
    source: 'KJVSB',
    chapter: 15
  }],
  '2co': [
  // 47
  {
    title: 'Introduction to the Book of 2 Corinthians',
    url: articlesRoot + '/introduction-to-the-book-of-2-corinthians',
    source: 'KJVSB'
  }],
  gal: [
  // 48
  {
    title: 'Introduction to the Book of Galatians',
    url: articlesRoot + '/introduction-to-the-book-of-galatians',
    source: 'KJVSB'
  }, {
    title: 'Justification by Faith Alone',
    url: articlesRoot + '/justification-by-faith-alone',
    source: 'KJVSB',
    chapter: 2
  }],
  eph: [
  // 49
  {
    title: 'Introduction to the Book of Ephesians',
    url: articlesRoot + '/introduction-to-the-book-of-ephesians',
    source: 'KJVSB'
  }, {
    title: 'Spiritual Warfare',
    url: articlesRoot + '/spiritual-warfare',
    source: 'KJVSB',
    chapter: 6
  }],
  php: [
  // 50
  {
    title: 'Introduction to the Book of Philippians',
    url: articlesRoot + '/introduction-to-the-book-of-philippians',
    source: 'KJVSB'
  }, {
    title: 'Christ’s States',
    url: articlesRoot + '/christs-states',
    source: 'KJVSB',
    chapter: 4
  }],
  col: [
  // 51
  {
    title: 'Introduction to the Book of Colossians',
    url: articlesRoot + '/introduction-to-the-book-of-colossians',
    source: 'KJVSB'
  }, {
    title: 'The Image of God',
    url: articlesRoot + '/image-of-god',
    source: 'KJVSB',
    chapter: 3
  }],
  '1th': [
  // 52
  {
    title: 'Introduction to the Book of 1 Thessalonians',
    url: articlesRoot + '/introduction-to-the-book-of-1-thessalonians',
    source: 'KJVSB'
  }],
  '2th': [
  // 53
  {
    title: 'Introduction to the Book of 2 Thessalonians',
    url: articlesRoot + '/introduction-to-the-book-of-2-thessalonians',
    source: 'KJVSB'
  }, {
    title: 'Election',
    url: articlesRoot + '/election',
    source: 'KJVSB',
    chapter: 2
  }],
  '1ti': [
  // 54
  {
    title: 'Introduction to the Book of 1 Timothy',
    url: articlesRoot + '/introduction-to-the-book-of-1-timothy',
    source: 'KJVSB'
  }],
  '2ti': [
  // 55
  {
    title: 'Introduction to the Book of 2 Timothy',
    url: articlesRoot + '/introduction-to-the-book-of-2-timothy',
    source: 'KJVSB'
  }],
  tit: [
  // 56
  {
    title: 'Introduction to the Book of Titus',
    url: articlesRoot + '/introduction-to-the-book-of-titus',
    source: 'KJVSB'
  }, {
    title: 'Regeneration',
    url: articlesRoot + '/regeneration',
    source: 'KJVSB',
    chapter: 3
  }],
  phm: [
  // 57
  {
    title: 'Introduction to the Book of Philemon',
    url: articlesRoot + '/introduction-to-the-book-of-philemon',
    source: 'KJVSB'
  }, {
    title: 'Communion of the Saints',
    url: articlesRoot + '/communion-saints',
    source: 'KJVSB',
    chapter: 2
  }],
  heb: [
  // 58
  {
    title: 'Introduction to the Book of Hebrews',
    url: articlesRoot + '/introduction-to-the-book-of-hebrews',
    source: 'KJVSB'
  }, {
    title: 'The Offices of Christ',
    url: articlesRoot + '/offices-of-christ',
    source: 'KJVSB',
    chapter: 7
  }],
  jas: [
  // 59
  {
    title: 'Introduction to the Book of James',
    url: articlesRoot + '/introduction-to-the-book-of-james',
    source: 'KJVSB'
  }, {
    title: 'Christ’s Coming in Glory',
    url: articlesRoot + '/christs-coming-glory',
    source: 'KJVSB',
    chapter: 5
  }],
  '1pe': [
  // 60
  {
    title: 'Introduction to the Book of 1 Peter',
    url: articlesRoot + '/introduction-to-the-book-of-1-peter',
    source: 'KJVSB'
  }, {
    title: 'The Church',
    url: articlesRoot + '/church',
    source: 'KJVSB',
    chapter: 2
  }],
  '2pe': [
  // 61
  {
    title: 'Introduction to the Book of 2 Peter',
    url: articlesRoot + '/introduction-to-the-book-of-2-peter',
    source: 'KJVSB'
  }],
  '1jn': [
  // 62
  {
    title: 'Introduction to the Book of 1 John',
    url: articlesRoot + '/introduction-to-the-book-of-1-john',
    source: 'KJVSB'
  }, {
    title: 'Assurance of Salvation',
    url: articlesRoot + '/assurance-salvation',
    source: 'KJVSB',
    chapter: 5
  }],
  '2jn': [
  // 63
  {
    title: 'Introduction to the Book of 2 John',
    url: articlesRoot + '/introduction-to-the-book-of-2-john',
    source: 'KJVSB'
  }],
  '3jn': [
  // 64
  {
    title: 'Introduction to the Book of 3 John',
    url: articlesRoot + '/introduction-to-the-book-of-3-john',
    source: 'KJVSB'
  }, {
    title: 'World Missions',
    url: articlesRoot + '/world-missions',
    source: 'KJVSB',
    chapter: 1
  }],
  jud: [
  // 65
  {
    title: 'Introduction to the Book of Jude',
    url: articlesRoot + '/introduction-to-the-book-of-jude',
    source: 'KJVSB'
  }],
  rev: [
  // 66
  {
    title: 'Introduction to the Book of Revelation',
    url: articlesRoot + '/introduction-to-the-book-of-revelation',
    source: 'KJVSB'
  }, {
    title: 'Hell',
    url: articlesRoot + '/hell',
    source: 'KJVSB',
    chapter: 14
  }, {
    title: 'Heaven',
    url: articlesRoot + '/heaven',
    source: 'KJVSB',
    chapter: 21
  }],
  none: [{
    url: articlesRoot + '/welcome',
    title: 'Welcome',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/alphabetical-list-of-the-books-of-the-bible',
    title: 'Alphabetical List of the Books of the Bible',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/abbreviations',
    title: 'Abbreviations',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/the-king-james-version-its-tradition-text-and-translation',
    title: 'The King James Version: Its Tradition, Text, and Translation',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/editors-contact-and-sources',
    title: 'Editors and Sources',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/only-true-god',
    title: 'The Only True God',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-names',
    title: 'God’s Names',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/trinity',
    title: 'The Trinity',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-eternity',
    title: 'God’s Eternity',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-immutability',
    title: 'God’s Immutability',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-foreknowledge',
    title: 'God’s Foreknowledge',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-wisdom',
    title: 'God’s Wisdom',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-holiness-ours',
    title: 'God’s Holiness and Ours',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-love-justice',
    title: 'God’s Love and Justice',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-mercy',
    title: 'God’s Mercy',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-faithfulness',
    title: 'God’s Faithfulness',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/authority-inerrancy-scripture',
    title: 'The Authority and Inerrancy of Scripture',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/creation-gods-glory',
    title: 'Creation and God’s Glory',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/angels',
    title: 'Angels',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/image-of-god',
    title: 'The Image of God',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/soul',
    title: 'The Soul',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/satan',
    title: 'Satan',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/fall-of-man',
    title: 'The Fall of Man',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/total-depravity',
    title: 'Total Depravity',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/human-responsibility',
    title: 'Human Responsibility',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/this-evil-world',
    title: 'This Evil World',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-covenants',
    title: 'God’s Covenants',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/angel-lord',
    title: 'The Angel of the Lord',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/son-of-david',
    title: 'The Son of David',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/offices-of-christ',
    title: 'The Offices of Christ',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/christs-incarnation',
    title: 'Christ’s Incarnation',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/christs-states',
    title: 'Christ’s States',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/christs-satisfaction-gods-justice',
    title: 'Christ’s Satisfaction of God’s Justice',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/christs-resurrection-ours',
    title: 'Christ’s Resurrection and Ours',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/christs-kingdom',
    title: 'Christ’s Kingdom',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/election',
    title: 'Election',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/uses-of-the-moral-law',
    title: 'The Uses of the Moral Law',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/holy-spirit',
    title: 'The Holy Spirit',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/calling-god',
    title: 'The Calling of God',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/regeneration',
    title: 'Regeneration',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/faith-in-god',
    title: 'Faith in God',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/justification-by-faith-alone',
    title: 'Justification by Faith Alone',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/adoption',
    title: 'Adoption',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/repentance',
    title: 'Repentance',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/experiential-knowledge',
    title: 'Experiential Knowledge',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/obedience-to-gods-will',
    title: 'Obedience to God’s Will',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/assurance-salvation',
    title: 'Assurance of Salvation',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/christian-discipleship',
    title: 'Christian Discipleship',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/spiritual-warfare',
    title: 'Spiritual Warfare',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/perseverance-of-the-saints',
    title: 'The Perseverance of the Saints',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/gods-dwelling-with-man',
    title: 'God’s Dwelling with Man',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/church',
    title: 'The Church',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/means-of-grace',
    title: 'The Means of Grace',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/worship-by-the-word',
    title: 'Worship by the Word',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/lords-supper',
    title: 'The Lord’s Supper',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/communion-saints',
    title: 'Communion of the Saints',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/world-missions',
    title: 'World Missions',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/canaan-inheritance',
    title: 'Canaan and the Inheritance',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/day-lord',
    title: 'The Day of the Lord',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/christs-coming-glory',
    title: 'Christ’s Coming in Glory',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/heaven',
    title: 'Heaven',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/hell',
    title: 'Hell',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/what-happened-between-the-testaments',
    title: 'What Happened Between the Testaments?',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/coming-to-christ',
    title: 'Coming to Christ',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/united-with-christ',
    title: 'United with Christ',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/experiencing-justification-and-adoption',
    title: 'Experiencing Justification and Adoption',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/growing-in-sanctification',
    title: 'Growing in Sanctification',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/assured-and-persevering',
    title: 'Assured and Persevering',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/reading-the-scriptures',
    title: 'Reading the Scriptures',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/why-and-how-we-pray',
    title: 'Why and How We Pray',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/worship-and-the-means-of-grace',
    title: 'Worship and the Means of Grace',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/fellowship-with-believers',
    title: 'Fellowship with Believers',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/how-we-regard-ourselves',
    title: 'How We Regard Ourselves',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/love-to-god',
    title: 'Love to God',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/the-fear-of-god',
    title: 'The Fear of God',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/living-by-the-ten-commandments',
    title: 'Living by the Ten Commandments',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/godly-contentment',
    title: 'Godly Contentment',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/self-denial',
    title: 'Self-Denial',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/humility',
    title: 'Humility',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/how-we-kill-pride',
    title: 'How We Kill Pride',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/coping-with-criticism',
    title: 'Coping with Criticism',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/enduring-affliction',
    title: 'Enduring Affliction',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/spiritual-desertion',
    title: 'Spiritual Desertion',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/fleeing-worldliness',
    title: 'Fleeing Worldliness',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/fighting-against-backsliding',
    title: 'Fighting against Backsliding',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/family-worship',
    title: 'Family Worship',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/being-a-christ-like-husband',
    title: 'Being a Christ-like Husband',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/being-a-godly-wife',
    title: 'Being a Godly Wife',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/showing-hospitality',
    title: 'Showing Hospitality',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/raising-children-in-the-lord',
    title: 'Raising Children in the Lord',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/being-a-christian-grandparent',
    title: 'Being a Christian Grandparent',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/honoring-your-parents',
    title: 'Honoring Your Parents',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/serving-god-at-work',
    title: 'Serving God at Work',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/using-leisure-time-well',
    title: 'Using Leisure Time Well',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/witnessing-for-christ',
    title: 'Witnessing for Christ',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/defending-our-faith',
    title: 'Defending Our Faith',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/facing-sickness-and-death',
    title: 'Facing Sickness and Death',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/living-positively',
    title: 'Living Positively',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/living-for-gods-glory',
    title: 'Living for God’s Glory',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-1st-century',
    title: 'First Century: Apostolic Foundations',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-2nd-century',
    title: 'Second Century: The Church of Martyrs and Confessors',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-3rd-century',
    title: 'The Third Century: Persecution and Heresy; Origen and Tertullian',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-4th-century',
    title: 'The Fourth Century: The Beginnings of the Christian Empire',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-5th-century',
    title: 'The Fifth Century: The City of God and the City of Man',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-6th-century',
    title: 'The Sixth Century: Justinian, Benedict, and the Conversion of the Scots',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-7th-century',
    title: 'The Seventh Century: Gregory the Great and the Rise of Islam',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-8th-century',
    title: 'The Eighth Century: The Iconoclastic Controversy',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-9th-century',
    title: 'The Ninth Century: Struggle for Power in the Church; Ratramnus and Gottschalk',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-10th-century',
    title: 'The Tenth Century: “The Dark Ages”',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-11th-century',
    title: 'The Eleventh Century: The Great Schism; Anselm of Canterbury ',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-12th-century',
    title: 'The Twelfth Century: The Crusades, Abelard, Lombard, and the Waldenses ',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-13th-century',
    title: 'The Thirteenth Century: Francis of Assisi and Thomas Aquinas',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-14th-century',
    title: 'The Fourteenth Century: The Church’s Babylonian Captivity and John Wycliffe ',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-15th-century',
    title: 'The Fifteenth Century: The Renaissance, Huss, Savonarola, and Groote',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-16th-century',
    title: 'The Sixteenth Century: Luther, Calvin, and the Reformation',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-17th-century',
    title: 'The Seventeenth Century: Reforming the Church in England',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-18th-century',
    title: 'The Eighteenth Century: The Great Awakening ',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-19th-century',
    title: 'The Nineteenth Century: Beginnings of Modern Theology and Kingdom Builders ',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/history-20th-century',
    title: 'The Twentieth Century: The Age of Paradoxes',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/apostles-creed',
    title: 'Apostles’ Creed',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/nicene-creed',
    title: 'Nicene Creed',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/athanasian-creed',
    title: 'Athanasian Creed',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/belgic-confession',
    title: 'Belgic Confession',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/heidelberg-catechism',
    title: 'Heidelberg Catechism',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/canons-of-dort',
    title: 'Canons of Dort',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/westminster-confession-of-faith',
    title: 'Westminster Confession',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/westminster-shorter-catechism',
    title: 'Westminster Shorter Catechism',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/westminster-larger-catechism',
    title: 'Westminster Larger Catechism',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/read-the-bible-in-a-year',
    title: 'Read the Bible in a Year',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/money-weights-and-measures',
    title: 'Money, Weights, and Measures',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance',
    title: 'Concordance',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/a',
    title: 'Concordance: A',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/b',
    title: 'Concordance: B',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/c',
    title: 'Concordance: C',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/d',
    title: 'Concordance: D',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/e',
    title: 'Concordance: E',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/f',
    title: 'Concordance: F',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/g',
    title: 'Concordance: G',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/h',
    title: 'Concordance: H',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/i',
    title: 'Concordance: I',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/j',
    title: 'Concordance: J',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/k',
    title: 'Concordance: K',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/l',
    title: 'Concordance: L',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/m',
    title: 'Concordance: M',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/n',
    title: 'Concordance: N',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/o',
    title: 'Concordance: O',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/p',
    title: 'Concordance: P',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/q',
    title: 'Concordance: Q',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/r',
    title: 'Concordance: R',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/s',
    title: 'Concordance: S',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/t',
    title: 'Concordance: T',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/u',
    title: 'Concordance: U',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/v',
    title: 'Concordance: V',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/w',
    title: 'Concordance: W',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/y',
    title: 'Concordance: Y',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/concordance/z',
    title: 'Concordance: Z',
    source: 'KJVSB'
  }, {
    url: articlesRoot + '/acknowledgements',
    title: 'Acknowledgements',
    source: 'KJVSB'
  }]
};

// The same data, but listed simply by URL, for easy lookup internally.
var byUrl = {};
for (var book in byLocation) {
  for (var idx in byLocation[book]) {
    var url = byLocation[book][idx].url;
    byUrl[url] = byLocation[book][idx];
  }
}

// Supply both means of organization as interfaces to the outline.
module.exports = { byLocation: byLocation, byUrl: byUrl };

},{}],16:[function(require,module,exports){
'use strict';

// Define the Bible outline for navigation. NOTE: these counts are valid *only*
// for the English Bible. If at some point we add the Hebrew, we will have to
// handle this differently.
module.exports = {
  'gen': { id: 'gen', order: 0, abbr: 'Gen', title: 'Genesis', numChapters: 50, section: 'Old Testament' },
  'exo': { id: 'exo', order: 1, abbr: 'Exo', title: 'Exodus', numChapters: 40, section: 'Old Testament' },
  'lev': { id: 'lev', order: 2, abbr: 'Lev', title: 'Leviticus', numChapters: 27, section: 'Old Testament' },
  'num': { id: 'num', order: 3, abbr: 'Num', title: 'Numbers', numChapters: 36, section: 'Old Testament' },
  'deu': { id: 'deu', order: 4, abbr: 'Deu', title: 'Deuteronomy', numChapters: 34, section: 'Old Testament' },
  'jos': { id: 'jos', order: 5, abbr: 'Jos', title: 'Joshua', numChapters: 24, section: 'Old Testament' },
  'jdg': { id: 'jdg', order: 6, abbr: 'Jdg', title: 'Judges', numChapters: 21, section: 'Old Testament' },
  'rth': { id: 'rth', order: 7, abbr: 'Rth', title: 'Ruth', numChapters: 4, section: 'Old Testament' },
  '1sa': { id: '1sa', order: 8, abbr: '1Sa', title: '1 Samuel', numChapters: 31, section: 'Old Testament' },
  '2sa': { id: '2sa', order: 9, abbr: '2Sa', title: '2 Samuel', numChapters: 24, section: 'Old Testament' },
  '1ki': { id: '1ki', order: 10, abbr: '1Ki', title: '1 Kings', numChapters: 22, section: 'Old Testament' },
  '2ki': { id: '2ki', order: 11, abbr: '2Ki', title: '2 Kings', numChapters: 25, section: 'Old Testament' },
  '1ch': { id: '1ch', order: 12, abbr: '1Ch', title: '1 Chronicles', numChapters: 29, section: 'Old Testament' },
  '2ch': { id: '2ch', order: 13, abbr: '2Ch', title: '2 Chronicles', numChapters: 36, section: 'Old Testament' },
  'ezr': { id: 'ezr', order: 14, abbr: 'Ezr', title: 'Ezra', numChapters: 10, section: 'Old Testament' },
  'neh': { id: 'neh', order: 15, abbr: 'Neh', title: 'Nehemiah', numChapters: 13, section: 'Old Testament' },
  'est': { id: 'est', order: 16, abbr: 'Est', title: 'Esther', numChapters: 10, section: 'Old Testament' },
  'job': { id: 'job', order: 17, abbr: 'Job', title: 'Job', numChapters: 42, section: 'Old Testament' },
  'psa': { id: 'psa', order: 18, abbr: 'Psa', title: 'Psalms', numChapters: 150, section: 'Old Testament' },
  'pro': { id: 'pro', order: 19, abbr: 'Pro', title: 'Proverbs', numChapters: 31, section: 'Old Testament' },
  'ecc': { id: 'ecc', order: 20, abbr: 'Ecc', title: 'Ecclesiastes', numChapters: 12, section: 'Old Testament' },
  'sng': { id: 'sng', order: 21, abbr: 'Sng', title: 'Song of Songs', numChapters: 8, section: 'Old Testament' },
  'isa': { id: 'isa', order: 22, abbr: 'Isa', title: 'Isaiah', numChapters: 66, section: 'Old Testament' },
  'jer': { id: 'jer', order: 23, abbr: 'Jer', title: 'Jeremiah', numChapters: 52, section: 'Old Testament' },
  'lam': { id: 'lam', order: 24, abbr: 'Lam', title: 'Lamentations', numChapters: 5, section: 'Old Testament' },
  'ezk': { id: 'ezk', order: 25, abbr: 'Ezk', title: 'Ezekiel', numChapters: 48, section: 'Old Testament' },
  'dan': { id: 'dan', order: 26, abbr: 'Dan', title: 'Daniel', numChapters: 12, section: 'Old Testament' },
  'hos': { id: 'hos', order: 27, abbr: 'Hos', title: 'Hosea', numChapters: 14, section: 'Old Testament' },
  'jol': { id: 'jol', order: 28, abbr: 'Jol', title: 'Joel', numChapters: 3, section: 'Old Testament' },
  'amo': { id: 'amo', order: 29, abbr: 'Amo', title: 'Amos', numChapters: 9, section: 'Old Testament' },
  'oba': { id: 'oba', order: 30, abbr: 'Oba', title: 'Obadiah', numChapters: 1, section: 'Old Testament' },
  'jon': { id: 'jon', order: 31, abbr: 'Jon', title: 'Jonah', numChapters: 4, section: 'Old Testament' },
  'mic': { id: 'mic', order: 32, abbr: 'Mic', title: 'Micah', numChapters: 7, section: 'Old Testament' },
  'nam': { id: 'nam', order: 33, abbr: 'Nam', title: 'Nahum', numChapters: 3, section: 'Old Testament' },
  'hab': { id: 'hab', order: 34, abbr: 'Hab', title: 'Habakkuk', numChapters: 3, section: 'Old Testament' },
  'zep': { id: 'zep', order: 35, abbr: 'Zep', title: 'Zephaniah', numChapters: 3, section: 'Old Testament' },
  'hag': { id: 'hag', order: 36, abbr: 'Hag', title: 'Haggai', numChapters: 2, section: 'Old Testament' },
  'zec': { id: 'zec', order: 37, abbr: 'Zec', title: 'Zechariah', numChapters: 14, section: 'Old Testament' },
  'mal': { id: 'mal', order: 38, abbr: 'Mal', title: 'Malachi', numChapters: 4, section: 'Old Testament' },

  'mat': { id: 'mat', order: 39, abbr: 'Mat', title: 'Matthew', numChapters: 28, section: 'New Testament' },
  'mrk': { id: 'mrk', order: 40, abbr: 'Mrk', title: 'Mark', numChapters: 16, section: 'New Testament' },
  'luk': { id: 'luk', order: 41, abbr: 'Luk', title: 'Luke', numChapters: 24, section: 'New Testament' },
  'jhn': { id: 'jhn', order: 42, abbr: 'Jhn', title: 'John', numChapters: 21, section: 'New Testament' },
  'act': { id: 'act', order: 43, abbr: 'Act', title: 'Acts', numChapters: 28, section: 'New Testament' },
  'rom': { id: 'rom', order: 44, abbr: 'Rom', title: 'Romans', numChapters: 16, section: 'New Testament' },
  '1co': { id: '1co', order: 45, abbr: '1Co', title: '1 Corinthians', numChapters: 16, section: 'New Testament' },
  '2co': { id: '2co', order: 46, abbr: '2Co', title: '2 Corinthians', numChapters: 13, section: 'New Testament' },
  'gal': { id: 'gal', order: 47, abbr: 'Gal', title: 'Galatians', numChapters: 6, section: 'New Testament' },
  'eph': { id: 'eph', order: 48, abbr: 'Eph', title: 'Ephesians', numChapters: 6, section: 'New Testament' },
  'php': { id: 'php', order: 49, abbr: 'Php', title: 'Philippians', numChapters: 4, section: 'New Testament' },
  'col': { id: 'col', order: 50, abbr: 'Col', title: 'Colossians', numChapters: 4, section: 'New Testament' },
  '1th': { id: '1th', order: 51, abbr: '1Th', title: '1 Thessalonians', numChapters: 5, section: 'New Testament' },
  '2th': { id: '2th', order: 52, abbr: '2Th', title: '2 Thessalonians', numChapters: 3, section: 'New Testament' },
  '1ti': { id: '1ti', order: 53, abbr: '1Ti', title: '1 Timothy', numChapters: 6, section: 'New Testament' },
  '2ti': { id: '2ti', order: 54, abbr: '2Ti', title: '2 Timothy', numChapters: 4, section: 'New Testament' },
  'tit': { id: 'tit', order: 55, abbr: 'Tit', title: 'Titus', numChapters: 3, section: 'New Testament' },
  'phm': { id: 'phm', order: 56, abbr: 'Phm', title: 'Philemon', numChapters: 1, section: 'New Testament' },
  'heb': { id: 'heb', order: 57, abbr: 'Heb', title: 'Hebrews', numChapters: 13, section: 'New Testament' },
  'jas': { id: 'jas', order: 58, abbr: 'Jas', title: 'James', numChapters: 5, section: 'New Testament' },
  '1pe': { id: '1pe', order: 59, abbr: '1Pe', title: '1 Peter', numChapters: 5, section: 'New Testament' },
  '2pe': { id: '2pe', order: 60, abbr: '2Pe', title: '2 Peter', numChapters: 3, section: 'New Testament' },
  '1jn': { id: '1jn', order: 61, abbr: '1Jn', title: '1 John', numChapters: 5, section: 'New Testament' },
  '2jn': { id: '2jn', order: 62, abbr: '2Jn', title: '2 John', numChapters: 1, section: 'New Testament' },
  '3jn': { id: '3jn', order: 63, abbr: '3Jn', title: '3 John', numChapters: 1, section: 'New Testament' },
  'jud': { id: 'jud', order: 64, abbr: 'Jud', title: 'Jude', numChapters: 1, section: 'New Testament' },
  'rev': { id: 'rev', order: 65, abbr: 'Rev', title: 'Revelation', numChapters: 22, section: 'New Testament' }
};

},{}],17:[function(require,module,exports){
'use strict';

module.exports = {
  'typesize': {
    'order': 0,
    'id': 'typesize',
    'description': 'Type Size',
    'type': 'iterable',
    'active': false,
    'popup': true,
    'options': {
      'micro': { 'order': 0, 'id': 'micro', 'description': 'Micro', 'active': false, 'class': 'type-micro' },
      'tiny': { 'order': 1, 'id': 'tiny', 'description': 'Tiny', 'active': false, 'class': 'type-tiny' },
      'small': { 'order': 2, 'id': 'small', 'description': 'Small', 'active': false, 'class': 'type-small' },
      'normal': { 'order': 3, 'id': 'normal', 'description': 'Normal', 'active': true, 'class': 'type-normal' },
      'large': { 'order': 4, 'id': 'large', 'description': 'Large', 'active': false, 'class': 'type-large' },
      'huge': { 'order': 5, 'id': 'huge', 'description': 'Huge', 'active': false, 'class': 'type-huge' },
      'mega': { 'order': 6, 'id': 'mega', 'description': 'Mega', 'active': false, 'class': 'type-mega' }
    },
    'currentOption': 'normal',
    'defaultOption': 'normal',
    'maxOption': 'mega',
    'minOption': 'micro',
    'numOptions': 7
  },
  'lineheight': {
    'order': 1,
    'id': 'lineheight',
    'description': 'Line Height',
    'type': 'iterable',
    'active': false,
    'popup': true,
    'options': {
      'tiny': { 'order': 0, 'id': 'tiny', 'description': 'Tiny', 'active': false, 'class': 'lh-tiny' },
      'small': { 'order': 1, 'id': 'small', 'description': 'Small', 'active': false, 'class': 'lh-small' },
      'normal': { 'order': 2, 'id': 'normal', 'description': 'Normal', 'active': true, 'class': 'lh-normal' },
      'large': { 'order': 3, 'id': 'large', 'description': 'Large', 'active': false, 'class': 'lh-large' },
      'huge': { 'order': 4, 'id': 'huge', 'description': 'Huge', 'active': false, 'class': 'lh-huge' }
    },
    'currentOption': 'normal',
    'defaultOption': 'normal',
    'maxOption': 'huge',
    'minOption': 'tiny',
    'numOptions': 5
  },
  'contrast': {
    'order': 2,
    'id': 'contrast',
    'description': 'Contrast',
    'class': 'contrast',
    'type': 'choosable',
    'active': false,
    'popup': true,
    'options': {
      'light': { 'order': 0, 'id': 'light', 'description': 'Light', 'active': false, 'class': 'light' },
      'sepia': { 'order': 1, 'id': 'sepia', 'description': 'Sepia', 'active': true, 'class': 'sepia' },
      'dark': { 'order': 2, 'id': 'dark', 'description': 'Dark', 'active': false, 'class': 'dark' }
    },
    'currentOption': 'light',
    'numOptions': 3
  },
  'reading': {
    'order': 3,
    'id': 'reading',
    'description': 'Reading Mode',
    'type': 'togglable',
    'popup': false,
    'active': false
  }
};

},{}],18:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/16/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

// The Browserify package includes all modules here.

require('./settings-controller');

},{"./settings-controller":19}],19:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/8/14
 * License: All rights reserved.
 * Copyright: 2014 Puritan Reformed Theological Seminary
 */

// Define requirements for Browserify.

require('../app-controller');

/**
 * Search for a key in an object for a given value at a given attribute.
 * @param {Object} obj The object to search.
 * @param {string} attr
 * @param {vary} value
 * @returns {string}
 */
function keyFromObjByAttr(obj, attr, value) {
  for (var key in obj) {
    if (obj[key][attr] === value) {
      return key;
    }
  }
}

function SettingsController($scope, $rootScope, $timeout) {
  var READING_SETTINGS_EVENT = 'hbReadingSettingsChanged';
  var READING_SETTINGS_POPUP = 'hbReadingPopupToggled';

  function readingSettingIsPopup(setting) {
    return setting.type === 'choosable' || setting.type === 'iterable';
  }

  // Handle global popup value.
  $scope.popupsInactive = true;
  function managePopupContainer() {
    // Check whether any of the settings are active.
    for (var setting in $scope.readingSettings) {
      if (readingSettingIsPopup($scope.readingSettings[setting])) {
        if ($scope.readingSettings[setting].active) {
          $scope.popupsInactive = false;
          return;
        }
      }
    }

    // If we made it this far, none of the settings were active. Delay setting
    // the class because of a quirky interplay between the container and child
    // elements in terms of how the animations render.
    $timeout(function () {
      $scope.popupsInactive = true;
    }, 501);
  }

  $scope.$on(READING_SETTINGS_POPUP, managePopupContainer);

  /* Turn a settings button on or off, with corresponding changes for
   * associated popups. */
  $scope.toggleSetting = function toggleSetting(setting) {
    setting.active = !setting.active;
    if (readingSettingIsPopup(setting)) {
      for (var otherSetting in $scope.readingSettings) {
        if ($scope.readingSettings[otherSetting] !== setting && $scope.readingSettings[otherSetting].popup) {

          $scope.readingSettings[otherSetting].active = false;
        }
      }

      $scope.$broadcast(READING_SETTINGS_POPUP);
    } else {
      $rootScope.$broadcast(READING_SETTINGS_EVENT);
    }
  };

  /* Iterate over settings options by setting order. */
  $scope.iterateOption = function iterateOption(setting, direction) {
    var currentOption = setting.currentOption;
    var maxPosition = setting.numOptions - 1;
    var minPosition = 0;

    var currentPosition = setting.options[currentOption].order;
    var newPosition = currentPosition;

    // Prevent the options from going out of bounds.
    if (direction === 'upward') {
      if (currentPosition !== maxPosition) {
        newPosition = currentPosition + 1;
      }
    } else if (direction === 'downward') {
      if (currentPosition !== minPosition) {
        newPosition = currentPosition - 1;
      }
    } else {
      var err = 'Invalid direction of iteration ' + direction + '  for SettingsController::iterateOption.';
      throw new Error(err);
    }

    // Update the currently selected option if it should change.
    if (newPosition !== currentPosition) {
      var newOption = keyFromObjByAttr(setting.options, 'order', newPosition);
      $scope.readingSettings[setting.id].options[currentOption].active = false;
      $scope.readingSettings[setting.id].options[newOption].active = true;
      $scope.readingSettings[setting.id].currentOption = newOption;

      $rootScope.$broadcast(READING_SETTINGS_EVENT);
    }
  };

  /* For options where there is a selection. */
  $scope.chooseOption = function (setting, option) {
    $scope.readingSettings[setting.id].currentOption = option.id;
  };
}

// Define a controller for the Settings panel.
angular.module('app').controller('SettingsController', [
// Inject dependencies. AngularJS:
'$scope', '$rootScope', '$timeout',
// Supply the constructor.
SettingsController]);

},{"../app-controller":3}],20:[function(require,module,exports){
"use strict";

angular.module("app").run(["$templateCache", function ($templateCache) {
  $templateCache.put("navigation/navigation.html", "<section id=\"nav-logo\" data-ng-controller=\"SiteNavController\" data-ng-click=\"clickLogo()\">\n    <div class=\"icon-wrap button\">\n        <svg class=\'svg icon\'><use xlink:href=\'#logo-shape\'/></svg>\n        <div class=\'svg-fallback icon\'></div>\n    </div>\n    <span id=\"sitetitle\">HolyBible.com</span>\n</section>\n\n<section id=\"sitenav\" class=\"navigation menu inactive\"\n    data-ng-controller=\"SiteNavController\"\n    data-ng-class=\"{active: sitenav.active, inactive: !(sitenav.active)}\">\n    <ul>\n        <li data-ng-repeat=\"page in siteOutline.pages | orderObjectBy: \'order\' | filter:{menu: true, show: true}\">\n            <a data-ng-href=\"{{siteOutline.getUrl(page)}}\"\n               data-ng-click=\"siteOutline.runClick(page)\"\n               data-ng-attr-id=\"{{siteOutline.getId(page)}}\">\n              {{page.title}}\n            </a>\n        </li>\n    </ul>\n    <div class=\'close button\' data-ng-click=\"sitenav.toggleActive(false)\">\n        <label class=\'icon-label\'>Close</label>\n        <div class=\'icon-wrap\' id=\'settings-close\'>\n            <svg class=\'svg icon\'><use xlink:href=\'#close-icon\'/></svg>\n            <div class=\'svg-fallback icon\' data-src=\"#close-icon\"></div>\n        </div>\n    </div>\n</section>\n\n<section role=\'search\' id=\'search\'>\n    <form ng-submit=\"searchPassage(searchField.text)\">\n        <label class=\'visuallyhidden\' for=\"searchfield\">Navigate to passage</label>\n\n        <div class=\"input-wrap\" data-ng-class=\"{focused: menu.active}\">\n            <input id=\"searchfield\"\n                   type=\"text\"\n                   placeholder=\"Search the Bible\"\n                   data-ng-readonly=\"!menu.textEditable\"\n                   data-ng-model=\"searchField.text\"\n                   data-ng-focus=\"menu.toggleActive(true)\">\n            <div class=\"ios-fixed-input-text-field\" id=\"searchfield-ios\"\n                 data-ng-click=\"menu.toggleActive()\">\n            </div>\n            <div class=\"icon-wrap search button\" data-ng-click=\"searchPassage(searchField.text)\">\n                <svg class=\"svg icon\"><use xlink:href=\"#search-icon\"></use></svg>\n            </div>\n        </div>\n\n        <input type=\"submit\" class=\"visuallyhidden\"/>\n    </form>\n</section>\n\n<section id=\"booknav\" class=\"navigation menu inactive\"\n         data-ng-class=\"{\'active\': menu.active, \'inactive\': !menu.active }\">\n    <div class=\'close button\' data-ng-click=\"menu.toggleActive(false)\">\n        <label class=\'icon-label\'>Close</label>\n        <div class=\'icon-wrap\' id=\'menu-close\'>\n            <svg class=\'svg icon\'><use xlink:href=\'#close-icon\'/></svg>\n            <div class=\'svg-fallback icon\' data-src=\"#close-icon\"></div>\n        </div>\n    </div>\n    <ul data-ng-if=\"!menu.current.book\">\n        <li class=\"bible-section\" data-ng-repeat=\"section in menu.sections\">\n            <h2>{{section}}</h2>\n            <ul class=\"location-chooser\">\n                <li class=\"location-chooser-item\"\n                    data-ng-repeat=\"book in menu.outline | filterBySection: section | orderObjectBy: \'order\'\">\n                    <a data-ng-click=\"requestBook(book.id)\">{{book.abbr}}</a>\n                </li>\n            </ul>\n        </li>\n    </ul>\n    <div class=\"back button\" data-ng-if=\"menu.current.book\" data-ng-click=\"cancelBookRequest()\">\n        <label class=\"icon-label\">Back</label>\n        <div class=\"icon-wrap\" id=\"chapters-back\">\n            <svg class=\"svg icon\"><use xlink:href=\"#back-icon\"/></svg>\n            <div class=\"svg-fallback icon\" data-src=\"#back-icon\"></div>\n        </div>\n    </div>\n    <h2>{{menu.outline[menu.current.book].title}}</h2>\n    <ul data-ng-if=\"menu.current.book\" class=\"location-chooser\">\n        <li class=\"location-chooser-item\"\n            data-ng-repeat=\"chapter in [] | range: menu.current.numChapters : 1 : true\">\n            <a data-ng-click=\"requestChapter(chapter)\">{{chapter}}</a>\n        </li>\n    </ul>\n</section>\n<section class=\"spacer\"></section>\n");
  $templateCache.put("main/bible.html", "<ng-include data-ng-if=\"showWelcome\" src=\"templates.welcome\"></ng-include>\n\n<div cg-busy=\'loadingPromise\'></div>\n\n<div class=\"book-nav single before\">\n  <a class=\"back book button\" ng-if=\"prev\" ng-href=\"{{prev}}.1.1\">\n    <div class=\"icon-wrap\" id=\"book-back-before\">\n      <svg class=\"svg icon\"><use xlink:href=\"#back-icon\"/></svg>\n      <div class=\"svg-fallback icon\" data-src=\"#back-icon\"></div>\n    </div>\n    {{outline[prev].title}}\n  </a>\n  <a class=\"forward book button\" ng-if=\"next\" ng-href=\"{{next}}.1.1\">\n    {{outline[next].title}}\n    <div class=\"icon-wrap\" id=\"book-forward-before\">\n      <svg class=\"svg icon\"><use xlink:href=\"#forward-icon\"/></svg>\n      <div class=\"svg-fallback icon\" data-src=\"#forward-icon\"></div>\n    </div>\n  </a>\n</div>\n\n<article class=\"book single\" id=\"{{passageInfo.id}}\"\n         data-ng-class=\"sbAccess\"\n         data-ng-controller=\"BookContentController\"\n         data-ng-bind-html=\"passage.book | trusted\"\n         data-hb-related-articles=\"{{passageInfo.id}}\"\n         data-hb-text-notes=\"{{passageInfo.id}}\">\n</article>\n\n<div id=\"text-notes\" data-ng-controller=\"BookContentController\">\n  <div data-ng-repeat=\"note in textNotes\"\n       data-ng-bind-html=\"note.content | trusted\"\n       data-ng-show=\"note.visible\"\n       id=\"{{note.id}}\">\n  </div>\n</div>\n\n<div class=\"book-nav single after\">\n  <a class=\"back book button after\" ng-if=\"prev\" ng-href=\"{{prev}}.1.1\">\n    <div class=\"icon-wrap\" id=\"book-back-after\">\n      <svg class=\"svg icon\"><use xlink:href=\"#back-icon\"/></svg>\n      <div class=\"svg-fallback icon\" data-src=\"#back-icon\"></div>\n    </div>\n    {{outline[prev].title}}\n  </a>\n  <a class=\"forward book button after\" ng-if=\"next\" ng-href=\"{{next}}.1.1\">\n    {{outline[next].title}}\n    <div class=\"icon-wrap\" id=\"book-forward-after\">\n      <svg class=\"svg icon\"><use xlink:href=\"#forward-icon\"/></svg>\n      <div class=\"svg-fallback icon\" data-src=\"#forward-icon\"></div>\n    </div>\n  </a>\n</div>\n");
  $templateCache.put("main/welcome.html", "<aside id=\"welcome-message\" class=\"non-bible single\">\n  <h2>Welcome!</h2>\n  <p>\n\n    Welcome to HolyBible.com, a project by <a href=\"http://prts.edu\" >Puritan\n    Reformed Theological Seminary!</a> We are delighted you’ve chosen to read\n    the Bible here. If you are looking to redeem your access code for the\n    Reformation Heritage KJV Study Bible, <a href=\"/user/sign-in\">create a new\n    account or sign into an existing account</a> and redeem your code on your <a\n    href=\"/user/profile\">profile</a>.\n\n  </p>\n  <p>\n\n    For more information on access to the study Bible, please see the\n    <a href=\"/pages/rhkjvsb-info\">information page</a>.\n\n  </p>\n\n  <button class=\"normal-button\" data-ng-click=\'hideWelcome()\'>Dismiss</button>\n  <hr/>\n</aside>\n");
  $templateCache.put("settings/settings.html", "\n<section class=\'wrap popups\' ng-class=\'{\"all-inactive\": popupsInactive}\'>\n\n    <div ng-repeat=\'setting in readingPopupSettings | orderObjectBy: \"order\"\'\n         class=\'popup item-{{$index}}\'\n         ng-class=\'{\"active\":setting.active, \"inactive\":!setting.active}\'\n         id=\'{{setting.id}}-popup\'>\n\n        <div class=\'close button\' ng-click=\"toggleSetting(setting)\">\n            <label class=\'icon-label\'>Close</label>\n            <div class=\'icon-wrap\'>\n                <svg class=\'svg icon\'><use xlink:href=\'#close-icon\'/></svg>\n                <div class=\'svg-fallback icon\'data-src=\"#close-icon\"></div>\n            </div>\n        </div>\n\n        <div class=\'switcher\' ng-if=\"setting.type == \'iterable\'\">\n            <div class=\'button larger {{setting.id}}\' id=\'{{setting.id}}-larger-button\'\n                 ng-click=\"iterateOption(setting, \'upward\')\">\n                <div class=\'icon-wrap\'>\n                    <svg class=\'svg icon\'><usesvg useid=\"{{setting.id}}-icon\"></svg>\n                    <div class=\'svg-fallback icon\'></div>\n                </div>\n                <div class=\"icon-wrap size\">\n                    <svg class=\"svg icon\"><use xlink:href=\"#size-up\"/></svg>\n                    <div class=\'svg-fallback icon\'></div>\n                </div>\n            </div>\n\n            <label class=\'icon-label unselected\'\n                   ng-class=\'{\"selected\":option.active, \"unselected\":!option.active}\'\n                   ng-repeat=\'option in setting.options | orderObjectBy: \"order\"\'>\n                {{option.description}}\n            </label>\n\n            <div class=\'button smaller {{setting.id}}\' id=\'{{setting.id}}-smaller-button\'\n                 ng-click=\"iterateOption(setting, \'downward\')\">\n                <div class=\'icon-wrap\'>\n                    <svg class=\'svg icon\'><usesvg useid=\"{{setting.id}}-icon\"/></svg>\n                    <div class=\'svg-fallback icon\'></div>\n                </div>\n                <div class=\"icon-wrap size\">\n                    <svg class=\"svg icon\"><use xlink:href=\"#size-down\"/></svg>\n                    <div class=\'svg-fallback icon\'></div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\'switcher\' ng-if=\"setting.type == \'choosable\'\">\n            <div ng-repeat=\"option in setting.options | orderObjectBy: \'order\'\"\n                 ng-click=\"chooseOption(setting, option)\"\n                 class=\'button contrast\' ng-class=\"option.id\"\n                 id=\'contrast-{{option.id}}-button\'>{{option.description}}</div>\n        </div>\n    </div>\n\n    <div class=\'popup inactive spacer\' id=\'popup-spacer\'></div>\n</section>\n\n<section class=\'wrap items\'>\n    <div ng-repeat=\'setting in readingSettings | orderObjectBy: \"order\"\' class=\'button\'\n         ng-click=\"toggleSetting(setting)\" ng-class=\"{\'active\': setting.active}\"\n         id=\"{{setting.id}}\">\n        <div class=\'icon-wrap\'>\n            <svg class=\"svg icon\"><usesvg useid=\"{{setting.id}}-icon\"/></svg>\n            <div class=\'svg-fallback icon\'></div>\n        </div>\n        <label class=\'icon-label\' for=\'{{setting.id}}\'>{{setting.description}}</label>\n    </div>\n\n    <div class=\'close button\' ng-click=\"\">\n        <label class=\'icon-label\'>Close</label>\n        <div class=\'icon-wrap\' id=\'settings-close\'>\n            <svg class=\'svg icon\'><use xlink:href=\'#close-icon\'/></svg>\n            <div class=\'svg-fallback icon\' data-src=\"#close-icon\"></div>\n        </div>\n    </div>\n</section>\n");
  $templateCache.put("res/svg-defs.svg", "<svg xmlns=\"http://www.w3.org/2000/svg\" style=\"display: none;\"><defs>\n    <symbol id=\"back-icon\" viewBox=\"0 0 24 64\">\n        <title>Backward action icon</title>\n        <desc>Move backward in a navigation tree.</desc>\n        <path d=\"M24 16l-15.875 16 15.875 16-4 4-20-20 20-20z\"></path>\n    </symbol>\n\n    <symbol id=\"forward-icon\" viewBox=\"0 0 24 64\">\n        <title>Forward action icon</title>\n        <desc>Move backward in a navigation tree.</desc>\n        <path d=\"M0 16l4-4 20 20-20 20-4-4 15.875-16z\"></path>\n    </symbol>\n\n    <symbol id=\"close-icon\" viewBox=\"274 364 64 64\"\n            enable-background=\"new 274 364 64 64\">\n        <circle cx=\"306\" cy=\"396\" r=\"16.3\"/>\n        <path d=\"M299.3 389.3l13.4 13.4m0-13.4l-13.4 13.4\"/>\n    </symbol>\n\n    <symbol id=\"contrast-icon\" viewBox=\"0 0 256 256\">\n        <title>Contrast icon</title>\n        <desc>Toggle view of the text contrast menu.</desc>\n        <path d=\"M91.7 139.1c0 2.4 1.5 3.7 3.3 3.7 2.3 0 5.2-2.3 6.7-3.6v-7l-1.8.3c-3.4.5-8.2 2.3-8.2 6.6zm35.9-17.7c-2.6 0-5.1 1.4-5.9 2.2V143s1.8.8 4.3.8c5.8 0 9.7-4.5 9.7-11.2 0-5.6-2.8-11.2-8.1-11.2zM235 75.3H18.7c-4.6 0-8.3 3.7-8.3 8.3v89c0 4.6 3.7 8.3 8.3 8.3H235c4.6 0 8.3-3.7 8.3-8.3v-89c.1-4.6-3.6-8.3-8.3-8.3zm-129.1 70.9c-2.3 0-4-1.3-4-4.2v-1.4s-3.2 5.6-9.3 5.6c-3.9 0-6.2-2.8-6.2-6 0-5.7 7.1-8.7 13.3-9.6l2-.3c.1-1.2.1-4.7-.2-6.4-.4-2.2-1.5-3.8-3.7-3.8-4 0-6.3 5.7-6.3 5.7h-1.9l-1-4.5s4.3-3.3 11-3.3c5.6 0 7.1 2.3 7.1 8.5v13.7c0 1.9.2 2.8 1.6 2.8 1.6 0 3.3-1.2 3.3-1.2l.8 1.2c-.2 0-3 3.2-6.5 3.2zm19.6 0c-3.2 0-7-.7-9.1-.7l-.2-.2s.5-2.6.5-5.9v-29.5c0-2.6-.1-4-1.8-4h-2.5v-1.6c6.8-1.5 9.6-2.7 9.6-2.7l.2.2s-.6 2.2-.6 6.8v9.5c0 2.7-.2 3.9-.2 4.4 1.6-2 4-4.4 8.4-4.4 7.3 0 11 6.4 11 13 0 7.3-4.9 15.1-15.3 15.1zm32.4 0c-8.3 0-12.6-6.7-12.6-13.5 0-7.2 4.5-14.6 12.7-14.6 3.6 0 9.4 1.4 9.4 4.5 0 1.1-.8 2.1-2.3 2.1-3 0-3.4-4.6-7.5-4.6-4.8 0-7.4 5.1-7.4 10.9 0 5.7 2.8 11.3 9.8 11.3 4.5 0 6.9-2.4 6.9-2.4l.7 1.3c-.1-.2-2.8 5-9.7 5z\" />\n    </symbol>\n\n    <symbol id=\"lineheight-icon\" viewBox=\"0 0 256 256\">\n        <title>Line height icon</title>\n        <desc>Toggle view of the line height menu.</desc>\n        <path d=\"M33 98h188.7v8.3H33zm0 50.7h188.7v8.3H33z\"/>\n    </symbol>\n\n    <symbol id=\"logo-shape\" viewBox=\"0 0 256 256\">\n        <title>Logo</title>\n        <desc>The HolyBible.com logo: sunrise breaking over an open book (the Bible).</desc>\n        <path id=\"logo-light\" d=\"M172.1 116.3l5.1-4.1-12.5-.5 32-26.3-41.4 18.4 11-20.1L148 96l12.2-37.5L138.8 91l.1-36.2-10.3 34.4L114 36.1l4.3 54.9-22.2-34.9 13 39.9-18.3-12.4 11 20.1-42.5-19.2 32.8 26.9-10.4.8 4.4 3.9c13.1-1.6 27.4-2.7 42.4-2.7 15.4 0 30.1 1.2 43.6 2.9z\"/>\n        <path id=\"logo-book\" d=\"M199.9 219.9c-47.4-9.8-96.4-9.8-143.8 0-6-28.9-12-57.7-17.9-86.6 59.3-12.3 120.4-12.3 179.7 0-6 28.9-12 57.8-18 86.6z\"/>\n    </symbol>\n\n    <symbol id=\"reading-icon\" viewBox=\"0 0 256 256\">\n        <title>Reading mode icon</title>\n        <desc>Toggle reading mode: hide all textual metadata, e.g. chapter and verse numbers or references.</desc>\n        <path d=\"M198.5 175c-46.5-9.6-94.5-9.6-141.1 0-5.9-28.3-11.7-56.6-17.6-84.9C98 78 158 78 216.1 90c-5.8 28.4-11.7 56.7-17.6 85z\"/>\n    </symbol>\n\n    <symbol id=\"search-icon\" viewBox=\"32 168 448 448\">\n        <title>Search icon</title>\n        <desc>Search for the specified passage or resource.</desc>\n        <circle cx=\"240.8\" cy=\"344.1\" r=\"101.8\"/>\n        <path d=\"M294.1 430.4L389 557.8\"/>\n    </symbol>\n\n    <symbol id=\"size-down\" viewBox=\"0 0 40 64\">\n        <title>Decrease size icon.</title>\n        <desc>Decrease the size of a given property.</desc>\n        <path d=\"M0.375 23.125c-0.25-0.25-0.375-0.75-0.375-1.125 0-1.125 1-2 2.125-2v0h35.75c1.125 0 2.125 0.875 2.125 2 0 0.375-0.125 0.75-0.375 1l-0.25 0.375-17 19.5c-0.625 0.625-1.375 1.125-2.375 1.125s-1.75-0.5-2.375-1.125l-17-19.5z\"/>\n    </symbol>\n\n    <symbol id=\"size-up\" viewBox=\"0 0 40 64\">\n        <title>Increase size icon.</title>\n        <desc>Increase the size of a given property.</desc>\n        <path d=\"M39.625 40.875c0.25 0.25 0.375 0.75 0.375 1.125 0 1.125-1 2-2.125 2v0h-35.75c-1.125 0-2.125-0.875-2.125-2 0-0.375 0.125-0.75 0.375-1l0.25-0.375 17-19.5c0.625-0.625 1.375-1.125 2.375-1.125s1.75 0.5 2.375 1.125l17 19.5z\"/>\n    </symbol>\n\n    <symbol id=\"typesize-icon\" viewBox=\"0 0 256 256\">\n        <title>Type size icon</title>\n        <desc>Toggle view of the font size menu.</desc>\n        <path d=\"M116.1 173c6.3-.6 8.8-3.7 10-6.7l35.3-87.9 6.1-1.3 33.1 84.6c4 10.1 6.7 10.9 11.3 11.6l-.6 4h-6.4c-5.5 0-22.6.4-22.6.4v-5.1c4.2-.1 7.9-1.3 6.3-5.8l-9.1-23.8h-35.6l-1.9 1.5-10.3 26.8 12.7 1.8-.6 4.2h-27.6V173zm45.1-79.2l-16.5 43.1H177l-12.8-34c-1.2-3-2.4-6.9-3-9.1zM43.3 174.4c4.3-.4 6-2.5 6.8-4.6l24-59.8 4.2-.9 22.5 57.6c2.7 6.9 4.6 7.4 7.7 7.9l-.4 2.7h-4.4c-3.8 0-15.4.3-15.4.3v-3.4c2.8-.1 5.4-.9 4.3-4L86.4 154H62.1l-1.3 1-7 18.3 8.6 1.2-.4 2.8H43.3v-2.9zm30.7-54l-11.3 29.3h22L76 126.6c-.8-2-1.6-4.6-2-6.2z\"/>\n    </symbol>\n\n    <symbol id=\"prtslogo-shape\" viewBox=\"0 0 792 153.36\">\n        <title>Puritan Reformed Theological Seminary Logo</title>\n        <desc>Logo for PRTS</desc>\n        <path stroke=\"#000\" stroke-width=\"3\" d=\"M39.667 14.346s-16 .833-16.5 2.667 11.333 9.5 11.333 9.5v3l-.167 1.333H23.167s-3.833 1.667-3.833 3.333 3.5 4.164 3.333 4.164S23 42.51 23 42.51l-1.333 1 .667 1.334.333 15.167-1.167 2.67-.167 1.667-.167 17.167s.927 1.468.833 1.833-1.336 1-1.336 1-.417.416-.167 1 2.666 1.167 2.666 1.167-.02 1.27.5 2 1.334.332 1.334.332 1.333.334 3 1.167 1.5.332 2.5 1.166l1 .83h2.167s1.833.667 1.833 1.167 2.5 1.166 2.5 1.166h3.667L59 93.68s19.037-7.045 19.685-8.19S77 83.514 77 83.514V62.68l-2.333-2.833.5-16-.667-2.834.167-4.333s4.167-2.167 4-3.5-8.5-3.5-8.5-3.5H38.5s0-.667.833-2.667 5.833-5.167 7.333-4.167 2.167-1.333 2.167-1.333-1.833-2-2.333-2.333-6.833-4.834-6.833-4.834zM42.09 94.33v22.6s-1.505 1.5-.84 2.5.42 1.417.335 1.584S38 123.598 38 123.598s-1.916.25-1.666 1.416 1.25 1.167 1.417 1.917c.06.26-.04.626-.242.954-.388.628-1.155 1.123-1.922.466-1.167-1 1.25 3.415 1.25 3.415l1.083 2.084 1.416.58 8 2.25 10.25-1.915 4.5-3.75v-2.833l-1.417-1.332.416-2.083s0-.75-.75-1.083-3.917-4-3.917-4l-.168-1.332-1-20.834 1-3.167m-18.744 33.53l10.162 2.55 9.083-1.273 4.01-2.758m-19.01-7.886l6.925 1.917 4.576-.96 2.17-1.456m-9.34-18.834v20.04m4.083-20.04l.666 20.04\" fill=\"none\"/>\n        <path stroke=\"#000\" stroke-width=\"2\" d=\"M29.167 36.764h12.75v2.667h-12.75zm19.166 0v2.666H63.25v-2.666l-16-.25\" fill=\"none\"/>\n        <path stroke=\"#000\" stroke-width=\"2\" d=\"M67.75 36.764v2.666l5.5.584v-2.667zM29.167 41.93l.75 41.334 12 .833V41.93zm19.416 0v42.167l14.667-.833V41.93zm19.167 0l.583 40.417 4.334-1.75V42.93z\" fill=\"none\"/>\n        <path stroke=\"#000\" stroke-width=\".25\" d=\"M25.625 41.93l-1.375 1.875.688 37.75 1.437.792zm-1.792 44.375l20.792 1.5 23.875-1.5 9.34.08-6.873 1.5L45 89.305l-19.688-1.5z\"/>\n        <path d=\"M44.562 99.18s1.75-1.688 2.938 0m1.175 0s1.325-1.625 2.95 0\"/>\n        <path d=\"M101.418 36.013s-1.583.667 0 1.5 3.75.584 4.417 4.417 0 37.583 0 37.583-.083 1.5-1.417 2.834-2.833 1.833-2.833 1.833-1.75 1 0 1.666c.48.183 2.136-.157 3.833-.083 1.697.073 3.748.074 5.417.083 3.137.016 5.77.46 5.77.46s1.416-.376 0-1.876c-1.834-.167-5.02-1.5-5.436-4.834s-.086-39.583-.086-39.583.75-1.667 1.917-1.625 3.167-.708 8.834 1.625c6.333 5 5.417 9.916 5.833 10.5.5 3.25-1.084 6.667-2.25 8.167s-4.084 2.448-6.334 2.75c-3 .333-4.858-.352-4.858-.352s-3.725.185-.56 1.435 8.584.917 9.834.333 7.915-4.167 8.832-10.667-2.417-11.67-3.667-12.586-5.167-3.333-8.917-3.583-9.167.334-9.167.334h-5.166l-4-.333zm35.5-.063s-2.083.98 0 1.897 3.333.833 4 3.5.332 27.27.332 27.27-.5 2.75 1.375 7.876 4.74 7.27 6.188 8.375c1.438 1.438 7.688 1.938 7.688 1.938h4.69s4.81 0 8.25-3 5.44-4.875 6.25-10.188.75-31.438.75-31.438-.19-2.688 1.626-3.625 2.625-.812 3-1.188.15-1.417-.562-1.417c-.6-.2-2.312.292-2.375.292s-1.063.125-1.063.125h-4.5s-1.307-.272-1.688-.417c-.626-.333-2.313 0-2.313 0s-1.565 1.355-.065 1.793 2.78.525 3.5 1.375c.505.596 1.376 1.312 1.376 2.75s.062 30.25.062 30.25-.562 4-2.125 6.375-5.125 5.062-8.938 5.375-4.625 0-4.625 0-4-.125-6.626-2.5-4.188-5.188-4.562-12 .188-27.562.062-28.375.438-2.375 1.75-2.75 2.062-.875 2.062-.875.938-.708-.438-1.417c-1.375 0-3 .357-3.625.295s-5.188.062-5.188.062-2.062-.083-2.625-.354h-1.642zM225.5 83.993c-3-1.25-1.5 0-3.438-2.062s-12.25-19.5-12.562-20.185c-.438-.625-.438-.625-.562-1s3.188-1.938 3.938-3.188 3.625-3 3.688-7.25l.062-4.25s-.5-3.438-2.25-5.438-4.062-3.44-5.938-4.063-2.875-.692-3.312-.752-6.125 0-6.125 0-3.122.315-3.685.44-4.875.062-4.875.062-2.19-.127-2.44-.188-1.124-.155-1.81 0-1.813 1.31.31 1.687 3.813 1.75 4.126 3.688 0 37.625 0 37.625.47 2.977-1.688 4.124c-2.02 1.073-2.375 1.125-2.375 1.125s-1.946 1.19-.125 1.56c1.37.28 3.188.062 3.688 0s6.688-.31 6.688-.31 2.062.186 2.562.31 1.75.396 2.5.292.938-1.23 0-2.104c-.625-.44-3.188-.19-3.875-.94-1.56-1.5-1.873-2.25-1.873-4.187V63.868s0-1.438 1.562-1.438 4.8.185 4.8.185 1.887.438 3.012 2.25 9.19 16.125 9.94 16.875 2.572 3.897 5.937 4.19c3.374.29 3.82.41 4.124.29s3-.98 0-2.23zM204.25 59.56s-5.938.62-6.875.308c-.95-.317-1.25-.875-1.25-.875s-.25-17.625 0-19.062 1.688-1.435 1.688-1.435 2.188-.312 4.188 0 5.69 1.875 6.815 2.938 2.438 3.75 2.812 5.44c.25 1.21.562 3.06.562 3.06s.31 3.313-1.94 6.313-6 3.317-6 3.317zm25.375-23.784c-.562 0-2.375 1.404 0 2.217s2.938.75 3.688 2.25.812 2.188.875 2.75 0 36.125 0 36.125-.312 2.125-1.188 3.062-2.188 1.5-2.688 1.688-2.688 2-.562 2.125 2.5 0 3.625-.312 5.016-.132 5.688 0 2.688.554 3.375.59 1.562.09 1.875 0 1.688-1.524 0-2.212-2.062.062-3.312-1.312-1.75-3.625-1.81-4.875.06-35.25.06-35.25-.122-2 1.25-3.062 2.315-1.438 3-1.625 2.19-.846-.31-1.875c-1.366.16-2.75.125-3.19.188s-6.435.125-6.435.125-1.476-.24-2.562-.59c-.625-.003-.938-.003-1.375-.003zm23.75.404s-2.562-.312-2.938 0-.625.5-.875 2.688-.812 6.438-.75 7.125 1.062 1.375 1.5 0 .938-3.407 1.688-4.58 1.688-1.858 2-1.92 2.562-.125 3.062-.125 8.688-.062 8.688-.062 1 .125 1.062 1.562 0 39.188 0 39.188.125 2.062-1.375 2.938-2.375 1.188-3.812 1.5-1.312 1.96-.062 1.824 4.125-.637 4.688-.637 5.315.065 5.315.065 1.938.062 2.5.125 2.812.456 3.438.06c.813-.124 1.44-1.187 0-1.437s-2-.688-2.937-1.062-2.188-.873-2.438-2.686-.188-40.25-.188-40.25.124-1.125 1.124-1.125 10.5-.126 10.5-.126 1 .125 1.75.562 1.812 1.188 2.312 2.312.688 2 .75 2.375 1.375 1.626 1.562.19-.188-6.063-.375-7.063-.687-1.59-1.5-1.577-4.437.015-5 .265-26.038.122-27.06 0c-1.252-.148-2.625-.125-2.625-.125zm82.5 47.938c-2.312-.562-2.938-.562-3.688-1.688s-2.75-5.688-3.25-7.25-13.75-39.14-13.75-39.14-.875-2.888-2.5 0-2.312 5.077-2.812 6.39-15.5 36.812-15.812 37.312-1.75 3.062-2.875 3.625l-1.5.75s-2.062 1.105.3 1.875c1.372-.402.644-.21 2.075-.438 1.483-.234 4.146-.053 4.75.062.804.153 2.312.188 2.875.25s1.188.25 1.562.062.938-1.375-.188-1.625-1.75-.312-2.375-.875S297 81.93 297 80.68s.688-2.875 1.125-3.812 2.75-6.312 3.062-7.125.938-2.875 2.438-2.875 14.812-.125 15.5-.062 1.688.688 2.062 1.5 3.875 10.625 4.125 11.438.812 2.375-.5 3.375-1.312 1-2.062 1.06c-1 .374-1.188 2.29.312 2.144s2.625-.582 3.25-.645 5.125-.125 5.875-.06 2.118.41 3.125.373c1.67-.064 2.876-1.314.563-1.876zm-17.75-20.25c-.5 0-10.562.062-12.875 0s-1.25-1.125-1-1.875 6.5-15.062 7.188-16.625 1.438-.062 1.518.312c0 0 5.357 15.062 5.795 16.5s-.123 1.688-.623 1.688zm30.125-14.563c.062-.562.125-1.5 1.438.375S376.75 83.618 377.5 84.618s2.875 3.375 2.875.75-.125-42.812.438-44.25 1.625-2.688 2.812-3.312 1.062-1.645 0-1.76-3.188.072-4.312.26-3.312-.145-5.125-.26-1.875-.268-2.438-.035-1.5 1.298.438 1.92 4.062.94 4.812 2.878.938 5.25.938 5.875-.063 23.375.062 25.625 1 5.25-1.875 1.625-29.188-35.938-29.812-36.75S345.25 36.1 344 36.047s-2.06.072-2.06.072c-1.125-.127-2.375-.064-2.812 0s-1.562 1.06 0 1.623 3.875 1.688 4.562 2.812 1.75 4.125 1.81 5.562.063 9.125 0 10.625.157 6.75.048 8.19-.36 8.06-.422 9.187-.375 4.374-.625 5.687-.31 2.625-1.56 3.25-1.69.812-2.19 1-2.06 2.492-.25 2.277 2.565-.527 3.378-.527 4-.125 4.688 0 3.25.438 3.875.188 1.375-1.125 0-1.438-2.812.062-3.625-1.312-1.375-1.938-1.375-5.188c0-2.066.06-5.75.186-7.312s.75-18.312.75-19.312\"/>\n        <path d=\"M447.438 83.93c-1.938-.5-2.5-.5-3.875-2.062s-9.812-16-10.812-17.562-1.81-3.03-2-3.327-.872-.426.815-1.3 3.188-2.19 4.188-3.56 2.44-4.815 2.44-6.44.187-3.94-.063-5.25-1.376-3.75-2.876-4.94-3.875-2.56-5-2.874-3.125-.708-4.125-.73-3.45.038-4.5.21c-1.1.18-2 .27-2.877.27s-5.625.125-6.438 0-3.996-.36-3.996-.36c-1-.022-2.567 1.298-.317 1.86s2.875.75 3.625 1.875 1.124 2.376 1.124 3.75.188 34.25 0 35.313-.312 2.438-1.25 3.438-1.688 1.25-2.562 1.69-2.375 2.25.062 2.125 2.783-.386 3.833-.5c.914-.1 5.167-.188 5.73-.062s3.81.637 4.56.568 2.563-1.317 0-2.067-4.187-1.188-4.75-2.938-.624-5-.624-6.688-.186-9.062.064-10 .312-2.062 1.875-2 3.19-.062 3.812.062 2.438.5 3.312 1.81 7.625 13.25 8.312 14.376 3.688 5.375 5.688 6.25 2.375 1.21 4.375 1.2 2.624-.263 2.937-.513 1.25-1.124-.687-1.624zm-27.25-23.937c-2.75 0-2.375-1.188-2.375-1.938s-.056-17.312 0-18.25c0 0 .625-.938 1.688-1.312.56-.197 3.19-.062 4.19 0s1.876.188 4.05 1 4.2 3.875 4.95 5.375 1 3 1.06 4.562-.5 4.438-1.122 5.875-2.25 2.875-4.5 3.75-5.188.938-7.938.938zm32.687-23.688c-.625-.062-1.812-.404-2.125-.42s-2.188 1.42 0 2.17 3.188 1.125 3.75 2.312.75 3.688.75 6.375.062 30.938 0 32.312-.688 2.938-1.25 3.5-1.295 1.587-1.938 1.625c-1.062.06-2.375 1.96-.438 1.884s4.188-.137 5.25-.262 9.812-.375 10.625-.188 3.122.336 5.06.45 3.94-.075 5.06-.575 3-1.625 4.126-3.875 1.75-4.062 1.625-5-.372-1.936-1.684-.186-1.812 2.437-2.75 3.124-2.812 2.25-6.188 2.938c-.95.193-1.876.438-3.94.562s-3.5.125-4.687-.062-2.374-.5-2.874-1-1.063-2.375-1.063-4.5-.187-13.563.125-14.375.75-1.5 1.25-1.5 7.75-.25 9 0 3 .562 3.25.938.83 1.06.938 2.25c.25 2.75 2.312 3.625 2.188.938-.235-5.063-.125-8.875 0-10.062s-1.034-4.364-1.938-.75c-.5 2-1.375 2.69-1.625 2.876s-.687.938-3.25 1-8.25-.062-8.937-.25-1.062-.625-.938-5.75-.126-11.625.124-12.375 1.375-1.874 2.562-1.874 8.61-.105 9.375 0c.797.11 3.442.203 4 .562.644.412 1.063.873 1.19 2.06.07.684.06 2.625.124 3.062s1.5 2 1.563-.25.625-5.375.625-6.312.19-1.84-1.938-1.795-4.75.42-5.688.42-3 .19-4.312.19-10.25 0-11.375-.126-3.623-.066-3.623-.066zm38.813-.125c-2.125-.125-2.625-.282-3.125-.297s-2.188 1.547 0 2.235 2.812.875 3.5 2 .812 2.188.812 3.562.062 33 0 34.625-.375 2.875-1 3.75-.69 1.062-1.69 1.688-2.876 2.525 0 2.356 2.19-.42 3.815-.42 2.375-.25 3.625-.064 2.688.484 4.062.492 2.75-1.056.312-2.118-3.19-1.25-3.628-3.688-.438-14.75-.375-16.188-.19-2.562 1.81-2.562 7.563.062 8 .062 1.94.188 2.876.875 1.438 1.812 1.688 3.25c.126 2.125 2.19 2.625 2.19.75-.313-2.875-.376-6-.25-8s-.063-3.688-.063-4.31-1.37-1.84-1.938.81c-.563 2.625-.565 2.53-2 3.19-.958.43-1.25.56-4.063.623-1.688 0-6.688.125-7.25-.062s-1.062-.25-1.062-4.687.125-11.25.125-12.312-.624-3.25 2.97-3.187 7.844-.125 8.53-.062 5.813-.5 5.75 3.563c-.437 3.875 1.626 3.812 1.626 2 .188-2.812.25-4.75.438-5.688s.25-2.47-1.5-2.485-3.812.298-5.125.423-2.94-.125-4.376-.062-10.75.064-12.125 0-2.563-.06-2.563-.06zm76.937 15.688c-.583-2.38-2.938-8.25-7.125-11.562s-9.52-4.922-11.938-5.312c-2.777-.45-5.438 0-5.438 0-.5.062-3.688.717-4.312.89s-4.938 2.11-6.438 3.173-6.438 6-7.938 9.438-2.562 9-2.625 9.812-.115 6.02 0 6.688.75 4.312 1.128 5.5 2.07 4.995 2.688 6.125c.648 1.187 3.5 4.625 4.875 5.75s5.625 4.188 9.188 4.625 7.875.812 10.688 0 7.5-2.625 10-5.312 5.75-6.688 6.938-10.812 1.5-7.553 1.5-9.87c0-2.35-.61-6.77-1.188-9.13zm-4.29 16.396s-1.37 5.93-2.126 7.47c-.878 1.78-3.89 5.09-5 6-1.878 1.53-5.94 2.624-7.065 2.75s-3.625.06-5.188 0-3.19-.22-5.626-1.47-4.437-3.21-6-5.584-4.437-9.312-5-12.5-.78-9.27-.094-12.833 3.78-7.677 4.406-8.49 3.375-3.5 5-4.437 5.312-1.5 6.125-1.688c0 0 2.897-.125 4.397 0s3.917.958 5.25 1.708 3.95 2.97 5.25 4.5c1.833 2.156 2.774 3.557 4 6.74 1.3 3.376 2.09 7.64 2.167 9.093.136 2.49-.25 7.074-.5 8.74z\"/>\n        <path d=\"M115.602 59.87v16.34c0 1.223.492 2.085 1.478 2.59.984.506 2.462.917 4.433 1.235.538.107.806.558.806 1.355 0 .372-.048.824-.137 1.354-1.3-.107-2.777-.2-4.433-.28-1.656-.078-3.447-.118-5.372-.118-1.166 0-2.486.04-3.963.12-1.478.08-2.866.17-4.164.278-.09-.53-.132-.956-.132-1.275 0-.746.223-1.17.67-1.278 1.79-.424 2.99-.837 3.594-1.235s.908-1.13.908-2.192v-40.57c0-1.06-.346-1.832-1.04-2.31-.695-.48-1.937-.85-3.728-1.117-.448-.106-.67-.584-.67-1.435 0-.37.043-.77.133-1.195 1.253.108 2.586.2 3.996.28s2.743.12 3.997.12h9.47c4.835 0 8.462 1.355 10.88 4.064 2.417 2.71 3.626 6.217 3.626 10.52 0 1.702-.325 3.428-.974 5.182-.65 1.753-1.59 3.335-2.823 4.742-1.232 1.41-2.753 2.564-4.567 3.467-1.813.904-3.86 1.355-6.145 1.355H115.6zm3.56-3.267c3.133 0 5.55-.823 7.253-2.47 1.7-1.647 2.552-4.437 2.552-8.37 0-1.646-.158-3.188-.47-4.623-.314-1.435-.85-2.696-1.612-3.786-.762-1.088-1.77-1.953-3.022-2.59-1.254-.638-2.82-.957-4.7-.957h-3.56v22.795h3.56zm62.66 6.377c0 3.028-.292 5.777-.873 8.248-.586 2.47-1.56 4.61-2.924 6.417-1.366 1.807-3.168 3.2-5.406 4.184-2.24.98-5.036 1.472-8.394 1.472-3.852 0-6.963-.57-9.335-1.713-2.372-1.143-4.196-2.643-5.472-4.503-1.276-1.86-2.127-3.998-2.552-6.416-.426-2.416-.638-4.874-.638-7.372V36.2c0-1.063-.314-1.834-.94-2.313-.627-.478-1.813-.85-3.56-1.116-.448-.05-.67-.5-.67-1.352 0-.32.043-.743.133-1.275 1.345.108 2.72.2 4.13.28 1.41.08 2.766.12 4.065.12 1.164 0 2.53-.04 4.097-.12 1.568-.08 3.024-.172 4.367-.28.09.533.133.957.133 1.276 0 .85-.224 1.302-.67 1.354-1.702.268-2.922.64-3.66 1.117-.74.48-1.11 1.25-1.11 2.313v25.345c0 5.527.93 9.763 2.788 12.712 1.858 2.95 5.004 4.423 9.437 4.423 2.507 0 4.634-.33 6.38-.996 1.746-.663 3.178-1.686 4.298-3.068 1.12-1.38 1.926-3.177 2.42-5.38.49-2.206.738-4.85.738-7.93V36.2c0-1.063-.336-1.834-1.007-2.313-.67-.478-1.88-.85-3.625-1.116-.493-.05-.74-.5-.74-1.352 0-.32.046-.743.136-1.275 1.298.108 2.562.2 3.794.28 1.23.08 2.294.12 3.19.12 1.075 0 2.16-.04 3.257-.12 1.098-.08 2.184-.172 3.258-.28.09.533.134.957.134 1.276 0 .266-.068.544-.203.836-.134.293-.313.466-.537.518-1.657.214-2.81.573-3.458 1.077-.65.506-.975 1.29-.975 2.35v26.78zm27.334-3.906h-4.97V76.61c0 1.168.458 1.965 1.377 2.39.917.426 2.317.77 4.197 1.036.538.107.806.558.806 1.355 0 .375-.045.827-.134 1.357-1.21-.107-2.676-.2-4.4-.28-1.723-.078-3.414-.118-5.07-.118-1.165 0-2.508.04-4.03.12-1.522.08-2.955.17-4.298.277-.09-.53-.134-.956-.134-1.275 0-.742.245-1.167.74-1.274 1.7-.318 2.897-.703 3.592-1.155.694-.45 1.04-1.207 1.04-2.27V36.2c0-1.01-.324-1.767-.973-2.272-.65-.504-1.917-.89-3.798-1.156-.448-.052-.67-.504-.67-1.355 0-.32.043-.743.133-1.275 1.343.107 2.73.2 4.164.28 1.432.08 2.797.12 4.097.12h9.067c4.835 0 8.484 1.262 10.947 3.785 2.463 2.524 3.695 5.938 3.695 10.242 0 1.166-.168 2.39-.503 3.664-.336 1.275-.85 2.524-1.545 3.746-.695 1.224-1.59 2.35-2.687 3.388-1.096 1.035-2.382 1.872-3.86 2.51l11.216 18.49c.85 1.384 1.79 2.34 2.82 2.87 1.03.532 1.993.93 2.89 1.195.402.107.603.48.603 1.116 0 .425-.047.9-.137 1.434-1.03-.107-2.283-.2-3.76-.28-1.48-.078-2.845-.118-4.098-.118-.94 0-1.892-.48-2.854-1.435-.96-.956-1.87-2.18-2.72-3.666l-10.743-18.412zm-1.41-3.268c3.132 0 5.55-.783 7.252-2.35 1.7-1.568 2.552-4.317 2.552-8.25 0-1.647-.18-3.162-.538-4.544-.36-1.38-.93-2.577-1.712-3.586-.784-1.01-1.813-1.806-3.09-2.39-1.275-.585-2.832-.878-4.667-.878h-3.358v21.998h3.56zm39.69 20.962c0 1.063.312 1.793.94 2.19.626.4 1.79.813 3.492 1.236.447.107.672.532.672 1.275 0 .316-.045.742-.134 1.272-1.388-.107-2.777-.2-4.164-.28-1.388-.078-2.71-.118-3.962-.118-1.21 0-2.542.04-3.996.12-1.456.08-2.832.17-4.13.278-.09-.53-.134-.956-.134-1.275 0-.744.224-1.17.67-1.276 1.702-.37 2.866-.77 3.494-1.194.626-.426.94-1.17.94-2.232v-40.57c0-1.06-.313-1.818-.94-2.27-.627-.45-1.792-.837-3.493-1.156-.266-.053-.445-.21-.534-.48-.09-.264-.134-.557-.134-.876s.045-.743.135-1.275c1.343.106 2.742.2 4.198.28 1.454.08 2.764.12 3.93.12 1.118 0 2.405-.04 3.86-.12 1.455-.08 2.877-.174 4.266-.28.09.53.134.955.134 1.274 0 .798-.225 1.25-.672 1.356-1.7.32-2.865.704-3.49 1.155-.628.453-.94 1.21-.94 2.27v40.57zm33.176-42.96V76.37c0 1.223.425 2.086 1.276 2.59.85.506 2.284.89 4.298 1.156.492 0 .74.426.74 1.275 0 .375-.046.827-.135 1.357-1.43-.107-2.942-.2-4.53-.28-1.59-.078-3.19-.118-4.802-.118-1.567 0-3.168.04-4.802.12-1.635.08-3.168.17-4.6.277-.09-.53-.135-.982-.135-1.354 0-.743.224-1.168.67-1.274 2.016-.32 3.47-.72 4.367-1.196.895-.478 1.343-1.327 1.343-2.55V33.808h-6.92c-1.342 0-2.474.16-3.39.48-.92.317-1.714.796-2.385 1.434-.672.638-1.254 1.462-1.746 2.47-.495 1.01-1.01 2.18-1.547 3.508-.09.267-.235.452-.437.558-.2.107-.393.16-.57.16-.494 0-.92-.16-1.277-.48.447-1.912.783-3.612 1.007-5.1.224-1.487.425-2.722.604-3.706.18-.983.37-1.74.57-2.27.204-.532.528-.798.976-.798.313 0 .76.027 1.343.08.58.053 1.196.107 1.846.16.648.053 1.31.106 1.98.158.673.054 1.3.08 1.88.08h22.433c.537 0 1.14-.026 1.812-.08.67-.052 1.343-.105 2.015-.16.672-.05 1.287-.105 1.847-.158.56-.053 1.018-.08 1.376-.08.45 0 .774.28.976.837.2.56.39 1.346.57 2.355.18 1.01.37 2.26.572 3.746.202 1.488.548 3.136 1.04 4.94-.224.11-.436.215-.637.32-.2.108-.435.16-.703.16-.18 0-.38-.052-.604-.16-.224-.105-.38-.29-.47-.557-.492-1.328-.984-2.497-1.477-3.507-.493-1.01-1.064-1.833-1.712-2.47-.648-.64-1.433-1.117-2.35-1.436-.918-.32-2.048-.48-3.392-.48h-6.915zm41.975 29.57H307.61l-4.298 12.832c-.225.638-.335 1.17-.335 1.594 0 1.116 1.365 1.913 4.097 2.39.312.055.525.2.638.44.11.238.168.518.168.836 0 .32-.045.745-.134 1.275-1.21-.107-2.485-.2-3.828-.28-1.343-.078-2.664-.118-3.962-.118-.896 0-1.813.026-2.753.08-.94.052-1.926.16-2.955.318-.09-.425-.134-.85-.134-1.275 0-.37.056-.69.168-.956.11-.266.346-.425.705-.48 1.387-.264 2.428-.597 3.123-.995.693-.4 1.197-1.025 1.51-1.876l16.187-46.228c.313-.903.74-1.355 1.276-1.355.178 0 .447.055.806.16l16.25 47.663c.27.745.873 1.33 1.813 1.753.94.427 1.857.718 2.753.877.27.107.48.253.638.438.156.188.235.52.235.997 0 .318-.045.744-.134 1.274-1.434-.106-2.844-.2-4.23-.28-1.39-.077-2.688-.117-3.897-.117-1.255 0-2.688.04-4.3.12-1.61.08-3.066.17-4.364.278-.09-.53-.134-.955-.134-1.274 0-.48.078-.81.235-.997.157-.187.302-.28.437-.28 1.164-.265 2.104-.57 2.82-.916.717-.345 1.076-.863 1.076-1.554 0-.32-.09-.717-.267-1.195l-4.235-13.15zm-1.074-3.268l-6.246-19.527-6.515 19.527h12.76zm56.213 10.564V36.36c0-1.17-.36-1.994-1.074-2.472-.717-.478-1.926-.85-3.627-1.116-.493-.052-.74-.504-.74-1.355 0-.32.045-.743.135-1.275 1.12.107 2.26.2 3.425.28 1.164.08 2.26.12 3.29.12.985 0 2.016-.04 3.09-.12s2.126-.173 3.156-.28c.09.532.137.956.137 1.275 0 .85-.224 1.303-.67 1.355-1.523.267-2.564.638-3.124 1.116-.56.48-.838 1.25-.838 2.312v46.945c-.09.053-.247.093-.47.12-.225.025-.403.04-.537.04-.314 0-.604-.094-.873-.28-.27-.187-.583-.57-.94-1.155l-27.267-42.64v37.54c0 1.062.313 1.806.94 2.23.626.426 1.835.824 3.626 1.195.448.107.673.532.673 1.275 0 .32-.045.745-.134 1.275-1.12-.107-2.25-.2-3.393-.28-1.143-.078-2.207-.118-3.19-.118-.897 0-1.95.04-3.157.12-1.208.08-2.306.17-3.29.278-.09-.53-.134-.956-.134-1.275 0-.743.244-1.168.74-1.275 1.61-.37 2.694-.77 3.254-1.195.56-.425.84-1.168.84-2.23V35.8c0-.848-.26-1.5-.773-1.952-.515-.45-1.58-.81-3.19-1.076-.493-.106-.74-.558-.74-1.355 0-.265.023-.504.068-.717 0-.16.02-.345.066-.558.895.107 1.746.187 2.552.24.715.053 1.478.092 2.283.12.805.026 1.52.04 2.15.04 1.296 0 2.16.052 2.583.158.425.107.772.373 1.04 1.797l24.113 38.177zm44.526-11.6h-4.97V76.61c0 1.168.458 1.965 1.376 2.39.918.426 2.317.77 4.198 1.036.537.107.806.558.806 1.355 0 .375-.045.827-.135 1.357-1.208-.107-2.676-.2-4.398-.28-1.728-.078-3.418-.118-5.07-.118-1.168 0-2.51.04-4.03.12-1.525.08-2.958.17-4.3.277-.09-.53-.136-.956-.136-1.275 0-.742.246-1.167.74-1.274 1.7-.318 2.897-.703 3.592-1.155.693-.45 1.04-1.207 1.04-2.27V36.2c0-1.01-.324-1.767-.973-2.272-.65-.504-1.914-.89-3.795-1.156-.45-.052-.67-.504-.67-1.355 0-.32.042-.743.132-1.275 1.344.107 2.73.2 4.164.28 1.433.08 2.798.12 4.097.12h9.067c4.835 0 8.483 1.262 10.946 3.785 2.462 2.524 3.694 5.938 3.694 10.242 0 1.166-.167 2.39-.503 3.664s-.852 2.524-1.545 3.746c-.695 1.224-1.59 2.35-2.688 3.388-1.098 1.035-2.384 1.872-3.86 2.51l11.215 18.49c.85 1.384 1.79 2.34 2.82 2.87 1.03.532 1.992.93 2.888 1.195.403.107.604.48.604 1.116 0 .425-.046.9-.135 1.434-1.03-.107-2.284-.2-3.762-.28-1.478-.078-2.844-.118-4.097-.118-.94 0-1.894-.48-2.856-1.435-.964-.956-1.87-2.18-2.72-3.666l-10.744-18.41zm-1.41-3.268c3.133 0 5.55-.783 7.253-2.35 1.7-1.568 2.552-4.317 2.552-8.25 0-1.647-.18-3.162-.537-4.544-.358-1.38-.93-2.577-1.713-3.586-.783-1.01-1.812-1.806-3.09-2.39-1.275-.585-2.83-.878-4.667-.878h-3.357v21.998h3.56zm40.026-21.998v20.404h10.477c.896 0 1.533-.518 1.914-1.554.38-1.036.68-2.297.904-3.786.134-.69.537-1.036 1.208-1.036.135 0 .313.027.538.08.224.054.403.107.538.16-.092 1.17-.17 2.498-.236 3.985-.067 1.49-.1 2.79-.1 3.908 0 .904.02 2.006.066 3.308.044 1.302.134 2.777.27 4.423-.36.106-.696.16-1.01.16-.716 0-1.14-.347-1.274-1.038-.225-1.486-.527-2.75-.907-3.785-.382-1.036-1.02-1.554-1.915-1.554h-10.477v18.81c0 1.117.604 1.86 1.812 2.23 1.21.375 3.2.56 5.978.56h3.694c1.296 0 2.426-.225 3.39-.677.962-.45 1.812-1.062 2.552-1.833.738-.77 1.398-1.688 1.98-2.75.582-1.063 1.143-2.232 1.68-3.508.135-.37.47-.558 1.008-.558.225 0 .46.08.706.24.244.16.48.318.704.478-.403 1.01-.75 2.22-1.04 3.626-.293 1.41-.572 2.75-.84 4.026-.27 1.274-.55 2.364-.84 3.268-.292.905-.66 1.356-1.108 1.356-.36 0-.873-.027-1.545-.08s-1.398-.093-2.182-.12c-.784-.026-1.578-.066-2.384-.118-.805-.054-1.5-.08-2.08-.08h-14.71c-1.3 0-2.685.04-4.162.12-1.478.08-2.888.17-4.23.278-.09-.53-.135-.956-.135-1.275 0-.742.223-1.167.67-1.274 1.702-.37 2.923-.77 3.66-1.194.74-.424 1.11-1.167 1.11-2.23V36.2c0-1.063-.326-1.794-.975-2.193-.65-.398-1.914-.81-3.795-1.235-.448-.106-.67-.558-.67-1.355 0-.265.01-.49.032-.677.02-.186.056-.385.1-.598 1.926.16 3.537.266 4.837.318 1.3.054 2.463.08 3.493.08h13.23c2.015 0 3.76-.08 5.238-.24s2.463-.238 2.956-.238c.58 0 .972.438 1.174 1.315.2.876.37 1.926.504 3.148.135 1.223.29 2.524.47 3.906.18 1.385.515 2.55 1.008 3.51-.358.32-.762.478-1.21.478-.58 0-.962-.24-1.14-.717-.538-1.38-1.053-2.563-1.545-3.547-.49-.982-1.062-1.793-1.71-2.43-.65-.64-1.435-1.117-2.35-1.436-.92-.32-2.05-.48-3.394-.48h-9.937zm34.32 2.392c0-1.063-.35-1.807-1.04-2.232-.696-.425-1.94-.823-3.73-1.196-.313-.106-.504-.25-.57-.438-.067-.186-.1-.49-.1-.917 0-.32.043-.743.133-1.275 1.48.107 2.91.2 4.3.28s2.71.12 3.964.12h13.298c1.747 0 3.403-.08 4.97-.24 1.567-.16 2.643-.24 3.225-.24.537 0 .917.44 1.142 1.316.223.876.402 1.926.536 3.148.135 1.223.29 2.51.47 3.866.18 1.355.493 2.538.94 3.547-.134.21-.313.355-.537.435-.226.08-.448.12-.67.12-.54 0-.898-.24-1.077-.718-.536-1.436-1.062-2.657-1.577-3.667-.515-1.01-1.098-1.832-1.746-2.47-.65-.637-1.422-1.102-2.316-1.395-.895-.292-2.015-.438-3.357-.438H501.5v21.2h10.007c.895 0 1.533-.518 1.914-1.554.38-1.036.685-2.27.91-3.707.134-.69.536-1.037 1.21-1.037.355 0 .714.052 1.072.16-.09 1.17-.167 2.51-.233 4.023-.068 1.514-.103 2.83-.103 3.945 0 .903.022 1.992.067 3.267.045 1.276.136 2.738.27 4.385-.358.107-.694.16-1.007.16-.36 0-.65-.066-.873-.2-.225-.13-.36-.41-.403-.836-.18-1.382-.47-2.604-.873-3.668-.403-1.062-1.053-1.594-1.947-1.594H501.5v18.49c0 1.064.57 1.794 1.712 2.193s2.54.732 4.198.997c.537.054.806.506.806 1.355 0 .37-.045.823-.135 1.353-.94-.054-1.944-.107-3.02-.16-.894-.053-1.936-.106-3.12-.158-1.19-.054-2.43-.08-3.73-.08-1.21 0-2.575.04-4.097.12-1.522.08-2.934.17-4.23.278-.09-.53-.135-.956-.135-1.275 0-.796.223-1.22.67-1.274 1.48-.423 2.643-.836 3.493-1.234s1.277-1.128 1.277-2.19V36.2zm31.228 20.244c0-3.667.56-7.12 1.68-10.36 1.118-3.242 2.64-6.084 4.566-8.53 1.924-2.442 4.163-4.383 6.716-5.817 2.552-1.435 5.238-2.152 8.06-2.152 3.895 0 7.297.73 10.208 2.192 2.91 1.462 5.316 3.427 7.22 5.898 1.902 2.47 3.324 5.328 4.265 8.568.94 3.242 1.41 6.643 1.41 10.202 0 4.198-.58 7.958-1.743 11.278-1.165 3.32-2.766 6.137-4.802 8.45-2.038 2.31-4.433 4.077-7.187 5.3s-5.698 1.832-8.83 1.832c-3.18 0-6.09-.638-8.732-1.912-2.643-1.275-4.914-3.096-6.816-5.46-1.904-2.364-3.38-5.193-4.434-8.488-1.054-3.296-1.58-6.963-1.58-11zm23.103 23.034c2.1 0 4.03-.48 5.773-1.435 1.746-.957 3.245-2.284 4.5-3.985 1.253-1.7 2.227-3.72 2.92-6.058.694-2.337 1.042-4.888 1.042-7.65 0-3.827-.336-7.374-1.008-10.64-.672-3.27-1.69-6.11-3.057-8.53-1.365-2.416-3.09-4.315-5.17-5.698-2.082-1.38-4.512-2.072-7.287-2.072-1.836 0-3.593.412-5.272 1.235-1.68.825-3.154 2.02-4.43 3.586-1.275 1.57-2.295 3.498-3.056 5.78-.762 2.287-1.142 4.918-1.142 7.89 0 3.936.36 7.588 1.076 10.96.715 3.377 1.756 6.298 3.123 8.77 1.365 2.47 3.056 4.396 5.07 5.78 2.016 1.38 4.32 2.07 6.92 2.07zm43.99-20.404h-4.97V76.61c0 1.168.456 1.965 1.374 2.39.918.426 2.317.77 4.198 1.036.537.107.806.558.806 1.355 0 .375-.047.827-.137 1.357-1.207-.107-2.675-.2-4.397-.28-1.725-.078-3.415-.118-5.07-.118-1.165 0-2.51.04-4.03.12-1.522.08-2.955.17-4.298.277-.09-.53-.135-.956-.135-1.275 0-.742.246-1.167.74-1.274 1.7-.318 2.897-.703 3.592-1.155.693-.45 1.04-1.207 1.04-2.27V36.2c0-1.01-.324-1.767-.973-2.272-.65-.504-1.914-.89-3.795-1.156-.448-.052-.67-.504-.67-1.355 0-.32.043-.743.133-1.275 1.343.107 2.73.2 4.163.28 1.434.08 2.8.12 4.098.12h9.067c4.836 0 8.484 1.262 10.947 3.785 2.462 2.524 3.694 5.938 3.694 10.242 0 1.166-.168 2.39-.504 3.664s-.852 2.524-1.545 3.746c-.696 1.224-1.59 2.35-2.69 3.388-1.097 1.035-2.383 1.872-3.86 2.51l11.216 18.49c.85 1.384 1.79 2.34 2.82 2.87 1.03.532 1.992.93 2.888 1.195.404.107.605.48.605 1.116 0 .425-.046.9-.135 1.434-1.03-.107-2.284-.2-3.762-.28-1.477-.078-2.843-.118-4.096-.118-.94 0-1.892-.48-2.854-1.435-.964-.956-1.87-2.18-2.72-3.666l-10.743-18.412zm-1.41-3.268c3.13 0 5.55-.783 7.25-2.35 1.7-1.568 2.553-4.317 2.553-8.25 0-1.647-.18-3.162-.537-4.544-.358-1.38-.93-2.577-1.713-3.586-.783-1.01-1.812-1.806-3.09-2.39-1.275-.585-2.83-.878-4.667-.878h-3.357v21.998h3.56zm69.574-23.75c.09-.213.19-.426.303-.64.11-.21.302-.37.57-.477.27-.11.627-.2 1.075-.28.447-.08 1.074-.12 1.88-.12.358 0 .828-.015 1.41-.04.582-.028 1.21-.054 1.88-.08.673-.028 1.355-.068 2.05-.12.693-.054 1.33-.108 1.914-.16.09.53.134.955.134 1.274 0 .85-.223 1.303-.67 1.355-1.61.267-2.686.625-3.223 1.076-.538.452-.807 1.05-.807 1.793 0 .053.033.756.1 2.11s.168 3.615.303 6.776c.134 3.162.302 7.373.504 12.633.2 5.26.437 11.795.705 19.606.044 1.01.336 1.753.873 2.23s1.634.878 3.29 1.196c.225.054.392.2.504.438.11.24.165.52.165.84 0 .32-.045.744-.134 1.274-1.567-.107-2.99-.2-4.264-.28-1.276-.078-2.45-.118-3.526-.118-.447 0-1.006.013-1.68.04l-2.113.08c-.74.025-1.468.065-2.183.12-.717.05-1.344.104-1.88.158-.09-.53-.136-.956-.136-1.275 0-.85.223-1.277.67-1.277 1.79-.424 3.012-.85 3.66-1.274.65-.427.975-1.145.975-2.154 0-.16-.033-1.142-.1-2.95-.068-1.805-.158-4.01-.27-6.614-.112-2.603-.225-5.42-.336-8.448-.113-3.03-.226-5.885-.337-8.568-.112-2.683-.213-4.994-.302-6.934-.09-1.94-.134-3.12-.134-3.547L647.84 81.87c-.18.478-.347.836-.503 1.075-.158.24-.37.358-.64.358-.312 0-.514-.027-.603-.08l-16.454-44.79c-.045.532-.1 1.82-.168 3.865-.067 2.046-.157 4.477-.27 7.293-.11 2.818-.234 5.79-.368 8.928-.135 3.136-.26 6.03-.37 8.688-.11 2.658-.2 4.89-.27 6.695-.065 1.807-.1 2.764-.1 2.87 0 1.647 1.52 2.79 4.567 3.427.45.054.675.48.675 1.275 0 .32-.046.747-.135 1.277-1.21-.108-2.397-.2-3.56-.28-1.166-.08-2.195-.12-3.09-.12-.717 0-1.68.04-2.89.12-1.21.08-2.35.17-3.424.278-.09-.53-.135-.956-.135-1.275 0-.742.226-1.167.674-1.274 1.21-.266 2.183-.65 2.922-1.156.738-.504 1.152-1.26 1.242-2.27 0-.48.044-1.82.135-4.025.09-2.206.19-4.823.303-7.85.11-3.03.235-6.245.37-9.646l.37-9.445c.11-2.896.2-5.287.268-7.174.067-1.886.102-2.856.102-2.91 0-.85-.28-1.474-.84-1.872-.56-.398-1.623-.757-3.19-1.076-.447-.052-.67-.504-.67-1.355 0-.32.043-.744.133-1.276.58.053 1.242.107 1.98.16.74.053 1.48.092 2.217.12.738.026 1.443.052 2.115.08.673.026 1.21.04 1.61.04.81 0 1.435.04 1.883.12.447.08.806.172 1.074.278.27.107.46.267.57.478.11.213.212.426.302.638l14.373 39.77L661.68 32.06zm30.895 1.752v20.404h10.475c.896 0 1.533-.518 1.914-1.554.38-1.036.682-2.297.906-3.786.134-.69.537-1.036 1.208-1.036.135 0 .313.027.538.08.223.054.402.107.537.16-.09 1.17-.17 2.498-.236 3.985-.067 1.49-.1 2.79-.1 3.908 0 .904.02 2.006.066 3.308s.136 2.777.27 4.423c-.36.106-.694.16-1.007.16-.717 0-1.142-.347-1.275-1.038-.225-1.486-.527-2.75-.907-3.785s-1.02-1.554-1.912-1.554H692.57v18.81c0 1.117.603 1.86 1.81 2.23 1.21.375 3.202.56 5.98.56h3.693c1.298 0 2.428-.225 3.392-.677.962-.45 1.812-1.062 2.552-1.833.738-.77 1.398-1.688 1.98-2.75.582-1.063 1.143-2.232 1.68-3.508.135-.37.47-.558 1.008-.558.224 0 .458.08.705.24.245.16.48.318.705.478-.403 1.01-.75 2.22-1.04 3.626-.293 1.41-.572 2.75-.84 4.026-.27 1.274-.55 2.364-.84 3.268-.292.905-.66 1.356-1.108 1.356-.36 0-.873-.027-1.545-.08s-1.4-.093-2.183-.12c-.787-.026-1.58-.066-2.387-.118-.807-.054-1.5-.08-2.082-.08h-14.707c-1.3 0-2.687.04-4.164.12-1.478.08-2.888.17-4.23.278-.09-.53-.135-.956-.135-1.275 0-.742.223-1.167.67-1.274 1.702-.37 2.923-.77 3.66-1.194.74-.424 1.11-1.167 1.11-2.23V36.2c0-1.063-.326-1.794-.975-2.193-.647-.398-1.912-.81-3.793-1.235-.448-.106-.67-.558-.67-1.355 0-.265.01-.49.032-.677.02-.186.054-.385.1-.598 1.924.16 3.535.266 4.835.318 1.298.054 2.462.08 3.492.08h13.23c2.015 0 3.76-.08 5.238-.24s2.462-.238 2.955-.238c.58 0 .975.438 1.177 1.315.2.876.37 1.926.503 3.148.134 1.223.29 2.524.47 3.906.178 1.385.514 2.55 1.007 3.51-.358.32-.762.478-1.21.478-.58 0-.962-.24-1.14-.717-.538-1.38-1.053-2.563-1.545-3.547-.493-.982-1.064-1.793-1.713-2.43-.65-.64-1.437-1.117-2.354-1.436-.918-.32-2.05-.48-3.392-.48h-9.937zm73.606 22.636c0 3.136-.46 6.244-1.377 9.325-.92 3.08-2.308 5.855-4.165 8.326-1.858 2.47-4.21 4.463-7.052 5.978-2.844 1.515-6.168 2.27-9.974 2.27h-13.77c-1.164 0-2.484.04-3.962.12-1.48.08-2.91.172-4.3.28-.09-.53-.134-.957-.134-1.276 0-.744.245-1.17.738-1.276 1.656-.478 2.843-.93 3.56-1.354.716-.424 1.074-1.114 1.074-2.07V36.2c0-1.063-.337-1.807-1.008-2.232-.672-.425-1.88-.823-3.627-1.196-.27-.052-.46-.21-.57-.478-.112-.265-.167-.558-.167-.877s.044-.743.134-1.275c.94.107 1.757.173 2.45.2.695.026 1.355.066 1.98.118.63.054 1.244.08 1.85.08h15.683c3.76 0 7.06.69 9.904 2.072 2.843 1.382 5.205 3.242 7.086 5.58 1.88 2.338 3.29 5.074 4.23 8.208.942 3.137 1.413 6.485 1.413 10.044zm-7.052 1.514c0-8.182-1.713-14.253-5.138-18.212-3.426-3.958-8.43-5.938-15.01-5.938h-5.844V76.21c0 .532.11.984.336 1.355.222.373.602.665 1.14.877.537.213 1.276.372 2.216.48.94.105 2.126.158 3.56.158 3.447 0 6.357-.49 8.73-1.475 2.373-.983 4.3-2.39 5.776-4.225 1.478-1.833 2.552-4.05 3.224-6.655.672-2.602 1.008-5.525 1.008-8.767zm-633.732 42.95v25.813c0 .745.258 1.27.774 1.574.516.307 1.385.54 2.607.7.3 0 .448.26.448.774 0 .226-.026.5-.08.822-.87-.066-1.787-.12-2.75-.17-.965-.05-1.936-.073-2.914-.073-.95 0-1.92.024-2.913.072-.992.05-1.92.102-2.79.17-.056-.324-.082-.6-.082-.824 0-.45.136-.71.408-.773 1.22-.193 2.102-.436 2.645-.726.543-.29.815-.805.815-1.547v-25.813h-4.195c-.814 0-1.5.097-2.057.29-.557.193-1.04.483-1.446.87-.407.387-.76.887-1.06 1.498-.298.613-.61 1.322-.936 2.127-.055.163-.143.275-.265.34-.12.064-.237.097-.345.097-.3 0-.557-.1-.774-.29.273-1.16.477-2.19.613-3.096.135-.902.257-1.65.366-2.248.107-.596.223-1.056.345-1.378.123-.32.32-.484.59-.484.19 0 .462.017.816.048.354.033.727.065 1.12.097l1.203.097s.787.048 1.14.048h13.606c.325 0 .69-.016 1.1-.048.406-.032.813-.064 1.22-.098.41-.033.78-.065 1.12-.1.34-.03.62-.047.837-.047.27 0 .468.17.59.508.123.34.238.815.347 1.427.108.612.224 1.37.346 2.272.12.9.33 1.9.63 2.996-.135.064-.264.13-.386.193s-.265.096-.428.096c-.11 0-.23-.032-.367-.097s-.23-.178-.287-.34c-.3-.805-.598-1.514-.896-2.127-.3-.61-.646-1.11-1.04-1.498-.393-.387-.87-.677-1.425-.87-.557-.193-1.243-.29-2.057-.29h-4.192zm44.807 26.055c0 .645.176 1.088.53 1.33.352.24 1.06.49 2.117.748.27.068.408.29.408.68 0 .26-.027.55-.082.87-.68-.064-1.48-.12-2.4-.17-.92-.047-1.743-.07-2.468-.07-.752 0-1.555.023-2.408.07-.853.05-1.686.105-2.5.17-.055-.32-.082-.61-.082-.87 0-.387.135-.61.407-.677 1.004-.224 1.697-.466 2.078-.724.38-.26.57-.71.57-1.355v-11.7h-12.79v11.7c0 .645.177 1.088.53 1.33.354.24 1.06.49 2.12.748.297.065.447.29.447.677 0 .26-.027.55-.08.87-.708-.065-1.522-.12-2.445-.17-.922-.048-1.75-.07-2.484-.07-.76 0-1.562.022-2.403.07-.842.05-1.684.104-2.526.17-.057-.32-.08-.61-.08-.87 0-.388.132-.61.404-.678 1.032-.225 1.737-.467 2.118-.725.38-.258.57-.71.57-1.354v-24.558c0-.32-.033-.588-.1-.798-.07-.21-.198-.394-.388-.556-.19-.16-.455-.296-.794-.41-.34-.11-.78-.232-1.323-.36-.272-.03-.408-.29-.408-.774 0-.225.025-.5.08-.822.68.065 1.467.12 2.363.17.897.048 1.712.072 2.445.072.76 0 1.56-.024 2.402-.072.84-.05 1.67-.104 2.485-.17.054.323.082.598.082.822 0 .452-.137.71-.41.773-1.06.192-1.757.435-2.097.725-.34.29-.51.758-.51 1.402v10.83h12.79V102.4c0-.548-.162-.99-.488-1.33-.326-.338-1.02-.603-2.078-.797-.3-.03-.448-.29-.448-.773 0-.225.026-.5.08-.822.68.065 1.473.12 2.38.17.906.048 1.722.072 2.45.072.75 0 1.54-.024 2.365-.072.826-.05 1.66-.104 2.5-.17.056.323.084.598.084.822 0 .452-.136.71-.407.773-1.06.193-1.76.436-2.097.726-.34.29-.51.756-.51 1.4v24.56zm22.16-26.056v12.375h6.355c.542 0 .93-.313 1.16-.942.23-.628.415-1.394.55-2.296.083-.42.327-.63.734-.63.08 0 .19.018.325.05s.244.064.326.097c-.054.71-.1 1.518-.142 2.42s-.063 1.69-.063 2.368c0 .55.013 1.218.04 2.007.028.79.083 1.685.164 2.683-.218.065-.42.097-.61.097-.436 0-.694-.21-.775-.628-.136-.902-.32-1.668-.55-2.297-.23-.63-.618-.943-1.16-.943h-6.356v11.41c0 .676.367 1.127 1.1 1.353.733.225 1.94.337 3.625.337h2.24c.787 0 1.473-.137 2.057-.41.583-.273 1.1-.645 1.548-1.112.45-.467.85-1.022 1.204-1.668.353-.645.692-1.354 1.02-2.127.08-.225.284-.338.61-.338.136 0 .278.048.428.145.15.097.293.193.43.29-.245.612-.456 1.346-.632 2.2-.177.853-.346 1.667-.51 2.44-.162.773-.332 1.435-.508 1.982-.177.546-.4.82-.672.82-.218 0-.53-.02-.937-.05-.406-.03-.848-.057-1.323-.07-.476-.02-.958-.04-1.446-.074-.488-.033-.91-.05-1.262-.05h-8.92c-.79 0-1.63.025-2.527.073-.895.05-1.75.104-2.565.17-.055-.32-.08-.58-.08-.774 0-.45.134-.708.406-.773 1.033-.225 1.773-.467 2.22-.725.45-.26.673-.71.673-1.356V102.36c0-.646-.2-1.09-.59-1.33-.397-.242-1.164-.49-2.304-.75-.27-.064-.406-.338-.406-.82 0-.162.007-.3.02-.412.015-.112.035-.233.06-.363 1.17.097 2.147.162 2.935.194.788.03 1.493.045 2.118.045h8.025c1.223 0 2.282-.048 3.178-.146.896-.097 1.493-.145 1.792-.145.353 0 .59.266.713.798.124.53.226 1.168.308 1.91.08.74.175 1.53.284 2.368.11.84.313 1.548.61 2.128-.216.19-.46.29-.73.29-.354 0-.585-.148-.693-.438-.327-.837-.64-1.554-.938-2.15s-.645-1.088-1.04-1.475c-.393-.387-.87-.677-1.425-.87-.557-.193-1.242-.29-2.057-.29h-6.03zm24.807 13.73c0-2.226.34-4.32 1.02-6.286.677-1.963 1.6-3.686 2.77-5.17 1.166-1.48 2.524-2.66 4.072-3.53 1.547-.87 3.177-1.304 4.887-1.304 2.363 0 4.426.443 6.192 1.33 1.764.886 3.224 2.078 4.38 3.577 1.152 1.5 2.015 3.232 2.585 5.197.57 1.965.855 4.03.855 6.187 0 2.546-.35 4.826-1.057 6.84-.707 2.015-1.677 3.723-2.913 5.125-1.237 1.4-2.69 2.474-4.36 3.214-1.67.74-3.456 1.112-5.356 1.112-1.93 0-3.694-.387-5.295-1.16-1.606-.773-2.984-1.877-4.138-3.312-1.155-1.434-2.05-3.15-2.688-5.148-.64-1.997-.958-4.22-.958-6.67zm14.014 13.97c1.277 0 2.445-.29 3.504-.87s1.97-1.386 2.73-2.417c.76-1.03 1.35-2.256 1.77-3.675.42-1.417.632-2.964.632-4.64 0-2.32-.204-4.473-.61-6.455-.41-1.98-1.026-3.705-1.855-5.172-.83-1.467-1.873-2.618-3.136-3.457-1.263-.835-2.736-1.254-4.42-1.254-1.114 0-2.18.25-3.198.75-1.018.5-1.915 1.225-2.688 2.175-.776.95-1.394 2.12-1.856 3.505-.462 1.386-.692 2.98-.692 4.786 0 2.386.217 4.6.652 6.648.434 2.047 1.065 3.818 1.894 5.317.827 1.498 1.853 2.667 3.075 3.505s2.62 1.256 4.198 1.256zm31.815-1.74c0 .548.204.935.61 1.16.408.226.964.338 1.67.338h4.44c.79 0 1.468-.12 2.038-.362.57-.24 1.06-.588 1.466-1.04s.766-1.006 1.08-1.667c.31-.66.59-1.41.834-2.248.082-.258.245-.387.49-.387.135 0 .277.044.427.124.15.08.307.17.47.266-.19.966-.374 1.99-.55 3.07-.177 1.08-.333 2.295-.47 3.65-.025.353-.107.58-.243.675-.136.097-.3.146-.49.146-.46 0-1.038-.04-1.73-.12-.693-.08-1.297-.12-1.813-.12H261.04c-.624 0-1.412.024-2.362.07-.95.05-1.86.106-2.73.17-.054-.32-.08-.58-.08-.772 0-.45.135-.708.407-.773 1.113-.225 1.874-.475 2.28-.75.408-.272.612-.7.612-1.28V102.36c0-.646-.19-1.105-.57-1.38-.38-.272-1.114-.507-2.2-.7-.136-.03-.238-.12-.306-.266-.065-.146-.1-.314-.1-.508 0-.225.028-.5.08-.822.926.065 1.836.12 2.73.17.898.048 1.658.072 2.28.072.926 0 1.9-.024 2.936-.072 1.032-.05 1.955-.104 2.77-.17.054.323.082.58.082.774 0 .548-.15.838-.448.87-1.17.16-2.03.395-2.588.7-.556.307-.834.863-.834 1.668v24.17zm23.3-12.23c0-2.226.34-4.32 1.02-6.286.677-1.963 1.6-3.686 2.77-5.17 1.166-1.48 2.524-2.66 4.072-3.53 1.548-.87 3.178-1.304 4.888-1.304 2.363 0 4.426.443 6.192 1.33 1.765.886 3.225 2.078 4.38 3.577 1.153 1.5 2.016 3.232 2.586 5.197.57 1.965.855 4.03.855 6.187 0 2.546-.355 4.826-1.06 6.84-.708 2.015-1.678 3.723-2.914 5.125-1.236 1.4-2.688 2.474-4.36 3.214-1.67.74-3.455 1.112-5.355 1.112-1.93 0-3.694-.387-5.295-1.16-1.603-.773-2.98-1.877-4.135-3.312-1.154-1.434-2.05-3.15-2.687-5.148-.64-1.997-.958-4.22-.958-6.67zm14.014 13.97c1.275 0 2.443-.29 3.502-.87s1.97-1.386 2.73-2.417c.76-1.03 1.35-2.256 1.77-3.675.42-1.417.632-2.964.632-4.64 0-2.32-.204-4.473-.61-6.455-.41-1.98-1.026-3.705-1.855-5.172-.83-1.467-1.875-2.618-3.138-3.457-1.263-.835-2.736-1.254-4.42-1.254-1.114 0-2.18.25-3.198.75-1.018.5-1.915 1.225-2.688 2.175-.774.95-1.392 2.12-1.854 3.505-.462 1.386-.692 2.98-.692 4.786 0 2.386.22 4.6.654 6.648.434 2.047 1.065 3.818 1.894 5.317.828 1.498 1.854 2.667 3.076 3.505s2.62 1.256 4.197 1.256zm46.64 1.498c-1.22.258-2.47.46-3.748.604-1.277.143-2.77.215-4.48.215-2.337 0-4.367-.42-6.09-1.257-1.726-.84-3.158-1.983-4.298-3.434-1.14-1.45-1.99-3.166-2.546-5.148-.56-1.982-.837-4.134-.837-6.454 0-1.935.28-3.868.836-5.802s1.397-3.674 2.525-5.22c1.127-1.548 2.547-2.813 4.258-3.796 1.71-.982 3.707-1.475 5.988-1.475.815 0 1.595.024 2.342.072.747.05 1.487.138 2.22.266.733.13 1.473.283 2.22.46.747.18 1.554.395 2.424.652.054 1.13.156 2.296.305 3.505.15 1.21.346 2.393.59 3.554-.054.064-.162.113-.325.145-.163.032-.3.05-.408.05-.435 0-.707-.21-.814-.63-.49-2.16-1.317-3.706-2.485-4.64-1.17-.936-2.84-1.403-5.012-1.403-1.738 0-3.26.34-4.562 1.016-1.303.676-2.382 1.603-3.24 2.78-.853 1.175-1.5 2.577-1.933 4.204-.435 1.628-.652 3.393-.652 5.293 0 2.225.278 4.27.835 6.14.556 1.87 1.317 3.48 2.28 4.835.965 1.354 2.105 2.4 3.423 3.142 1.317.742 2.75 1.112 4.297 1.112.788 0 1.582-.064 2.383-.193.8-.13 1.473-.29 2.016-.482v-7.395c0-.87-.22-1.475-.653-1.812-.435-.34-1.168-.587-2.2-.75-.217-.03-.366-.144-.448-.337s-.124-.387-.124-.58c0-.258.027-.516.082-.773.788.064 1.656.12 2.607.17.95.047 1.777.07 2.483.07s1.514-.023 2.424-.07c.91-.05 1.704-.105 2.383-.17.055.322.083.58.083.773 0 .322-.048.54-.143.652-.096.113-.21.186-.347.218-.87.13-1.473.347-1.812.652-.34.307-.507.782-.507 1.426v8.606c0 .29-.07.53-.205.725-.134.193-.514.355-1.138.483zm22.12-3.142c0 .645.19 1.088.57 1.33.38.24 1.085.49 2.117.748.27.068.407.326.407.776 0 .193-.027.452-.08.774-.843-.066-1.686-.12-2.527-.17-.842-.05-1.644-.073-2.403-.073-.733 0-1.542.024-2.424.072-.88.05-1.716.102-2.503.17-.055-.324-.08-.58-.08-.776 0-.45.134-.708.406-.773 1.032-.223 1.737-.465 2.118-.723.38-.258.57-.71.57-1.354v-24.606c0-.645-.19-1.104-.57-1.378-.38-.274-1.084-.51-2.116-.7-.163-.033-.272-.13-.326-.29-.055-.163-.08-.34-.08-.533s.025-.45.08-.774c.815.065 1.664.12 2.546.17.882.048 1.676.072 2.383.072.68 0 1.46-.024 2.342-.072.88-.05 1.744-.104 2.586-.17.054.323.08.58.08.774 0 .483-.135.757-.406.82-1.033.194-1.74.43-2.12.702-.38.273-.57.732-.57 1.377v24.607zm28.595 3.964c-2.28 0-4.277-.42-5.988-1.257s-3.13-1.99-4.257-3.457c-1.125-1.466-1.967-3.19-2.524-5.172-.557-1.98-.835-4.114-.835-6.402 0-1.9.28-3.82.837-5.753s1.398-3.682 2.526-5.245c1.127-1.564 2.547-2.837 4.258-3.82 1.71-.98 3.708-1.475 5.99-1.475.895 0 1.716.024 2.464.072.747.05 1.46.13 2.14.242.678.11 1.344.256 1.996.433.65.178 1.33.38 2.034.604.028.87.124 1.934.286 3.19.164 1.257.38 2.53.652 3.82-.217.128-.434.192-.652.192-.217 0-.414-.033-.59-.1-.178-.063-.293-.24-.346-.53-.49-2.128-1.264-3.64-2.322-4.545-1.06-.9-2.594-1.354-4.604-1.354-1.684 0-3.17.323-4.46.968s-2.376 1.545-3.26 2.705c-.882 1.16-1.547 2.555-1.995 4.182-.45 1.628-.673 3.44-.673 5.438 0 2.225.285 4.27.855 6.14.57 1.87 1.337 3.48 2.3 4.835s2.092 2.402 3.382 3.143c1.29.743 2.667 1.113 4.134 1.113 1.17 0 2.154-.137 2.955-.41.802-.274 1.468-.67 1.997-1.186.53-.517.98-1.153 1.345-1.91.368-.758.714-1.62 1.04-2.587.19-.484.516-.726.98-.726.134 0 .276.024.427.072.148.05.264.104.346.17-.326 1.127-.652 2.367-.977 3.72-.325 1.355-.597 2.708-.815 4.06-1.33.26-2.688.46-4.072.606-1.384.148-2.906.22-4.562.22zM435.1 118.84h-9.083l-2.607 7.784c-.134.387-.2.71-.2.967 0 .68.827 1.16 2.483 1.45.19.036.32.124.387.27.067.145.102.313.102.507s-.027.452-.082.774c-.733-.065-1.507-.12-2.32-.17-.816-.05-1.617-.072-2.404-.072-.544 0-1.1.016-1.67.05-.57.03-1.17.096-1.793.192-.055-.26-.08-.518-.08-.776 0-.225.032-.418.1-.58.068-.16.21-.257.43-.29.84-.16 1.472-.362 1.893-.604.42-.24.727-.62.917-1.136l9.817-28.038c.19-.548.448-.822.773-.822.108 0 .27.032.49.097l9.856 28.91c.16.45.53.808 1.1 1.065s1.124.435 1.67.53c.16.066.29.154.385.268.095.114.143.314.143.605 0 .193-.028.452-.08.774-.87-.065-1.727-.12-2.568-.17-.842-.05-1.63-.072-2.362-.072-.76 0-1.63.024-2.606.072-.978.048-1.86.103-2.647.17-.055-.323-.082-.582-.082-.775 0-.29.047-.49.143-.604.095-.11.184-.17.265-.17.707-.16 1.277-.344 1.71-.554.437-.21.654-.524.654-.943 0-.193-.055-.436-.163-.726l-2.57-7.975zm-.652-1.98l-3.79-11.845-3.95 11.845h7.74zm28.31 10.007c0 .548.204.935.61 1.16s.965.338 1.67.338h4.44c.788 0 1.468-.12 2.038-.362.57-.24 1.06-.588 1.467-1.04.407-.45.767-1.006 1.08-1.667.31-.66.59-1.41.834-2.248.08-.258.242-.387.487-.387.135 0 .277.044.428.124.148.08.305.17.468.266-.19.966-.373 1.99-.55 3.07-.177 1.08-.333 2.295-.47 3.65-.026.353-.107.58-.243.675s-.298.146-.487.146c-.463 0-1.04-.04-1.73-.12-.693-.08-1.298-.12-1.813-.12h-10.185c-.625 0-1.412.024-2.362.07-.95.05-1.86.106-2.73.17-.054-.32-.08-.58-.08-.772 0-.45.136-.708.407-.773 1.113-.225 1.874-.475 2.28-.75.408-.272.612-.7.612-1.28V102.36c0-.646-.19-1.105-.57-1.38-.38-.272-1.115-.507-2.2-.7-.137-.03-.24-.12-.307-.266-.068-.146-.102-.314-.102-.508 0-.225.027-.5.08-.822.925.065 1.835.12 2.73.17.897.048 1.657.072 2.28.072.925 0 1.9-.024 2.935-.072 1.032-.05 1.956-.104 2.77-.17.055.323.082.58.082.774 0 .548-.15.838-.448.87-1.17.16-2.03.395-2.587.7-.558.307-.835.863-.835 1.668v24.17zm57.844-20.353c-.27.065-.476.097-.61.097-.354 0-.61-.08-.774-.24-.163-.16-.285-.34-.366-.53-.707-1.837-1.55-3.174-2.526-4.013-.978-.838-2.31-1.257-3.992-1.257-.65 0-1.27.104-1.853.313-.584.21-1.093.516-1.527.918-.435.405-.78.897-1.038 1.477-.26.58-.388 1.226-.388 1.934 0 1.516.534 2.756 1.607 3.723 1.072.967 2.654 1.95 4.746 2.95 2.606 1.224 4.527 2.585 5.764 4.084 1.235 1.498 1.854 3.344 1.854 5.535 0 1.324-.17 2.557-.51 3.7-.34 1.145-.87 2.144-1.587 2.997-.72.853-1.65 1.52-2.79 2.005-1.14.484-2.512.726-4.114.726-1.685 0-3.212-.21-4.583-.63-1.372-.417-2.533-.966-3.483-1.643-.08-1.354-.203-2.658-.366-3.915s-.354-2.514-.57-3.77c.19-.097.42-.145.692-.145.326 0 .576.09.754.266.176.18.332.46.468.847.68 2.32 1.555 4.03 2.628 5.125 1.072 1.097 2.572 1.645 4.5 1.645.87 0 1.63-.146 2.282-.436s1.194-.692 1.63-1.21c.434-.514.76-1.094.978-1.74.217-.643.325-1.335.325-2.077 0-1.676-.48-2.997-1.444-3.964-.965-.968-2.343-1.838-4.135-2.61-1.167-.517-2.227-1.057-3.177-1.62-.95-.564-1.766-1.217-2.444-1.96-.68-.74-1.2-1.602-1.568-2.585-.366-.982-.55-2.15-.55-3.505 0-1.193.184-2.313.55-3.36.367-1.047.896-1.958 1.59-2.73s1.526-1.387 2.504-1.838c.978-.45 2.077-.678 3.3-.678 1.275 0 2.497.146 3.665.436s2.486.773 3.953 1.45c.054.967.128 2.006.224 3.118.092 1.11.22 2.15.384 3.117zm20.368-5.607v12.375h6.354c.543 0 .93-.313 1.16-.942.23-.628.414-1.394.55-2.296.082-.42.326-.63.734-.63.08 0 .19.018.325.05s.245.064.326.097c-.054.71-.1 1.518-.14 2.42s-.064 1.69-.064 2.368c0 .55.014 1.218.04 2.007.027.79.083 1.685.164 2.683-.217.065-.42.097-.61.097-.435 0-.692-.21-.773-.628-.137-.902-.32-1.668-.55-2.297-.23-.63-.618-.943-1.16-.943h-6.355v11.41c0 .676.367 1.127 1.1 1.353s1.942.337 3.626.337h2.24c.788 0 1.474-.137 2.058-.41s1.1-.645 1.548-1.112c.448-.467.85-1.022 1.202-1.668.353-.645.692-1.354 1.018-2.127.082-.225.285-.338.61-.338.137 0 .28.048.43.145s.29.193.427.29c-.243.612-.454 1.346-.63 2.2-.18.853-.347 1.667-.51 2.44s-.333 1.435-.51 1.982c-.176.546-.4.82-.672.82-.217 0-.53-.02-.937-.05-.407-.03-.85-.057-1.324-.07-.475-.02-.957-.04-1.445-.074-.49-.033-.91-.05-1.263-.05h-8.92c-.79 0-1.63.025-2.526.073-.895.05-1.75.104-2.565.17-.055-.32-.08-.58-.08-.774 0-.45.135-.708.406-.773 1.03-.225 1.77-.467 2.22-.725s.674-.71.674-1.356V102.36c0-.646-.198-1.09-.59-1.33-.396-.242-1.162-.49-2.303-.75-.27-.064-.406-.338-.406-.82 0-.162.006-.3.02-.412.014-.112.034-.233.062-.363 1.168.097 2.146.162 2.934.194.785.03 1.49.045 2.116.045H547c1.222 0 2.28-.048 3.178-.146.896-.097 1.493-.145 1.792-.145.353 0 .59.266.713.798.122.53.224 1.168.306 1.91.08.74.173 1.53.282 2.368.108.84.312 1.548.61 2.128-.217.19-.462.29-.732.29-.353 0-.584-.148-.69-.438-.327-.837-.64-1.554-.94-2.15s-.645-1.088-1.037-1.475c-.395-.387-.87-.677-1.426-.87-.558-.193-1.243-.29-2.058-.29h-6.03zm50.714-1.064c.055-.13.115-.258.184-.387.067-.13.184-.226.347-.29.162-.064.38-.12.65-.17.272-.048.652-.072 1.142-.072.215 0 .5-.008.853-.024s.733-.03 1.14-.048c.408-.016.822-.04 1.243-.073.42-.034.808-.066 1.16-.1.055.323.082.58.082.774 0 .516-.137.79-.408.82-.978.163-1.63.38-1.955.653-.326.273-.49.636-.49 1.087 0 .032.022.46.063 1.28s.102 2.193.184 4.11c.08 1.918.182 4.472.305 7.662.122 3.19.265 7.153.428 11.892.026.61.203 1.062.53 1.353.324.29.99.53 1.995.726.137.034.238.122.307.268.066.145.1.313.1.507s-.026.453-.08.775c-.95-.066-1.813-.122-2.587-.17-.774-.05-1.487-.073-2.14-.073-.27 0-.61.008-1.018.024-.407.017-.835.032-1.283.05-.45.015-.89.04-1.325.072-.435.03-.814.063-1.14.097-.056-.323-.082-.582-.082-.775 0-.515.136-.773.407-.773 1.086-.258 1.826-.516 2.22-.774.394-.258.59-.693.59-1.306 0-.097-.02-.693-.06-1.79-.04-1.094-.096-2.432-.163-4.012-.068-1.578-.137-3.287-.204-5.124-.068-1.836-.136-3.57-.203-5.195-.068-1.628-.13-3.03-.184-4.206-.056-1.178-.082-1.895-.082-2.15l-8.92 25.57c-.11.29-.21.51-.306.653-.095.146-.224.218-.387.218-.19 0-.312-.016-.366-.047l-9.98-27.17c-.026.323-.06 1.105-.1 2.346-.04 1.24-.097 2.714-.164 4.422-.07 1.708-.144 3.513-.225 5.414l-.224 5.27c-.068 1.61-.122 2.964-.163 4.06-.04 1.096-.06 1.676-.06 1.74 0 1 .922 1.69 2.77 2.08.27.03.406.29.406.77 0 .194-.028.453-.08.775-.735-.064-1.455-.12-2.16-.17-.707-.047-1.33-.07-1.875-.07-.436 0-1.02.023-1.75.07-.735.05-1.428.105-2.08.17-.055-.32-.08-.58-.08-.773 0-.45.135-.707.406-.772.733-.16 1.324-.394 1.77-.7.45-.307.7-.766.755-1.378 0-.29.027-1.104.082-2.44.054-1.338.115-2.926.183-4.763s.142-3.787.224-5.85l.223-5.73s.122-3.206.163-4.35.063-1.732.063-1.765c0-.517-.17-.896-.51-1.138-.34-.24-.985-.46-1.936-.652-.27-.03-.407-.306-.407-.82 0-.194.027-.452.082-.775.352.033.753.065 1.2.097.45.033.897.058 1.345.073l1.283.048c.408.018.734.025.98.025.488 0 .868.025 1.14.073.27.05.49.106.652.17s.278.16.346.29.13.26.184.388l8.718 24.123 8.266-24.123zm26.68 27.12c0 .645.19 1.088.57 1.33.38.24 1.087.49 2.12.748.27.068.406.326.406.776 0 .193-.027.452-.08.774-.844-.066-1.686-.12-2.526-.17-.843-.05-1.644-.073-2.404-.073-.732 0-1.54.024-2.423.072-.885.05-1.72.102-2.508.17-.056-.324-.08-.58-.08-.776 0-.45.134-.708.405-.773 1.03-.223 1.736-.465 2.117-.723.38-.258.57-.71.57-1.354v-24.606c0-.645-.19-1.104-.57-1.378-.38-.274-1.087-.51-2.118-.7-.164-.033-.272-.13-.327-.29-.055-.163-.08-.34-.08-.533s.025-.45.08-.774c.814.065 1.663.12 2.546.17.882.048 1.676.072 2.382.072.68 0 1.46-.024 2.343-.072.883-.05 1.745-.104 2.588-.17.054.323.08.58.08.774 0 .483-.135.757-.406.82-1.032.194-1.738.43-2.118.702-.38.273-.57.732-.57 1.377v24.607zm36.092-4.303v-20.206c0-.71-.218-1.21-.65-1.5-.436-.29-1.17-.514-2.2-.676-.3-.03-.448-.306-.448-.82 0-.194.026-.452.08-.775.68.065 1.372.12 2.078.17.706.048 1.37.072 1.996.072.598 0 1.223-.024 1.874-.072.652-.05 1.29-.104 1.915-.17.055.323.08.58.08.774 0 .516-.134.79-.405.82-.924.163-1.555.388-1.895.678s-.51.758-.51 1.402v28.474c-.054.035-.148.06-.284.075-.137.017-.244.024-.326.024-.19 0-.366-.058-.53-.17-.162-.113-.353-.347-.57-.7l-16.538-25.864v22.77c0 .645.19 1.096.57 1.354.38.257 1.113.5 2.2.724.27.065.407.323.407.773 0 .193-.026.452-.08.774-.68-.063-1.365-.12-2.058-.17-.692-.046-1.338-.07-1.935-.07-.544 0-1.182.024-1.915.07-.733.05-1.398.106-1.996.17-.055-.32-.08-.58-.08-.772 0-.45.147-.708.447-.773.978-.225 1.636-.467 1.976-.725.337-.26.507-.71.507-1.355v-24.85c0-.514-.156-.91-.468-1.184-.313-.27-.96-.49-1.937-.65-.3-.064-.448-.34-.448-.82 0-.162.014-.31.04-.437 0-.096.015-.208.042-.338.543.065 1.06.114 1.548.146.434.033.896.058 1.385.073.49.017.925.024 1.306.024.787 0 1.31.032 1.568.097.258.066.47.227.63.484l14.625 23.157zm29.82-3.82h-9.085l-2.606 7.784c-.136.387-.203.71-.203.967 0 .68.83 1.16 2.485 1.45.19.036.32.124.387.27.068.145.103.313.103.507s-.027.452-.082.774c-.733-.065-1.507-.12-2.32-.17-.816-.05-1.617-.072-2.404-.072-.543 0-1.1.016-1.67.05-.57.03-1.168.096-1.79.192-.057-.26-.08-.518-.08-.776 0-.225.03-.418.1-.58.066-.16.21-.257.43-.29.84-.16 1.47-.362 1.89-.604.423-.24.73-.62.92-1.136l9.816-28.038c.19-.548.448-.822.773-.822.107 0 .27.032.49.097l9.855 28.91c.163.45.53.808 1.1 1.065s1.127.435 1.67.53c.164.066.292.154.388.268.095.114.143.314.143.605 0 .193-.027.452-.08.774-.87-.065-1.726-.12-2.567-.17-.843-.05-1.63-.072-2.363-.072-.76 0-1.63.024-2.607.072-.98.048-1.86.103-2.647.17-.055-.323-.082-.582-.082-.775 0-.29.05-.49.145-.604.095-.11.184-.17.265-.17.705-.16 1.275-.344 1.71-.554.435-.21.652-.524.652-.943 0-.193-.054-.436-.162-.726l-2.57-7.975zm-.653-1.98l-3.788-11.845-3.95 11.845h7.738zm31.325-.63h-3.014v10.637c0 .71.277 1.192.835 1.45.557.258 1.406.468 2.547.628.325.065.488.34.488.822 0 .226-.027.5-.08.822-.734-.068-1.624-.124-2.67-.17-1.045-.05-2.07-.075-3.075-.075-.705 0-1.52.024-2.442.072-.924.048-1.793.103-2.607.17-.053-.323-.08-.582-.08-.775 0-.45.15-.708.448-.773 1.032-.194 1.76-.428 2.18-.7s.632-.734.632-1.38v-24.605c0-.612-.2-1.07-.59-1.378-.397-.306-1.163-.54-2.304-.7-.27-.032-.407-.307-.407-.822 0-.193.024-.45.08-.774.813.066 1.655.12 2.524.17.87.05 1.697.073 2.485.073h5.497c2.933 0 5.146.766 6.64 2.296 1.493 1.53 2.24 3.6 2.24 6.212 0 .71-.102 1.45-.305 2.224-.204.772-.517 1.53-.938 2.27-.42.742-.964 1.427-1.63 2.055-.665.63-1.445 1.138-2.342 1.524l6.803 11.215c.516.84 1.086 1.42 1.71 1.74.626.322 1.21.563 1.753.725.242.063.364.29.364.676 0 .26-.027.55-.08.87-.626-.063-1.386-.12-2.282-.17-.896-.047-1.725-.07-2.484-.07-.57 0-1.15-.29-1.732-.87-.585-.58-1.135-1.32-1.65-2.225l-6.518-11.17zm-.855-1.98c1.9 0 3.367-.476 4.4-1.427 1.03-.95 1.547-2.618 1.547-5.003 0-1-.108-1.918-.325-2.756-.218-.838-.564-1.562-1.04-2.176-.475-.61-1.1-1.095-1.873-1.45-.773-.354-1.718-.53-2.83-.53h-2.037v13.34h2.158zm31.49 2.174l-6.804-14.503c-.27-.48-.61-.843-1.018-1.085-.407-.24-.964-.427-1.67-.556-.137-.03-.238-.13-.306-.29-.068-.16-.102-.355-.102-.58v-.22c0-.08.013-.152.04-.217 0-.097.014-.194.04-.29.598.064 1.358.12 2.282.17.923.047 1.82.07 2.688.07.326 0 .706-.007 1.14-.023l1.345-.05c.46-.016.9-.04 1.322-.073.42-.03.78-.063 1.08-.097 0 .13.013.243.04.34 0 .097.007.178.02.242s.022.13.022.193c0 .193-.034.37-.102.53-.068.163-.17.26-.306.29-.788.13-1.338.283-1.65.46-.312.178-.468.428-.468.75 0 .258.093.563.283.918l5.05 10.83 4.77-10.057c.27-.58.407-1.03.407-1.354 0-.418-.185-.74-.55-.967-.368-.225-.945-.418-1.732-.58-.3-.03-.448-.306-.448-.82 0-.162.014-.308.04-.437 0-.097.014-.21.04-.34.6.066 1.298.122 2.1.17.8.05 1.54.073 2.22.073.624 0 1.283-.02 1.976-.07.692-.05 1.378-.103 2.057-.17 0 .13.015.24.04.34 0 .097.01.178.023.24s.02.13.02.195c0 .45-.148.725-.447.82-.95.163-1.623.363-2.017.605-.395.24-.728.65-1 1.23l-6.6 13.876v10.828c0 .71.226 1.2.674 1.475.448.272 1.202.506 2.26.7.3.063.45.32.45.772 0 .064-.008.145-.022.24s-.02.18-.02.243c-.028.128-.04.225-.04.29-.653-.032-1.292-.065-1.916-.097-.544-.033-1.12-.066-1.73-.098-.61-.03-1.148-.048-1.61-.048-.462 0-.99.018-1.588.05-.6.03-1.17.063-1.71.096-.627.03-1.25.064-1.876.097-.027-.065-.04-.162-.04-.29-.028-.064-.04-.146-.04-.242v-.24c0-.452.134-.71.406-.774 1.06-.26 1.82-.51 2.282-.75.46-.24.692-.717.692-1.427v-10.39z\"/>\n    </symbol>\n</defs></svg>\n");
}]);

},{}],21:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/8/14
 * License: All rights reserved.
 * Copyright: 2014 Puritan Reformed Theological Seminary
 */

// Module-level constants

var PROFILE = '/user/profile';

/**
 * Check whether username change tokens are valid.
 * @param $http The Angular `$http` service.
 * @param change The change request token, containing a token and username.
 * @param user The local user management service.
 * @returns A Promise with the result
 */
function _tokenValid($http, change, user) {
  var url = user.API_ROOT + '/confirm-username';
  return $http.put(url, change, { timeout: 5000 });
}

function ConfirmationController($http, $location, $sce, $scope, session, user, token, username) {
  // Users may already have confirmed their username.
  var maybeSession = session.get();
  if (maybeSession && maybeSession.user && maybeSession.user.confirmed) {
    $location.url(PROFILE);
  }

  // The username and token items are injected via the route resolution.
  _tokenValid($http, { username: username, token: token }, user).then(function () /*response*/{
    $scope.success = true;
    session.set({ user: { name: username, confirmed: true } });
  }).catch(function (err) {
    $scope.success = false;
    $scope.noChangeReason = err.data.reason || 'There was a problem attempting to update your username.' + 'Please return to your <a href="' + PROFILE + '">profile</a> ' + 'and try again. If this happens again, send an email to ' + '<a href="mailto:holybible@heritagebooks.org">holybible@heritagebooks.org</a>. ' + 'We apologize for the inconvenience!';
  });
}

angular.module('hbUsers').controller('ConfirmationController', [
// Inject dependencies. Angular:
'$http', '$location', '$sce', '$scope',
// First-party:
'hbSession', 'hbUser',
// Injected by route resolver:
'token', 'username',
// Bind the controller constructor.
ConfirmationController]);

},{}],22:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/16/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

// Define an Angular controller.

function UsersController($scope, hbSession, hbMessages) {
  // Add scope objects for managing the user's information, so it can be
  // displayed when relevant and referenced by the view.
  var session = hbSession.get();
  if (session && session.user) {
    $scope.user = {
      username: session.user.name,
      confirmed: session.user.confirmed
    };
  }

  // Bind the messages singleton to the view.
  $scope.messages = hbMessages;
}

// Define an Angular module and bind the controller.
angular.module('hbUsers', []).controller('UsersController', [
// Inject dependencies. Angular:
'$scope',
// First-party (hb):
'hbSession', 'hbMessages',
// Supply the controller.
UsersController]);

// The Browserify package includes all JS modules that comprise the AngularJS
// `hbUsers` module.
require('./confirmation-controller');
require('./login-controller');
require('./password-reset-controller');
require('./profile-controller');
require('./resources-controller');
require('./signup-controller');

},{"./confirmation-controller":21,"./login-controller":23,"./password-reset-controller":24,"./profile-controller":25,"./resources-controller":26,"./signup-controller":27}],23:[function(require,module,exports){
'use strict';
/**
  Author: Chris Krycho
  Contact: chris@krycho.com
  Date: 1/16/15
  License: All rights reserved.
  Copyright: 2015 Puritan Reformed Theological Seminary
 */

// Define an Angular controller.

function LoginController($location, $scope, $timeout, messages, session, user) {
  // Define an object against which the form can bind.
  $scope.user = { username: '', password: '' };

  // Bind the local scope messages to the hbMessages singleton data.
  $scope.messages = messages;

  // Process a form requesting user login.
  $scope.login = function (form) {
    var clearForm = function clearForm() {
      $scope.user.password = undefined;
    };

    var handler = user.makeLoginHandler(200, session, $scope, $location, form, messages, clearForm);

    user.login($scope.user, handler);
  };

  // Process a request for a new password.
  $scope.forgot = function () {
    if (angular.isDefined($scope.user.username)) {
      var forgot = { username: $scope.user.username };
      user.forgot(forgot, function (status, data) {
        if (status === 200 && !!data.sent) {
          messages.forgotPassword = 'Thanks! You should receive an email shortly with instructions ' + 'for resetting your email.';

          // Only display the success message for a few seconds.
          $timeout(function () {
            messages.passwordUpdate = '';
          }, 10000);
        } else {
          messages.forgotPassword = 'Sorry, there was a problem resetting your password. Please try ' + 'again. If the problem presists, please send an email describing ' + 'the problem and including your current username to ' + '<a href="mailto:holybible@heritagebooks.org">holybible@heritagebooks.org</a>.';
        }
      });
    } else {
      messages.forgotPassword = 'You must supply a username (email address) to reset your password.';
    }
  };
}

// Add the controller to the users module.
angular.module('hbUsers').controller('LoginController', [
// Specify dependencies. Angular:
'$location', '$scope', '$timeout',
// Project (`hb`):
'hbMessages', 'hbSession', 'hbUser',
// Supply the controller.
LoginController]);

},{}],24:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/16/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

// Module-level constants.

var LOGIN = '/user/sign-in';
var PROFILE = '/user/profile';

// Define an Angular controller.
function PasswordResetController($location, $scope, $timeout, user, messages) {
  $scope.resetPassword = function () {
    var reset = {
      password: $scope.user.password,
      confirm: $scope.user.confirm,
      token: $location.search().token,
      username: $location.search().username
    };

    user.reset(reset, function (status, data) {
      if (status === 200 && !!data.succeeded) {
        messages.resetPassword = 'Password updated successfully!';

        // Having succeeded, log in with the new password.
        var newLogin = {
          username: $location.search().username,
          password: $scope.user.password
        };

        user.login(newLogin, function (status /*, data*/) {
          if (status === 200) {
            // Only display the message briefly, then go to the user's profile.
            $timeout(function () {
              $location.path(PROFILE);
            }, 2500);
          } else {
            // FIXME: presumably there should be something here!!!
          }
        });
      } else {
        // Add an error message to the messages service.
        var reason = angular.isDefined(data.reason) ? ' ' + data.reason : '';
        var message = angular.isDefined(data.message) ? ' ' + data.message : '';
        messages.resetPassword = 'There was a problem resetting your password.' + reason + message;
        $location.path(LOGIN);
      }
    });
  };
}

// Add the controller to the users module.
angular.module('hbUsers').controller('PasswordResetController', [
// Inject dependencies. Angular:
'$location', '$scope', '$timeout',
// Project (`hb`):
'hbUser', 'hbMessages',
// Supply the controller.
PasswordResetController]);

},{}],25:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/8/14
 * License: All rights reserved.
 * Copyright: 2014 Puritan Reformed Theological Seminary
 */

// Module-level constants.

var HOME = '/';

// Define an Angular controller.
function ProfileController($location, $scope, $timeout, messages, session, user) {

  var sessionData = session.get();
  if (sessionData && sessionData.user) {
    $scope.user = {
      username: sessionData.user.name,
      confirmed: sessionData.user.confirmed
    };
  }

  // Bind the local scope to the hgMessages singleton.
  $scope.messages = messages;

  // Enable the controller to track the previous page, for use in
  // conjunction with authentication.
  $scope.previousPage = null;

  // Let the user log out.
  $scope.logout = user.logout;

  /**
   * Process a form requesting deletion of a user.
   *
   * Prompt the user for confirmation, since this is a destructive
   * action; also require that the user provide
   */
  $scope.destroy = function () {
    session.clear();
    user.destroy($scope.user, function () {
      $location.path(HOME);
    });
  };

  $scope.resendConfirmation = function () {
    var username = $scope.user.username;

    user.resendConfirmation({ username: username }, function () {
      $scope.user.resentConfirmation = true;
      messages.resentConfirmation = 'We\'ve sent you a new email to confirm your username! If you don\'t ' + 'see it, please check your spam folder.';
      $scope.emailForm.$setPristine();
    });
  };

  // Process a form requesting password change by a logged-in user.
  $scope.updatePassword = function () {
    var _$scope$user = $scope.user,
        password = _$scope$user.password,
        confirm = _$scope$user.confirm;

    user.update({ password: password, confirm: confirm }, function (status, data) {
      if (status === 200 && data.succeeded) {
        messages.passwordUpdate = 'Your password was updated successfully.';
        $scope.user.password = '';
        $scope.user.confirm = '';
        $scope.passwordForm.$setPristine();

        // Only display the success message for a few seconds.
        $timeout(function () {
          messages.passwordUpdate = '';
        }, 5000);
      } else {
        messages.passwordUpdate = 'Sorry, there was a problem updating your password. Please try ' + 'again. If the problem persists, please send an email describing ' + 'the problem and including your current username to ' + '<a href="mailto:holybible@heritagebooks.org">holybible@heritagebooks.org</a>.';
      }
    });
  };

  // Process a form requesting username change.
  $scope.updateUser = function () {
    var username = $scope.user.username;

    if (username !== session.get().user.name) {
      session.set({ user: { confirmed: false } });
    }

    user.update({ username: username }, function (status, data) {
      messages.usernameUpdate = [200, 201].includes(status) && angular.isDefined(data.sent) ? 'Thanks! You should receive an email shortly asking you to confirm ' + 'your new email address.' : 'We seem to have had a minor problem sending you an email. Please ' + 'try submitting the request again. If you see this message again, ' + 'send us an email at holybible@heritagebooks.org';
    });
  };
}

// Bind the controller function to the Angular module.
angular.module('hbUsers').controller('ProfileController', [
// Inject dependencies. Angular:
'$location', '$scope', '$timeout',
// Project (`hb`):
'hbMessages', 'hbSession', 'hbUser',
// Bind the controller function.
ProfileController]);

},{}],26:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/9/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

function ResourcesController($scope, $timeout, sbAccess, session) {
  $scope.access = [];

  var sessionData = session.get();
  if (sessionData && sessionData.access) {
    $scope.access = sessionData.access;
  }

  // Add a scope object for managing the user's redemption request.
  $scope.sb = { key: null };

  $scope.hasSbAccess = function () {
    return $scope.access.indexOf('kjvsb') !== -1;
  };

  // Handle study bible key redemption requests.
  $scope.redeem = function (form) {
    var key = $scope.sb.key.toUpperCase();

    sbAccess.redeem(key, function (status, data) {
      // Handle errors.
      var message = void 0;
      if (status === 200) {
        $scope.access.push('kjvsb');
        session.set({ access: $scope.access });
      } else {
        if (status === 409 && !!data.conflict) {
          message = data.reason;
        } else {
          message = 'There was a problem redeeming your code. Please try ' + 'again. If this happens again, please send an email to ' + '<a href="mailto:holybible@heritagebooks.org">holybible@heritagebooks.org</a>. ' + 'We apologize for the inconvenience!';
        }

        $scope.messages.keyError = message;

        form.$setPristine();
        form.$setSubmitted();

        // Only display the error message for a few seconds.
        $timeout(function () {
          $scope.messages.keyError = '';
        }, 5000);
      }
    });
  };
}

// Add the controller to the users module.
angular.module('hbUsers').controller('ResourcesController', [
// Inject dependencies. Angular:
'$scope', '$timeout',
// Project (`hb`):
'hbSbAccess', 'hbSession',
// Supply the controller.
ResourcesController]);

},{}],27:[function(require,module,exports){
'use strict';
/**
  Author: Chris Krycho
  Contact: chris@krycho.com
  Date: 1/16/15
  License: All rights reserved.
  Copyright: 2015 Puritan Reformed Theological Seminary
 */

// Define an Angular controller.

function SignupController($location, $scope, session, user, messages) {
  // Provide an object against which the form can bind.
  $scope.newUser = {};

  // Process a form requesting user registration.
  $scope.create = function (form) {
    var clearForm = function clearForm() {
      $scope.newUser = {};
    };

    var handler = user.makeLoginHandler(201, session, $scope, $location, form, messages, clearForm);

    user.create($scope.newUser, handler);
  };
}

// Add the controller to the users module.
angular.module('hbUsers').controller('SignupController', [
// Inject dependencies. Angular:
'$location', '$scope',
// Project (`hb`):
'hbSession', 'hbUser', 'hbMessages',
// Supply the controller.
SignupController]);

},{}],28:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/23/15
 * License:
 * Copyright: 2015
 */

require('./main-content');
require('./use-svg');

},{"./main-content":29,"./use-svg":30}],29:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/23/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

var _angular = angular,
    isDefined = _angular.isDefined,
    isString = _angular.isString;

/**
 * An Angular constructor for the `bible-content` directive.
 * @returns {{}} An Angular definition object.
 * @constructor
 */

function HbMainContent($document, $q, $timeout) {
  function link(scope /*, el, attrs*/) {

    var scrollToPassage = function scrollToPassage(event, args) {
      var passage = args.hasOwnProperty('pathParams') && isDefined(args.pathParams.passage) ? args.pathParams.passage : isString(args) && /\w+\.\d+(\.\d+)?$/.test(args) ? args.split('/').pop() : null;

      if (!passage) {
        // For non-Bible pages, we simply need to make sure we are at the top of
        // the page after load.
        $timeout(function () {
          $document.scrollTop(scope.mobileWebAppOffset);
        }, 0, false);

        return;
      }

      // Scroll to the correct location on the page.
      // Use a timeout to make sure document renders first. Set the timeout
      // value to a tenth of a second to account for the "feature" in Chrome
      // that scrolls the user back to their previous position on the page on
      // a time delay after load.
      var scrollAction = function scrollAction() {
        // If the passage is the first element in a book, just scroll to the
        // top. Otherwise, scroll to the element.
        if (/\.1\.1$/.test(passage)) {
          $document.scrollTopAnimated(0, 500);
        } else {
          var passageID = passage.replace(/\./g, '-');
          var ngEl = angular.element(document.getElementById(passageID));
          var navOffset = document.getElementById('mainnav').offsetHeight;
          var offset = navOffset + scope.mobileWebAppOffset + 12;

          // Depending on event fire sequence, this may not have rendered.
          // Don't try to scroll till it does.
          if (ngEl.length === 0) {
            return;
          }

          $document.scrollToElement(ngEl, offset, 500);
        }
      };

      // Use `$timeout` to guarantee that the browser has rendered before trying
      // to scroll. Do it after 100ms to (hope) that fonts have rendered, too.
      $timeout(scrollAction, 100, false);
    };

    scope.$on('$locationChangeSuccess', scrollToPassage);
    scope.$on('$routeChangeSuccess', scrollToPassage);

    var showLoadingIndicator = function showLoadingIndicator() /*event*/{
      scope.loadingPromise = $q.defer();
    };

    var endLoadingIndicator = function endLoadingIndicator() /*event*/{
      if (scope.loadingPromise) {
        scope.loadingPromise.resolve();
      }
    };

    scope.$on('$routeChangeStart', showLoadingIndicator);
    scope.$on('$routeChangeSuccess', endLoadingIndicator);
    scope.$on('$routeChangeError', endLoadingIndicator);
  }

  return {
    link: link,
    restrict: 'A' // Only allow attribute usage.
  };
}

// Construct the directive and bind it to the `app` module.
angular.module('app').directive('hbMainContent', [
// Inject dependencies. AngularJS:
'$document', '$q', '$timeout',
// Supply the directive.
HbMainContent]);

},{}],30:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/9/14
 * License: All rights reserved.
 * Copyright: 2014 Puritan Reformed Theological Seminary
 */

function usesvg() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: { useid: '@' },
    templateNamespace: 'svg',
    template: '<use xlink:href=""/>',
    link: function link(scope, use, attrs) {
      use.attr('xlink:href', '#' + attrs.useid);
    }
  };
}

// Define a transclusion for SVG <use> elements
angular.module('app').directive('usesvg', [usesvg]);

},{}],31:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/9/14
 * License:
 * Copyright: 2014
 */

// Define a simple filter to output trusted data -- thus, avoiding the need to
// call `$sce.trustAsHtml` explicitly anywhere it might be relevant.

var trusted = function trusted($sce) {
  return function (val) {
    return $sce.trustAsHtml(val);
  };
};

angular.module('app').filter('trusted', ['$sce', trusted]);

},{}],32:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/9/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

/**
 * Helper function to let us use the method-specific callback to operate on a
 * standard HTTP request error callback signature.
 * @param {Auth~stdCb} callback
 * @returns {Function} A function taking the standard Angular HTTP request
 *     promise signature of `data, status, headers, config`.
 */

var _makeResponseHandler = function _makeResponseHandler(callback) {
  return function (_ref) {
    var data = _ref.data,
        status = _ref.status;
    return callback(status, data);
  };
};

/**
 * Helper function for common HTTP request functionality.
 *
 * @param {string} route
 * @param {string} method
 * @param {Object} data
 * @param {Auth~stdCb} callback
 * @param $http The Angular HTTP service.
 * @returns {Function} A function that runs the relevant HTTP request with
 *     success and error handling bound.
 */
function hbRequest(route, method, data, callback, $http) {
  var cb = callback || angular.noop,
      responseHandler = _makeResponseHandler(cb);

  var req = {
    method: method, data: data,
    url: route,
    withCredentials: true
  };

  $http(req).then(responseHandler).catch(responseHandler);
}

module.exports = hbRequest;

},{}],33:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 2/25/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

function hbAuth(session) {
  /**
   * Check whether the user is authorized for access to a given resource.
   * @param {string|Array} requiredAccess The required access permissions.
   * @returns {boolean} Whether the user has the required permissions.
   */
  function isAuthorized(requiredAccess) {
    // Normalize the access content.
    if (!angular.isArray(requiredAccess)) {
      requiredAccess = [requiredAccess];
    }

    // Some content is available to anyone.
    if (requiredAccess.indexOf('*') !== -1) {
      return true;
    }

    // Otherwise, if the user is not logged in, automatically return.
    if (!session.isAuthenticated()) {
      return false;
    }

    // Make sure the user has the required access permissions.
    for (var a = 0; a < requiredAccess.length; a++) {
      if (session.get().access.indexOf(requiredAccess[a]) === -1) {
        return false;
      }
    }

    return true;
  }

  return { isAuthorized: isAuthorized };
}

angular.module('hbServices').factory('hbAuth', [
// Inject dependencies. AngularJS:
// First-party (`hb`):
'hbSession',
// Supply the constructor:
hbAuth]);

},{}],34:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/16/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

// Define an Angular services module.

angular.module('hbServices', ['ngCookies']);

// The Browserify package includes all modules here. Order matters, because some
// modules depend on others.
require('./auth');
require('./location-metadata');
require('./messages');
require('./sb-access');
require('./session');
require('./route-logging');
require('./user');

},{"./auth":33,"./location-metadata":35,"./messages":36,"./route-logging":37,"./sb-access":38,"./session":39,"./user":40}],35:[function(require,module,exports){
'use strict';
/**
  Author: Chris Krycho
  Contact: chris@krycho.com
  Date: 7/10/15
  License:
  Copyright: 2015
 */

var OUTLINE = require('../components/res/outline');

/** The HolyBible metadata location service.

  @class hbLocationMetadata
  @param $rootScope An Angular `$rootScope` instance.
  @returns {{setPage: setPage, setPassage: setPassage}}
 */
function hbLocationMetadata($rootScope) {
  // Service constants.
  var EVENT_NAME = 'hbLocationMetadataUpdate';
  var ROOT_TITLE = 'HolyBible.com';

  // Helper data for the service.
  var broadcastProto = { meta: {}, passage: {} };
  var blankPassage = { id: null, title: null, chapter: null, verse: null };

  // Service data
  var meta = { title: ROOT_TITLE };
  var passage = {
    current: angular.copy(blankPassage),
    previous: angular.copy(blankPassage)
  };

  // Function prototypes to export.
  /** Get the location metadata.
     @returns {hbLocationMetadata~LocationMeta}
             An object with the location information.
   */
  function get() {
    return { meta: meta, passage: passage };
  }

  /** Set the metadata for a "page".
     @param {object} pageMeta
    @param {string} pageMeta.title The title of the page.
   */
  function setPage(pageMeta) {
    if (!pageMeta) {
      return;
    }

    var broadcast = angular.copy(broadcastProto);
    if (pageMeta.title) {
      meta.title = pageMeta.title;
      if (!meta.title.match(/ – HolyBible\.com/)) {
        meta.title += ' – HolyBible.com';
      }

      broadcast.meta.title = meta.title;
      passage.previous = angular.copy(passage.current);
      passage.current = angular.copy(blankPassage);
    }

    $rootScope.$broadcast(EVENT_NAME, broadcast);
  }

  /** Set the metadata for a "passage".
     @param {object} [passageMeta]
    @param {string} [passageMeta.id] The ID of the book ("gen").
    @param {string|number} [passageMeta.chapter] The chapter of the passage.
    @param {string|number} [passageMeta.chapter] The verse of the passage.
    @fires hbLocationMetadata#hbLocationMetadataUpdate
     @note All the attributes and the object itself are optional, but of course
          no changes will be made and no broadcast emitted
   */
  function setPassage(passageMeta) {
    if (!passageMeta || angular.equals(passageMeta, {})) {
      return;
    }

    // Update the previous passage to the passage current before updating.
    passage.previous = angular.copy(passage.current);

    // Build up the components to change
    var broadcast = angular.copy(broadcastProto);

    if (passageMeta.id) {
      passage.current.id = passageMeta.id;
      passage.current.title = OUTLINE[passage.current.id].title;
      var id = passage.current.id;
      var title = passage.current.title;

      angular.extend(broadcast.passage, { id: id, title: title });
    }

    if (passageMeta.chapter) {
      passage.current.chapter = passageMeta.chapter;
      angular.extend(broadcast.passage, { chapter: passageMeta.chapter });
    }

    if (passageMeta.verse) {
      passage.current.verse = passageMeta.verse;
      angular.extend(broadcast.passage, { verse: passageMeta.verse });
    }

    if (!angular.equals(broadcast, broadcastProto)) {
      var _title = passage.current.title + ' ' + passage.current.chapter + ':' + passage.current.verse + ' - HolyBible.com';

      meta.title = _title;
      angular.extend(broadcast.meta, { title: _title });

      $rootScope.$broadcast(EVENT_NAME, broadcast);
    }
  }

  return { get: get, setPage: setPage, setPassage: setPassage, eventName: EVENT_NAME };
}

angular.module('hbServices').factory('hbLocationMetadata', [
// Inject dependencies. AngularJS:
'$rootScope',
// First party:
// Supply the constructor.
hbLocationMetadata]);

// Document types used in the module.
/** @event hbLocationMetadata#hbLocationMetadataUpdate

  @type {object}

  @property {object} meta              Page metadata
  @property {string} [meta.title]      The new meta title for the page.
  @property {object} passage           The Bible passage.
  @property {string} [passage.title]   The title of the Bible book ("Genesis").
  @property {string} [passage.id]      The ID of the Bible book ("gen").
  @property {string} [passage.chapter] The chapter of the book.
  @property {string} [passage.verse]   The chapter of the book.
 */

/** @typedef {Object} hbLocationMetadata~LocationMeta

  @property {object} meta
            The location's metadata (title, etc.).
  @property {object} passage
            The location information, with `current` and `previous` keys
            specifying corresponding `PassageInfo` data.
  @property {hbLocationMetadata~PassageInfo} passage.current
  @property {hbLocationMetadata~PassageInfo} passage.previous
 */

/** @typedef {object} hbLocationMetadata~PassageInfo

  @property {string} id
  @property {string} title
  @property {string} chapter
  @property {string} verse
 */

},{"../components/res/outline":16}],36:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 2/27/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

/**
 * A simple service to provide a singleton resource for flash messages.
 *
 * @returns {{}} A simple (empty at construction) container object.
 */

function hbMessages() {
  return {};
}

// Construct the service.
angular.module('hbServices').factory('hbMessages', [hbMessages]);

},{}],37:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 2/6/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */
/* eslint-disable angular/log, no-console, no-unused-vars */

function hbRouteLogging($rootScope) {
  var _arguments = arguments;

  var changeStart = $rootScope.$on('$locationChangeStart', function () {
    console.log('Started location change with arguments: ', _arguments);
  });

  var locationChangeSuccess = $rootScope.$on('$locationChangeSuccess', function () {
    console.log('Started location change with arguments: ', _arguments);
  });

  var routeChangeStart = $rootScope.$on('$routeChangeStart', function () {
    console.log('Started route change with arguments: ', _arguments);
  });

  var routeChangeSuccess = $rootScope.$on('$routeChangeSuccess', function () {
    console.log('Started route change with arguments: ', _arguments);
  });

  var routeChangeError = $rootScope.$on('$routeChangeError', function () {
    console.log('Started location change with arguments: ', _arguments);
  });

  $rootScope.$on('$destroy', changeStart);
  $rootScope.$on('$destroy', locationChangeSuccess);
  $rootScope.$on('$destroy', routeChangeStart);
  $rootScope.$on('$destroy', routeChangeSuccess);
  $rootScope.$on('$destroy', routeChangeError);

  return {};
}

angular.module('hbServices').factory('hbRouteLogging', [
// Inject dependencies. Angular:
'$rootScope',
// Supply the service
hbRouteLogging]);

},{}],38:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 1/9/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

var hbRequest = require('./_request');

var API_ROOT = '/r/rhkjvsb';

// Define an Angular controller.
function sbAccess($http) {
  return {
    redeem: function redeem(key, callback) {
      var route = API_ROOT + '/redeem';
      hbRequest(route, 'POST', { key: key }, callback, $http);
    }
  };
}

// Bind the controller to the module.
angular.module('hbServices').factory('hbSbAccess', [
// Inject dependencies. Angular:
'$http',
// Supply the controller function.
sbAccess]);

},{"./_request":32}],39:[function(require,module,exports){
'use strict';
/**
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 3/13/15
 * License: All rights reserved.
 * Copyright: 2015 Puritan Reformed Theological Seminary
 */

var EVENT = 'USER_SESSION_CHANGE';

function hbSession($cookies, $rootScope) {
  // Initialize the session with an empty cache.
  var _session = {};
  var COOKIE_SESSION_NAME = 'hbsession';
  var COOKIE_PATH = '/';

  var sessionService = {
    clear: function clear() {
      _session = {};
      $cookies.remove(COOKIE_SESSION_NAME, { path: COOKIE_PATH });
      $rootScope.$broadcast(EVENT, EVENT);
    },


    /**
     * Get the user information.
     * @returns {{}|null} The session data, if the session is set; otherwise null.
     */
    get: function get() {
      // Check whether session data exists in the application state or a cookie.
      var cookieSession = $cookies.getObject(COOKIE_SESSION_NAME);

      if (angular.equals(_session, {})) {
        if (angular.equals(cookieSession, {}) || !cookieSession) {
          return null;
        } else {
          angular.copy(cookieSession, _session);
        }
      }

      return _session;
    },


    /**
     * @return {Boolean}
     */
    isAuthenticated: function isAuthenticated() {
      // Prime the session.
      sessionService.get();

      var authenticated = angular.isDefined(_session.user) && angular.isDefined(_session.user.name) && angular.isDefined(_session.user.confirmed) && angular.isDefined(_session.access);

      return authenticated;
    },


    /**
     * @param {{}} sessOpts
     * @param {{}} sessOpts.user
     * @param {string} sessOpts.user.name
     * @param {boolean} sessOpts.user.confirmed
     * @param {{}} sessOpts.user.access An object describing user access, keyed by
     */
    set: function set(sessOpts) {
      if (!sessOpts) {
        throw new Error('Cannot call hbSession.set without `sessOpts` parameter.');
      }

      angular.copy(sessOpts, _session);

      var month = 30 * 24 * 60 * 60 * 1000;
      var expiration = new Date(+new Date() + month);
      var config = { expires: expiration, path: COOKIE_PATH };

      $cookies.putObject(COOKIE_SESSION_NAME, _session, config);
      $rootScope.$broadcast(EVENT, EVENT);
    },


    EVENT: EVENT
  };

  return sessionService;
}

angular.module('hbServices').factory('hbSession', [
// Inject dependencies. AngularJS:
'$cookies', '$rootScope',
// First-party:
// Supply the constructor
hbSession]);

},{}],40:[function(require,module,exports){
'use strict';
/**
 * Angular authentication module.
 *
 * Author: Chris Krycho
 * Contact: chris@krycho.com
 * Date: 12/10/14
 * License: All rights reserved.
 * Copyright: 2014 Puritan Reformed Theological Seminary
 */

var hbRequest = require('./_request');

var API_ROOT = '/u';
var HOME = '/';
var PROFILE = '/user/profile';

// Define the authentication service.
function hbUser($http, $location, session) {

  // Supply default post-logout behavior of just returning home. If the user has
  // provided their own behavior, use that instead.
  function withDefaultAfter(callback) {
    function defaultAfter() {
      session.clear();
      $location.path(HOME);
    }

    return callback && angular.isFunction(callback) ? callback : defaultAfter;
  }

  return {
    create: function create(user, afterCreate) {
      var route = API_ROOT + '/create';
      return hbRequest(route, 'POST', user, afterCreate, $http);
    },
    destroy: function destroy(user, afterDestroy) {
      var route = API_ROOT + '/destroy';
      return hbRequest(route, 'DELETE', user, withDefaultAfter(afterDestroy), $http);
    },
    forgot: function forgot(user, afterForgot) {
      var route = API_ROOT + '/forgot-password';
      return hbRequest(route, 'POST', user, afterForgot, $http);
    },
    login: function login(user, afterLogin) {
      var route = API_ROOT + '/login';
      return hbRequest(route, 'POST', user, afterLogin, $http);
    },
    logout: function logout(afterLogout) {
      var route = API_ROOT + '/logout';
      hbRequest(route, 'POST', {}, withDefaultAfter(afterLogout), $http);
    },
    reset: function reset(user, callback) {
      var route = API_ROOT + '/password-reset';
      hbRequest(route, 'PUT', user, callback, $http);
    },
    resendConfirmation: function resendConfirmation(user, callback) {
      var route = API_ROOT + '/resend-confirmation';
      hbRequest(route, 'POST', user, callback, $http);
    },
    update: function update(user, callback) {
      // TODO: this should probably error, but for backwards compatibility it
      //       is left as is for the present.
      var configured = user.username || user.password && user.confirm;
      if (!configured) return;

      var subroute = user.username ? 'username-change' : 'password-change';
      var route = API_ROOT + '/' + subroute;
      hbRequest(route, 'PUT', user, callback, $http);
    },


    /**
      Make a function to process a login callback from `hbUser`.
       @param {number} [acceptableStatus] The acceptable status code. If left
          empty, no status code checking is done.
      @param session The hbSession service.
      @param $scope The Angular scope bound to the view.
      @param $location An Angular location.
      @param form An ngForm to reset, and with which to associate error messages.
      @param messages hbMessages instance for "flash"-style messages
      @param clearForm
      @returns {Users~loginHandlerCallback} A function
     */
    makeLoginHandler: function makeLoginHandler(acceptableStatus, session, $scope, $location, form, messages, clearForm) {
      /**
        @callback Users~loginHandlerCallback
        @param {Object} data The data returned by the API.
        @param {string} data.username The username returned by the API.
        @param {boolean} data.confirmed Whether the username is confirmed, as
            returned by the API.
        @param {number} data.status The status code returned by the API.
       */
      return function (status, data) {
        // Account for failures in the login action based on the API response.
        var invalidForm = angular.isDefined(acceptableStatus) && status !== acceptableStatus || angular.isUndefined(data) || angular.isUndefined(data.user) || angular.isUndefined(data.user.username) || angular.isUndefined(data.user.confirmed);

        if (invalidForm) {
          $scope.invalidForm = true;

          messages.authentication = data.reason ? data.reason : 'The username and password submitted were not valid.';

          form.$setPristine();
          clearForm();
          return;
        }

        // If there are no errors, store the data in the session.
        var sessOpts = {
          user: {
            name: data.user.username,
            confirmed: data.user.confirmed
          },
          access: ['user']
        };

        if (data.user.sb && data.user.sb.hasAccess) {
          sessOpts.access.push('kjvsb');
        }
        session.set(sessOpts);

        // Then go to the user's profile page.
        // TODO: go where the user requested, instead, when using a popup.
        $location.path(PROFILE);
      };
    },


    API_ROOT: API_ROOT
  };
}

// Callback documentation.
/**
 * @callback Auth~stdCb
 * @param {number} status The status code returned by the called API.
 * @param {*} data Any data returned by the called API with the status code.
 */

// Define an authentication service for the application.
angular.module('hbServices').factory('hbUser', [
// Inject dependencies. AngularJS:
'$http', '$location',
// Project (`hb`):
'hbSession', hbUser]);

},{"./_request":32}]},{},[2])

